{
  "id": "navrules",
  "title": "Navigation Rules, amalgamated: International (72 COLREGS) and U.S. Inland (33 CFR 83)",
  "url": "https://www.navcen.uscg.gov/navigation-rules-amalgamated",
  "retrieved": "2026-09-19",
  "license": "US Government Work, gemeinfrei (17 U.S.C. 105)",
  "rules": {
    "1": {
      "number": 1,
      "title": "Application",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) These Rules shall apply to all vessels upon the high seas and in all waters connected therewith navigable by seagoing vessels.",
          "inland": "(a) These Rules shall apply to all vessels upon the inland waters of the United States, and to vessels of the United States on the Canadian waters of the Great Lakes to the extent that there is no conflict with Canadian law."
        },
        {
          "id": "b",
          "scope": "international",
          "international": "(b) Nothing in these Rules shall interfere with the operation of special rules made by an appropriate authority for roadsteads, harbors, rivers, lakes, or inland waterways connected with the high seas and navigable by seagoing vessels. Such special rules shall conform as closely as possible to these Rules.",
          "inland": ""
        },
        {
          "id": "b(i)",
          "scope": "inland",
          "international": "",
          "inland": "(b)(i)These rules constitute special rules made by an appropriate authority within the meaning of Rule 1(b) of the International Regulations for Preventing Collisions at Sea, 1972, including annexes currently in force for the United States (“International Regulations”)."
        },
        {
          "id": "b(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) All vessels complying with the construction and equipment requirements of the International Regulations are considered to be in compliance with these Rules."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) Nothing in these Rules shall interfere with the operation of any special rules made by the Government of any State with respect to special rules with respect to additional station and signal lights and shapes or whistle signals for ships of war and vessels proceeding under convoy, or with respect to additional station or signal lights or shapes for fishing vessels engaged in fishing as a fleet. These additional stations or signal lights, shapes or whistle signals shall, so far as possible, be such that they cannot be mistaken for any light, shape, or signal authorized elsewhere under these Rules..",
          "inland": "(c) Nothing in these Rules shall interfere with the operation of any special rules made by the Secretary of the Navy with respect to special rules with respect to additional station and signal lights and shapes or whistle signals for ships of war and vessels proceeding under convoy, or by the Secretary with respect to additional station or signal lights or shapes for fishing vessels engaged in fishing as a fleet. These additional stations or signal lights, shapes or whistle signals shall, so far as possible, be such that they cannot be mistaken for any light, shape, or signal authorized elsewhere under these Rules. Notice of such special rules shall be published in the Federal Register and, after the effective date specified in such notice, they shall have effect as if they were a part of these Rules."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) Traffic separation schemes may be adopted by the Organization for the purposes of these Rules..",
          "inland": "(d) Traffic separation schemes may be established for the purposes of these Rules. Vessel traffic service regulations may be in effect in certain areas."
        },
        {
          "id": "e",
          "scope": "international",
          "international": "(e) Whenever the Government concerned shall have determined that a vessel of special construction or purpose cannot comply fully with the provisions of any of these Rules with respect to number, position, range or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, such vessel shall comply with such other provisions in regard to number, position, range or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, as the Government shall have determined to be the closest possible compliance with these Rules in respect to that vessel.",
          "inland": ""
        },
        {
          "id": "e",
          "scope": "inland",
          "international": "",
          "inland": "(e) Whenever the Secretary determines that a vessel or class of vessels of special construction or purpose cannot comply fully with the provisions of any of these Rules with respect to the number, position, range, or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, the vessel shall comply with such other provisions in regard to the number, position, range, or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, as the Secretary shall have determined to be the closest possible compliance with these Rules. The Secretary may issue a certificate of alternative compliance for a vessel or class of vessels specifying the closest possible compliance with these Rules. The Secretary of the Navy shall make these determinations and issue certificates of alternative compliance for vessels of the Navy."
        },
        {
          "id": "f",
          "scope": "inland",
          "international": "",
          "inland": "(f) The Secretary may accept a certificate of alternative compliance issued by a contracting party to the International Regulations if it determines that the alternative compliance standards of the contracting party are substantially the same as those of the United States."
        },
        {
          "id": "g",
          "scope": "inland",
          "international": "",
          "inland": "(g) The operator of each self-propelled vessel 12 meters or more in length shall carry, on board and maintain for ready reference, a copy of these Rules. {This Amalgamation or similar facsimiles of the Navigation Rules, such as those published by the United States Coast Pilot®, maybe used to meet the 'copy of these Rules' requirement of Inland Navigation Rule 1(g)/33 CFR 83.01(g). For the USCG policy on the use of electronic charts and publications to meet U.S. carriage requirements see the USCG Navigation and Vessel Inspection Circular 01-16 CH-2.}."
        },
        {
          "id": "b1:a",
          "scope": "both",
          "international": "(a) The International Regulations do not apply to vessels while in the waters of the United States shoreward of the navigational demarcation lines {30 CFR 80} dividing the high seas from harbors, rivers, and other inland waters of the United States.",
          "inland": "(a) The International Regulations do not apply to vessels while in the waters of the United States shoreward of the navigational demarcation lines {30 CFR 80} dividing the high seas from harbors, rivers, and other inland waters of the United States."
        },
        {
          "id": "b1:b",
          "scope": "both",
          "international": "(b) Whenever a vessel subject to the jurisdiction of the United States is in the territorial waters of a foreign state the International Regulations shall be applicable to, and shall be complied with by, that vessel to the extent that the laws and regulations of the foreign state are not in conflict there with.",
          "inland": "(b) Whenever a vessel subject to the jurisdiction of the United States is in the territorial waters of a foreign state the International Regulations shall be applicable to, and shall be complied with by, that vessel to the extent that the laws and regulations of the foreign state are not in conflict there with."
        }
      ]
    },
    "2": {
      "number": 2,
      "title": "Responsibility",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) Nothing in these Rules shall exonerate any vessel, or the owner, master, or crew thereof, from the consequences of any neglect to comply with these Rules or of the neglect of any precaution which may be required by the ordinary practice of seamen, or by the special circumstances of the case.",
          "inland": "(a) Nothing in these Rules shall exonerate any vessel, or the owner, master, or crew thereof, from the consequences of any neglect to comply with these Rules or of the neglect of any precaution which may be required by the ordinary practice of seamen, or by the special circumstances of the case."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) In construing and complying with these Rules due regard shall be had to all dangers of navigation and collision and to any special circumstances, including the limitations of the vessels involved, which may make a departure from these Rules necessary to avoid immediate danger.",
          "inland": "(b) In construing and complying with these Rules due regard shall be had to all dangers of navigation and collision and to any special circumstances, including the limitations of the vessels involved, which may make a departure from these Rules necessary to avoid immediate danger."
        }
      ]
    },
    "3": {
      "number": 3,
      "title": "General Definitions.",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "For the purpose of these Rules, except where the context otherwise requires:",
          "inland": "For the purpose of these Rules, except where the context otherwise requires:"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) The word \"vessel\" includes every description of watercraft, including non-displacement craft, WIG craft, and seaplanes, used or capable of being used as a means of transportation on water.",
          "inland": "(a) The word \"vessel\" includes every description of watercraft, including non-displacement craft, WIG craft, and seaplanes, used or capable of being used as a means of transportation on water."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) The term \"power-driven vessel\" means any vessel propelled by machinery.",
          "inland": "(b) The term \"power-driven vessel\" means any vessel propelled by machinery."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) The term \"sailing vessel\" means any vessel under sail provided that propelling machinery, if fitted, is not being used.",
          "inland": "(c) The term \"sailing vessel\" means any vessel under sail provided that propelling machinery, if fitted, is not being used."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) The term \"vessel engaged in fishing\" means any vessel fishing with nets, lines, trawls, or other fishing apparatus which restrict maneuverability, but does not include a vessel fishing with trolling lines or other fishing apparatus which do not restrict maneuverability.",
          "inland": "(d) The term \"vessel engaged in fishing\" means any vessel fishing with nets, lines, trawls, or other fishing apparatus which restrict maneuverability, but does not include a vessel fishing with trolling lines or other fishing apparatus which do not restrict maneuverability."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) The term \"seaplane\" includes any aircraft designed to maneuver on the water.",
          "inland": "(e) The term \"seaplane\" includes any aircraft designed to maneuver on the water."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) The term \"vessel not under command\" means a vessel which through some exceptional circumstance is unable to maneuver as required by these Rules and is therefore unable to keep out of the way of another vessel.",
          "inland": "(f) The term \"vessel not under command\" means a vessel which through some exceptional circumstance is unable to maneuver as required by these Rules and is therefore unable to keep out of the way of another vessel."
        },
        {
          "id": "g",
          "scope": "both",
          "international": "(g) The term \"vessel restricted in her ability to maneuver\" means a vessel which from the nature of her work is restricted in her ability to maneuver as required by these Rules and is, therefore, unable to keep out of the way of another vessel. The term \"vessels restricted in their ability to maneuver\" shall include but not be limited to:",
          "inland": "(g) The term \"vessel restricted in her ability to maneuver\" means a vessel which from the nature of her work is restricted in her ability to maneuver as required by these Rules and is, therefore, unable to keep out of the way of another vessel. The term \"vessels restricted in their ability to maneuver\" shall include but not be limited to:"
        },
        {
          "id": "g(i)",
          "scope": "both",
          "international": "(i) A vessel engaged in laying, servicing, or picking up a navigational mark, submarine cable or pipeline",
          "inland": "(i) A vessel engaged in laying, servicing, or picking up a navigational mark, submarine cable or pipeline"
        },
        {
          "id": "g(ii)",
          "scope": "both",
          "international": "(ii) A vessel engaged in dredging, surveying or underwater operations;",
          "inland": "(ii) A vessel engaged in dredging, surveying or underwater operations;"
        },
        {
          "id": "g(iii)",
          "scope": "both",
          "international": "(iii) A vessel engaged in replenishment or transferring persons, provisions or cargo while underway;",
          "inland": "(iii) A vessel engaged in replenishment or transferring persons, provisions or cargo while underway;"
        },
        {
          "id": "g(iv)",
          "scope": "both",
          "international": "(iv) A vessel engaged in the launching or recovery of aircraft;",
          "inland": "(iv) A vessel engaged in the launching or recovery of aircraft;"
        },
        {
          "id": "g(v)",
          "scope": "both",
          "international": "(v) A vessel engaged in mine clearance operations;",
          "inland": "(v) A vessel engaged in mine clearance operations;"
        },
        {
          "id": "g(vi)",
          "scope": "both",
          "international": "(vi) A vessel engaged in a towing operation such as severely restricts the towing vessel and her tow in their ability to deviate from their course.",
          "inland": "(vi) A vessel engaged in a towing operation such as severely restricts the towing vessel and her tow in their ability to deviate from their course. Reserved"
        },
        {
          "id": "h",
          "scope": "international",
          "international": "(h) The term \"vessel constrained by her draft\" means a power-driven vessel which because of her draft in relation to the available depth and width of navigable water is severely restricted in her ability to deviate from the course she is following.",
          "inland": ""
        },
        {
          "id": "i",
          "scope": "both",
          "international": "(i) The word \"underway\" means that a vessel is not at anchor, or made fast to the shore, or aground.",
          "inland": "(i) The word \"underway\" means that a vessel is not at anchor, or made fast to the shore, or aground."
        },
        {
          "id": "j",
          "scope": "both",
          "international": "(j) The words \"length\" and \"breadth\" of a vessel mean her length overall and greatest breadth.",
          "inland": "(j) The words \"length\" and \"breadth\" of a vessel mean her length overall and greatest breadth."
        },
        {
          "id": "k",
          "scope": "both",
          "international": "(k) Vessels shall be deemed to be in sight of one another only when one can be observed visually from the other.",
          "inland": "(k) Vessels shall be deemed to be in sight of one another only when one can be observed visually from the other."
        },
        {
          "id": "l",
          "scope": "both",
          "international": "(l) The term “restricted visibility” means any condition in which visibility is restricted by fog, mist, falling snow, heavy rainstorms, sandstorms, or any other similar causes.",
          "inland": "(l) The term “restricted visibility” means any condition in which visibility is restricted by fog, mist, falling snow, heavy rainstorms, sandstorms, or any other similar causes."
        },
        {
          "id": "m",
          "scope": "both",
          "international": "(m) The term “Wing-In-Ground (WIG)” craft means a multimodal craft which, in its main operational mode, flies in close proximity to the surface by utilizing surface-effect action.",
          "inland": "(m) The term “Wing-In-Ground (WIG)” craft means a multimodal craft which, in its main operational mode, flies in close proximity to the surface by utilizing surface-effect action."
        },
        {
          "id": "n",
          "scope": "inland",
          "international": "",
          "inland": "(n) \"Western Rivers\" means the Mississippi River, its tributaries, South Pass, and Southwest Pass, to the navigational demarcation lines {30 CFR 80} dividing the high seas from harbors, rivers and other inland waters of the United States, and the Port Allen-Morgan City Alternate Route, and that part of the Atchafalaya River above its junction with the Port Allen-Morgan City Alternate Route including the Old River and the Red River."
        },
        {
          "id": "o",
          "scope": "inland",
          "international": "",
          "inland": "(o) \"Great Lakes\" means the Great Lakes and their connecting tributary waters including the Calumet River as far as the Thomas J. O'Brien Lock and Controlling Waters (between mile 326 and 327), the Chicago River as far as the east side of the Ashland Avenue Bridge (between mile 321 and 322), and the Saint Lawrence River as far east as the lower exit of Saint Lambert Lock."
        },
        {
          "id": "p",
          "scope": "inland",
          "international": "",
          "inland": "(p) \"Secretary\" means the Secretary of the Department in which the Coast Guard is operating."
        },
        {
          "id": "q",
          "scope": "inland",
          "international": "",
          "inland": "(q) \"Inland Waters\" means the navigable waters of the United States shoreward of the navigational demarcation lines {30 CFR 80}dividing the high seas from harbors, rivers and other inland waters of the United States and the waters of the Great Lakes on the United States side of the International Boundary."
        },
        {
          "id": "r",
          "scope": "inland",
          "international": "",
          "inland": "(r) Inland Rules or Rules means these Inland Navigational Rules and the annexes thereto, which govern the conduct of vessels and specify the lights, shapes, and sound signals that apply on inland waters."
        },
        {
          "id": "s",
          "scope": "inland",
          "international": "",
          "inland": "(s) International Regulations means the International Regulations for Preventing Collisions at Sea, 1972, including annexes currently in force for the United States."
        }
      ]
    },
    "4": {
      "number": 4,
      "title": "Application",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Rules 4-10 apply in any condition of visibility.",
          "inland": "Rules 4-10 apply in any condition of visibility."
        }
      ]
    },
    "5": {
      "number": 5,
      "title": "Lookout",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Every vessel shall at all times maintain a proper look-out by sight and hearing as well as by all available means appropriate in the prevailing circumstances and conditions so as to make a full appraisal of the situation and of the risk of collision.",
          "inland": "Every vessel shall at all times maintain a proper look-out by sight and hearing as well as by all available means appropriate in the prevailing circumstances and conditions so as to make a full appraisal of the situation and of the risk of collision."
        }
      ]
    },
    "6": {
      "number": 6,
      "title": "Safe Speed",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Every vessel shall at all times proceed at a safe speed so that she can take proper and effective action to avoid collision and be stopped within a distance appropriate to the prevailing circumstances and conditions. In determining a safe speed the following factors shall be among those taken into account:",
          "inland": "Every vessel shall at all times proceed at a safe speed so that she can take proper and effective action to avoid collision and be stopped within a distance appropriate to the prevailing circumstances and conditions. In determining a safe speed the following factors shall be among those taken into account:"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) By all vessels:",
          "inland": "(a) By all vessels:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) The state of visibility;",
          "inland": "(i) The state of visibility;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) The traffic density including concentrations of fishing vessels or any other vessels;",
          "inland": "(ii) The traffic density including concentrations of fishing vessels or any other vessels;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) The maneuverability of the vessel with special reference to stopping distance and turning ability in the prevailing conditions;",
          "inland": "(iii) The maneuverability of the vessel with special reference to stopping distance and turning ability in the prevailing conditions;"
        },
        {
          "id": "a(iv)",
          "scope": "both",
          "international": "(iv) At night, the presence of background light such as from shore lights or from back scatter from her own lights;",
          "inland": "(iv) At night, the presence of background light such as from shore lights or from back scatter from her own lights;"
        },
        {
          "id": "a(v)",
          "scope": "both",
          "international": "(v) The state of wind, sea and current, and the proximity of navigational hazards;",
          "inland": "(v) The state of wind, sea and current, and the proximity of navigational hazards;"
        },
        {
          "id": "a(vi)",
          "scope": "both",
          "international": "(vi) The draft in relation to the available depth of water.",
          "inland": "(vi) The draft in relation to the available depth of water."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Additionally, by vessels with operational radar:",
          "inland": "(b) Additionally, by vessels with operational radar:"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) The characteristics, efficiency and limitations of the radar equipment;",
          "inland": "(i) The characteristics, efficiency and limitations of the radar equipment;"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) Any constraints imposed by the radar range scale in use;",
          "inland": "(ii) Any constraints imposed by the radar range scale in use;"
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) The effect on radar detection of the sea state, weather and other sources of interference;",
          "inland": "(iii) The effect on radar detection of the sea state, weather and other sources of interference;"
        },
        {
          "id": "b(iv)",
          "scope": "both",
          "international": "(iv) The possibility that small vessels, ice and other floating objects may not be detected by radar at an adequate range;",
          "inland": "(iv) The possibility that small vessels, ice and other floating objects may not be detected by radar at an adequate range;"
        },
        {
          "id": "b(v)",
          "scope": "both",
          "international": "(v) The number, location and movement of vessels detected by radar;",
          "inland": "(v) The number, location and movement of vessels detected by radar;"
        },
        {
          "id": "b(vi)",
          "scope": "both",
          "international": "(vi) The more exact assessment of the visibility that may be possible when radar is used to determine the range of vessels or other objects in the vicinity.",
          "inland": "(vi) The more exact assessment of the visibility that may be possible when radar is used to determine the range of vessels or other objects in the vicinity."
        }
      ]
    },
    "7": {
      "number": 7,
      "title": "Risk of Collision",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) Every vessel shall use all available means appropriate to the prevailing circumstances and conditions to determine if risk of collision exists. If there is any doubt such risk shall be deemed to exist.",
          "inland": "(a) Every vessel shall use all available means appropriate to the prevailing circumstances and conditions to determine if risk of collision exists. If there is any doubt such risk shall be deemed to exist."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Proper use shall be made of radar equipment if fitted and operational, including long-range scanning to obtain early warning of risk of collision and radar plotting or equivalent systematic observation of detected objects.",
          "inland": "(b) Proper use shall be made of radar equipment if fitted and operational, including long-range scanning to obtain early warning of risk of collision and radar plotting or equivalent systematic observation of detected objects."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) Assumptions shall not be made on the basis of scanty information, especially scanty radar information.",
          "inland": "(c) Assumptions shall not be made on the basis of scanty information, especially scanty radar information."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) In determining if risk of collision exists the following considerations shall be among those taken into account:",
          "inland": "(d) In determining if risk of collision exists the following considerations shall be among those taken into account:"
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(i) Such risk shall be deemed to exist if the compass bearing of an approaching vessel does not appreciably change.",
          "inland": "(i) Such risk shall be deemed to exist if the compass bearing of an approaching vessel does not appreciably change."
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) Such risk may sometimes exist even when an appreciable bearing change is evident, particularly when approaching a very large vessel or a tow or when approaching a vessel at close range.",
          "inland": "(ii) Such risk may sometimes exist even when an appreciable bearing change is evident, particularly when approaching a very large vessel or a tow or when approaching a vessel at close range."
        }
      ]
    },
    "8": {
      "number": 8,
      "title": "Action to Avoid Collision",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) Any action taken to avoid collision shall be taken in accordance with Rules 4-19, and shall if the circumstances of the case admit, be positive, made in ample time and with due regard to the observance of good seamanship.",
          "inland": "(a) Any action taken to avoid collision shall be taken in accordance with Rules 4-19, and shall if the circumstances of the case admit, be positive, made in ample time and with due regard to the observance of good seamanship."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Any alteration of course and/or speed to avoid collision shall, if the circumstances of the case admit, be large enough to be readily apparent to another vessel observing visually or by radar; a succession of small alterations of course and/or speed should be avoided.",
          "inland": "(b) Any alteration of course and/or speed to avoid collision shall, if the circumstances of the case admit, be large enough to be readily apparent to another vessel observing visually or by radar; a succession of small alterations of course and/or speed should be avoided."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) If there is sufficient sea room, alteration of course alone may be the most effective action to avoid a close-quarters situation provided that it is made in good time, is substantial and does not result in another close-quarters situation.",
          "inland": "(c) If there is sufficient sea room, alteration of course alone may be the most effective action to avoid a close-quarters situation provided that it is made in good time, is substantial and does not result in another close-quarters situation."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) Action taken to avoid collision with another vessel shall be such as to result in passing at a safe distance. The effectiveness of the action shall be carefully checked until the other vessel is finally past and clear.",
          "inland": "(d) Action taken to avoid collision with another vessel shall be such as to result in passing at a safe distance. The effectiveness of the action shall be carefully checked until the other vessel is finally past and clear."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) If necessary to avoid collision or allow more time to assess the situation, a vessel shall slacken her speed or take all way off by stopping or reversing her means of propulsion.",
          "inland": "(e) If necessary to avoid collision or allow more time to assess the situation, a vessel shall slacken her speed or take all way off by stopping or reversing her means of propulsion."
        },
        {
          "id": "f(i)",
          "scope": "both",
          "international": "(f)(i) A vessel which, by any of these Rules, is required not to impede the passage or safe passage of another vessel shall, when required by the circumstances of the case, take early action to allow sufficient sea room for the safe passage of the other vessel.",
          "inland": "(f)(i) A vessel which, by any of these Rules, is required not to impede the passage or safe passage of another vessel shall, when required by the circumstances of the case, take early action to allow sufficient sea room for the safe passage of the other vessel."
        },
        {
          "id": "f(ii)",
          "scope": "both",
          "international": "(ii) A vessel required not to impede the passage or safe passage of another vessel is not relieved of this obligation if approaching the other vessel so as to involve risk of collision and shall, when taking action, have full regard to the action which may be required by Rules 4-19.",
          "inland": "(ii) A vessel required not to impede the passage or safe passage of another vessel is not relieved of this obligation if approaching the other vessel so as to involve risk of collision and shall, when taking action, have full regard to the action which may be required by Rules 4-19."
        },
        {
          "id": "f(iii)",
          "scope": "both",
          "international": "(iii) A vessel, the passage of which is not to be impeded remains fully obliged to comply with Rules 4-19 when the two vessels are approaching one another so as to involve risk of collision.",
          "inland": "(iii) A vessel, the passage of which is not to be impeded remains fully obliged to comply with Rules 4-19 when the two vessels are approaching one another so as to involve risk of collision."
        }
      ]
    },
    "9": {
      "number": 9,
      "title": "Narrow Channels",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel proceeding along the course of a narrow channel or fairway shall keep as near to the outer limit of the channel or fairway which lies on her starboard side as is safe and practicable.",
          "inland": "(a)(i) A vessel proceeding along the course of a narrow channel or fairway shall keep as near to the outer limit of the channel or fairway which lies on her starboard side as is safe and practicable."
        },
        {
          "id": "a(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) Notwithstanding Rule 9(a)(i) and Rule 14(a), a power-driven vessel operating in a narrow channel or fairway on the Great Lakes, Western Rivers, or waters specified by the Secretary, and proceeding downbound with the following current shall have the right-of-way over an upbound vessel, shall propose the manner and place of passage, and shall initiate the maneuvering signals prescribed by Rule 34(a)(i), as appropriate. The vessel proceeding upbound against the current shall hold as necessary to permit safe passing."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel of less than 20 meters in length or a sailing vessel shall not impede the passage of a vessel which can safely navigate only within a narrow channel or fairway.",
          "inland": "(b) A vessel of less than 20 meters in length or a sailing vessel shall not impede the passage of a vessel that can safely navigate only within a narrow channel or fairway."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel engaged in fishing shall not impede the passage of any other vessel navigating within a narrow channel or fairway.",
          "inland": "(c) A vessel engaged in fishing shall not impede the passage of any other vessel navigating within a narrow channel or fairway."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) A vessel shall not cross a narrow channel or fairway if such crossing impedes the passage of a vessel which can safely navigate only within that channel or fairway. The latter vessel may use the signal prescribed in Rule 34(d) if in doubt as to the intention of the crossing vessel.",
          "inland": "(d) A vessel must not cross a narrow channel or fairway if such crossing impedes the passage of a vessel which can safely navigate only within that channel or fairway. The latter vessel must use the signal prescribed in Rule 34(d) if in doubt as to the intention of the crossing vessel."
        },
        {
          "id": "e(i)",
          "scope": "international",
          "international": "(e)(i) In a narrow channel or fairway when overtaking can take place only if the vessel to be overtaken has to take action to permit safe passing, the vessel intending to overtake shall indicate her intention by sounding the appropriate signal prescribed in Rule 34(c)(i). The vessel to be overtaken shall, if in agreement, sound the appropriate signal prescribed in Rule 34(c)(ii) and take steps to permit safe passing. If in doubt she may sound the signals prescribed in Rule 34(d).",
          "inland": ""
        },
        {
          "id": "i",
          "scope": "inland",
          "international": "",
          "inland": "(i) In a narrow channel or fairway when overtaking, the power-driven vessel intending to overtake another power-driven vessel shall indicate her intention by sounding the appropriate signal prescribed in Rule 34(c) and take steps to permit safe passing. The power-driven vessel being overtaken, if in agreement, shall sound the same signal and may, if specifically agreed to, take steps to permit safe passing. If in doubt she shall sound the signal prescribed in Rule 34(d)."
        },
        {
          "id": "b1:e(ii)",
          "scope": "both",
          "international": "(e)(ii) This rule does not relieve the overtaking vessel of her obligation under Rule 13.",
          "inland": "(e)(ii) This rule does not relieve the overtaking vessel of her obligation under Rule 13."
        },
        {
          "id": "b1:f",
          "scope": "both",
          "international": "(f) A vessel nearing a bend or an area of a narrow channel or fairway where other vessels may be obscured by an intervening obstruction shall navigate with particular alertness and caution and shall sound the appropriate signal prescribed in Rule 34(e).",
          "inland": "(f) A vessel nearing a bend or an area of a narrow channel or fairway where other vessels may be obscured by an intervening obstruction shall navigate with particular alertness and caution and shall sound the appropriate signal prescribed in Rule 34(e)."
        },
        {
          "id": "b1:g",
          "scope": "both",
          "international": "(g) Any vessel shall, if the circumstances of the case admit, avoid anchoring in a narrow channel.",
          "inland": "(g) Any vessel shall, if the circumstances of the case admit, avoid anchoring in a narrow channel."
        }
      ]
    },
    "10": {
      "number": 10,
      "title": "Traffic Separation Schemes",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) This Rule applies to traffic separation schemes adopted by the Organization and does not relieve any vessel of her obligation under any other rule.",
          "inland": "(a) This Rule applies to traffic separation schemes and does not relieve any vessel of her obligation under any other rule."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel using a traffic separation scheme shall:",
          "inland": "(b) A vessel using a traffic separation scheme shall:"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) Proceed in the appropriate traffic lane in the general direction of traffic flow for that lane.",
          "inland": "(i) Proceed in the appropriate traffic lane in the general direction of traffic flow for that lane."
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) So far as is practicable keep clear of a traffic separation line or separation zone.",
          "inland": "(ii) So far as is practicable keep clear of a traffic separation line or separation zone."
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) Normally join or leave a traffic lane at the termination of the lane, but when joining or leaving from either side shall do so at as small an angle to the general direction of traffic flow as practicable.",
          "inland": "(iii) Normally join or leave a traffic lane at the termination of the lane, but when joining or leaving from either side shall do so at as small an angle to the general direction of traffic flow as practicable."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel, shall so far as practicable, avoid crossing traffic lanes but if obliged to do so shall cross on a heading as nearly as practicable at right angles to the general direction of traffic flow.",
          "inland": "(c) A vessel, shall so far as practicable, avoid crossing traffic lanes but if obliged to do so shall cross on a heading as nearly as practicable at right angles to the general direction of traffic flow."
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(d)(i) A vessel shall not use an inshore traffic zone when she can safely use the appropriate traffic lane within the adjacent traffic separation scheme. However, vessels of less than 20 meters in length, sailing vessels and vessels engaged in fishing may use the inshore traffic zone.",
          "inland": "(d)(i) A vessel shall not use an inshore traffic zone when she can safely use the appropriate traffic lane within the adjacent traffic separation scheme. However, vessels of less than 20 meters in length, sailing vessels and vessels engaged in fishing may use the inshore traffic zone."
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) Notwithstanding Rule 10(d)(i), a vessel may use an inshore traffic zone when en route to or from a port, offshore installation or structure, pilot station or any other place situated within the inshore traffic zone, or to avoid immediate danger.",
          "inland": "(ii) Notwithstanding Rule 10(d)(i), a vessel may use an inshore traffic zone when en route to or from a port, offshore installation or structure, pilot station or any other place situated within the inshore traffic zone, or to avoid immediate danger."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel, other than a crossing vessel or a vessel joining or leaving a lane shall not normally enter a separation zone or cross a separation line except:",
          "inland": "(e) A vessel, other than a crossing vessel or a vessel joining or leaving a lane shall not normally enter a separation zone or cross a separation line except:"
        },
        {
          "id": "e(i)",
          "scope": "both",
          "international": "(i) In cases of emergency to avoid immediate danger;",
          "inland": "(i) In cases of emergency to avoid immediate danger;"
        },
        {
          "id": "e(ii)",
          "scope": "both",
          "international": "(ii) To engage in fishing within a separation zone.",
          "inland": "(ii) To engage in fishing within a separation zone."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) A vessel navigating in areas near the terminations of traffic separation schemes shall do so with particular caution.",
          "inland": "(f) A vessel navigating in areas near the terminations of traffic separation schemes shall do so with particular caution."
        },
        {
          "id": "g",
          "scope": "both",
          "international": "(g) A vessel shall so far as practicable avoid anchoring in a traffic separation scheme or in areas near its terminations.",
          "inland": "(g) A vessel shall so far as practicable avoid anchoring in a traffic separation scheme or in areas near its terminations."
        },
        {
          "id": "h",
          "scope": "both",
          "international": "(h) A vessel not using a traffic separating scheme shall avoid it by as wide a margin as is practicable.",
          "inland": "(h) A vessel not using a traffic separating scheme shall avoid it by as wide a margin as is practicable."
        },
        {
          "id": "i",
          "scope": "both",
          "international": "(i) A vessel engaged in fishing shall not impede the passage of any vessel following a traffic lane.",
          "inland": "(i) A vessel engaged in fishing shall not impede the passage of any vessel following a traffic lane."
        },
        {
          "id": "j",
          "scope": "both",
          "international": "(j) A vessel of less than 20 meters in length or a sailing vessel shall not impede the safe passage of a power-driven vessel following a traffic lane.",
          "inland": "(j) A vessel of less than 20 meters in length or a sailing vessel shall not impede the safe passage of a power-driven vessel following a traffic lane."
        },
        {
          "id": "k",
          "scope": "both",
          "international": "(k) A vessel restricted in her ability to maneuver when engaged in an operation for the maintenance of safety of navigation in a traffic separation scheme is exempted from complying with this Rule to the extent necessary to carry out the operation.",
          "inland": "(k) A vessel restricted in her ability to maneuver when engaged in an operation for the maintenance of safety of navigation in a traffic separation scheme is exempted from complying with this Rule to the extent necessary to carry out the operation."
        },
        {
          "id": "l",
          "scope": "both",
          "international": "(l) A vessel restricted in her ability to maneuver when engaged in an operation for the laying, servicing or picking up of a submarine cable, within a traffic separation scheme, is exempted from complying with this Rule to the extent necessary to carry out the operation. II - Conduct of Vessels in Sight of One Another",
          "inland": "(l) A vessel restricted in her ability to maneuver when engaged in an operation for the laying, servicing or picking up of a submarine cable, within a traffic separation scheme, is exempted from complying with this Rule to the extent necessary to carry out the operation. II - Conduct of Vessels in Sight of One Another"
        }
      ]
    },
    "11": {
      "number": 11,
      "title": "Application",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Rules 11-18 apply to vessels in sight of one another.",
          "inland": "Rules 11-18 apply to vessels in sight of one another."
        }
      ]
    },
    "12": {
      "number": 12,
      "title": "Sailing Vessels",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) When two sailing vessels are approaching one another, so as to involve risk of collision, one of them shall keep out of the way of the other as follows:",
          "inland": "(a) When two sailing vessels are approaching one another, so as to involve risk of collision, one of them shall keep out of the way of the other as follows:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) when each has the wind on a different side, the vessel which has the wind on the port side shall keep out of the way of the other;",
          "inland": "(i) when each has the wind on a different side, the vessel which has the wind on the port side shall keep out of the way of the other;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) when both have the wind on the same side, the vessel which is to windward shall keep out of the way of the vessel which is to leeward;",
          "inland": "(ii) when both have the wind on the same side, the vessel which is to windward shall keep out of the way of the vessel which is to leeward;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) if a vessel with the wind on the port side sees a vessel to windward and cannot determine with certainty whether the other vessel has the wind on the port or on the starboard side, she shall keep out of the way of the other.",
          "inland": "(iii) if a vessel with the wind on the port side sees a vessel to windward and cannot determine with certainty whether the other vessel has the wind on the port or on the starboard side, she shall keep out of the way of the other."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) For the purposes of this Rule, the windward side shall be deemed to be the side opposite that on which the mainsail is carried or, in the case of a square-rigged vessel, the side opposite to that on which the largest fore-and-aft sail is carried.",
          "inland": "(b) For the purposes of this Rule, the windward side shall be deemed to be the side opposite that on which the mainsail is carried or, in the case of a square-rigged vessel, the side opposite to that on which the largest fore-and-aft sail is carried."
        }
      ]
    },
    "13": {
      "number": 13,
      "title": "Overtaking",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) Notwithstanding anything contained in the Rules 4-18, any vessel overtaking any other shall keep out of the way of the vessel being overtaken.",
          "inland": "(a) Notwithstanding anything contained in the Rules 4-18, any vessel overtaking any other shall keep out of the way of the vessel being overtaken."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel shall be deemed to be overtaking when coming up with a another vessel from a direction more than 22.5 degrees abaft her beam, that is, in such a position with reference to the vessel she is overtaking, that at night she would be able to see only the sternlight of that vessel but neither of her sidelights.",
          "inland": "(b) A vessel shall be deemed to be overtaking when coming up with a another vessel from a direction more than 22.5 degrees abaft her beam, that is, in such a position with reference to the vessel she is overtaking, that at night she would be able to see only the sternlight of that vessel but neither of her sidelights."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) When a vessel is in any doubt as to whether she is overtaking another, she shall assume that this is the case and act accordingly.",
          "inland": "(c) When a vessel is in any doubt as to whether she is overtaking another, she shall assume that this is the case and act accordingly."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) Any subsequent alteration of the bearing between the two vessels shall not make the overtaking vessel a crossing vessel within the meaning of these Rules or relieve her of the duty of keeping clear of the overtaken vessel until she is finally past and clear.",
          "inland": "(d) Any subsequent alteration of the bearing between the two vessels shall not make the overtaking vessel a crossing vessel within the meaning of these Rules or relieve her of the duty of keeping clear of the overtaken vessel until she is finally past and clear."
        }
      ]
    },
    "14": {
      "number": 14,
      "title": "Head-on Situation",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) when two power-driven vessels are meeting on reciprocal or nearly reciprocal courses so as to involve risk of collision each shall alter her course to starboard so that each shall pass on the port side of the other.",
          "inland": "(a) Unless otherwise agreed when two power-driven vessels are meeting on reciprocal or nearly reciprocal courses so as to involve risk of collision each shall alter her course to starboard so that each shall pass on the port side of the other."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Such a situation shall be deemed to exist when a vessel sees the other ahead or nearly ahead and by night she could see the masthead lights of the other in a line or nearly in a line and/or both sidelights and by day she observes the corresponding aspect of the other vessel.",
          "inland": "(b) Such a situation shall be deemed to exist when a vessel sees the other ahead or nearly ahead and by night she could see the masthead lights of the other in a line or nearly in a line and/or both sidelights and by day she observes the corresponding aspect of the other vessel."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) When a vessel is in any doubt as to whether such a situation exists she shall assume that it does exist and act accordingly.",
          "inland": "(c) When a vessel is in any doubt as to whether such a situation exists she shall assume that it does exist and act accordingly."
        },
        {
          "id": "d",
          "scope": "inland",
          "international": "",
          "inland": "(d) Notwithstanding Rule 14(a), a power-driven vessel operating on the Great Lakes, Western Rivers, or waters specified by the Secretary, and proceeding downbound with a following current shall have the right-of-way over an upbound vessel, shall propose the manner of passage, and shall initiate the maneuvering signals prescribed by Rule 34(a)(i), as appropriate."
        }
      ]
    },
    "15": {
      "number": 15,
      "title": "Crossing Situation",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) When two power-driven vessels are crossing so as to involve risk of collision, the vessel which has the other on her own starboard side shall keep out of the way and shall, if the circumstances of the case admit, avoid crossing ahead of the other vessel.",
          "inland": "(a) When two power-driven vessels are crossing so as to involve risk of collision, the vessel which has the other on her own starboard side shall keep out of the way and shall, if the circumstances of the case admit, avoid crossing ahead of the other vessel."
        },
        {
          "id": "b",
          "scope": "inland",
          "international": "",
          "inland": "(b) Notwithstanding Rule 15(a), on the Great Lakes, Western Rivers, or waters specified by the Secretary, a power-driven vessel crossing a river shall keep out of the way of a power-driven vessel ascending or descending the river."
        }
      ]
    },
    "16": {
      "number": 16,
      "title": "Action by Give-way Vessel",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Every vessel which is directed to keep out of the way of another vessel shall, so far as possible, take early and substantial action to keep well clear.",
          "inland": "Every vessel which is directed to keep out of the way of another vessel shall, so far as possible, take early and substantial action to keep well clear."
        }
      ]
    },
    "17": {
      "number": 17,
      "title": "Action by Stand-on Vessel",
      "paragraphs": [
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(a)(i) Where one of two vessels is to keep out of the way, the other shall keep her course and speed.",
          "inland": "(a)(i) Where one of two vessels is to keep out of the way, the other shall keep her course and speed."
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) The latter vessel may, however, take action to avoid collision by her maneuver alone, as soon as it becomes apparent to her that the vessel required to keep out of the way is not taking appropriate action in compliance with these Rules.",
          "inland": "(ii) The latter vessel may, however, take action to avoid collision by her maneuver alone, as soon as it becomes apparent to her that the vessel required to keep out of the way is not taking appropriate action in compliance with these Rules."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) When, from any cause, the vessel required to keep her course and speed finds herself so close that collision cannot be avoided by the action of the give-way vessel alone, she shall take such action as will best aid to avoid collision.",
          "inland": "(b) When, from any cause, the vessel required to keep her course and speed finds herself so close that collision cannot be avoided by the action of the give-way vessel alone, she shall take such action as will best aid to avoid collision."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A power-driven vessel which takes action in a crossing situation in accordance with Rule 17(a)(ii) to avoid collision with another power-driven vessel shall, if the circumstances of the case admit, not alter course to port for a vessel on her own port side.",
          "inland": "(c) A power-driven vessel which takes action in a crossing situation in accordance with Rule 17(a)(ii) to avoid collision with another power-driven vessel shall, if the circumstances of the case admit, not alter course to port for a vessel on her own port side."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) This Rule does not relieve the give-way vessel of her obligation to keep out of the way.",
          "inland": "(d) This Rule does not relieve the give-way vessel of her obligation to keep out of the way."
        }
      ]
    },
    "18": {
      "number": 18,
      "title": "Responsibilities Between Vessels",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Except where Rules 9, 10, and 13 otherwise require:",
          "inland": "Except where Rules 9, 10, and 13 otherwise require:"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A power-driven vessel underway shall keep out of the way of:",
          "inland": "(a) A power-driven vessel underway shall keep out of the way of:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) a vessel not under command;",
          "inland": "(i) a vessel not under command;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) a vessel restricted in her ability to maneuver;",
          "inland": "(ii) a vessel restricted in her ability to maneuver;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) a vessel engaged in fishing;",
          "inland": "(iii) a vessel engaged in fishing;"
        },
        {
          "id": "a(iv)",
          "scope": "both",
          "international": "(iv) a sailing vessel.",
          "inland": "(iv) a sailing vessel."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A sailing vessel underway shall keep out of the way of:",
          "inland": "(b) A sailing vessel underway shall keep out of the way of:"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) a vessel not under command;",
          "inland": "(i) a vessel not under command;"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) a vessel restricted in her ability to maneuver;",
          "inland": "(ii) a vessel restricted in her ability to maneuver;"
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) a vessel engaged in fishing.",
          "inland": "(iii) a vessel engaged in fishing."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel engaged in fishing when underway shall, so far as possible, keep out of the way of:",
          "inland": "(c) A vessel engaged in fishing when underway shall, so far as possible, keep out of the way of:"
        },
        {
          "id": "c(i)",
          "scope": "both",
          "international": "(i) a vessel not under command;",
          "inland": "(i) a vessel not under command;"
        },
        {
          "id": "c(ii)",
          "scope": "both",
          "international": "(ii) a vessel restricted in her ability to maneuver.",
          "inland": "(ii) a vessel restricted in her ability to maneuver. Reserved"
        },
        {
          "id": "d(i)",
          "scope": "international",
          "international": "(d)(i) Any vessel other than a vessel not under command or a vessel restricted in her ability to maneuver shall, if the circumstances of the case admit, avoid impeding the safe passage of a vessel constrained by her draft, exhibiting the signals in Rule 28.",
          "inland": ""
        },
        {
          "id": "d(ii)",
          "scope": "international",
          "international": "(ii) A vessel constrained by her draft shall navigate with particular caution having full regard to her special condition.",
          "inland": ""
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A seaplane on the water shall, in general, keep well clear of all vessels and avoid impeding their navigation. In circumstances, however, where risk of collision exists, she shall comply with Rules 4-19.",
          "inland": "(e) A seaplane on the water shall, in general, keep well clear of all vessels and avoid impeding their navigation. In circumstances, however, where risk of collision exists, she shall comply with Rules 4-19."
        },
        {
          "id": "f(i)",
          "scope": "both",
          "international": "(f)(i) A WIG craft shall, when taking off, landing and in flight near the surface, keep well clear of all other vessels and avoid impeding their navigation;",
          "inland": "(f)(i) A WIG craft shall, when taking off, landing and in flight near the surface, keep well clear of all other vessels and avoid impeding their navigation;"
        },
        {
          "id": "f(ii)",
          "scope": "both",
          "international": "(ii) a WIG craft operating on the water surface shall comply with Rules 4-19 as a power-driven vessel. III - Conduct of Vessels in Restricted Visibility",
          "inland": "(ii) a WIG craft operating on the water surface shall comply with Rules 4-19 as a power-driven vessel. III - Conduct of Vessels in Restricted Visibility"
        }
      ]
    },
    "19": {
      "number": 19,
      "title": "Conduct of Vessels in Restricted Visibility",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) This Rule applies to vessels not in sight of one another when navigating in or near an area of restricted visibility.",
          "inland": "(a) This Rule applies to vessels not in sight of one another when navigating in or near an area of restricted visibility."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Every vessel shall proceed at a safe speed adapted to the prevailing circumstances and conditions of restricted visibility. A power-driven vessel shall have her engines ready for immediate maneuver.",
          "inland": "(b) Every vessel shall proceed at a safe speed adapted to the prevailing circumstances and conditions of restricted visibility. A power-driven vessel shall have her engines ready for immediate maneuver."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) Every vessel shall have due regard to the prevailing circumstances and conditions of restricted visibility when complying with Rules 4-10.",
          "inland": "(c) Every vessel shall have due regard to the prevailing circumstances and conditions of restricted visibility when complying with Rules 4-10."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) A vessel which detects by radar alone the presence of another vessel shall determine if a close-quarters situation is developing and/or risk of collision exists. If so, she shall take avoiding action in ample time, provided that when such action consists of an alteration in course, so far as possible the following shall be avoided:",
          "inland": "(d) A vessel which detects by radar alone the presence of another vessel shall determine if a close-quarters situation is developing and/or risk of collision exists. If so, she shall take avoiding action in ample time, provided that when such action consists of an alteration in course, so far as possible the following shall be avoided:"
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(i) An alteration of course to port for a vessel forward of the beam, other than for a vessel being overtaken;",
          "inland": "(i) An alteration of course to port for a vessel forward of the beam, other than for a vessel being overtaken;"
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) An alteration of course toward a vessel abeam or abaft the beam.",
          "inland": "(ii) An alteration of course toward a vessel abeam or abaft the beam."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) Except where it has been determined that a risk of collision does not exist, every vessel which hears apparently forward of her beam the fog signal of another vessel, or which cannot avoid a close-quarters situation with another vessel forward of her beam, shall reduce her speed to be the minimum at which she can be kept on her course. She shall if necessary take all her way off and in any event navigate with extreme caution until danger of collision is over. PART C - LIGHTS AND SHAPES",
          "inland": "(e) Except where it has been determined that a risk of collision does not exist, every vessel which hears apparently forward of her beam the fog signal of another vessel, or which cannot avoid a close-quarters situation with another vessel forward of her beam, shall reduce her speed to be the minimum at which she can be kept on her course. She shall if necessary take all her way off and in any event navigate with extreme caution until danger of collision is over. PART C - LIGHTS AND SHAPES"
        }
      ]
    },
    "20": {
      "number": 20,
      "title": "Application",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) Rules 20-31 shall be complied with in all weathers.",
          "inland": "(a) Rules 20-31 shall be complied with in all weathers."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) The Rules concerning lights shall be complied with from sunset to sunrise, and during such times no other lights shall be exhibited, except such lights which cannot be mistaken for the lights specified in these Rules or do not impair their visibility or distinctive character, or interfere with the keeping of a proper look-out.",
          "inland": "(b) The Rules concerning lights shall be complied with from sunset to sunrise, and during such times no other lights shall be exhibited, except such lights which cannot be mistaken for the lights specified in these Rules or do not impair their visibility or distinctive character, or interfere with the keeping of a proper look-out."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) The lights prescribed by these Rules shall, if carried, also be exhibited from sunrise to sunset in restricted visibility and may be exhibited in all other circumstances when it is deemed necessary.",
          "inland": "(c) The lights prescribed by these Rules shall, if carried, also be exhibited from sunrise to sunset in restricted visibility and may be exhibited in all other circumstances when it is deemed necessary."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) The Rules concerning shapes shall be complied with by day.",
          "inland": "(d) The Rules concerning shapes shall be complied with by day."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) The lights and shapes specified in these Rules shall comply with the provisions of Annex I of these Rules.",
          "inland": "(e) The lights and shapes specified in these Rules shall comply with the provisions of Annex I of these Rules."
        },
        {
          "id": "f",
          "scope": "inland",
          "international": "",
          "inland": "(f) A vessel’s navigation lights and shapes may be lowered if necessary to pass under a bridge. 67 FR 53382, September 6th, 2022 69 FR 42192, June 12th, 2023"
        }
      ]
    },
    "21": {
      "number": 21,
      "title": "Definitions",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) \"Masthead light\" means a white light placed over the fore and aft centerline of the vessel showing an unbroken light over an arc of the horizon of 225 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on either side of the vessel.",
          "inland": "(a) \"Masthead light\" means a white light placed over the fore and aft centerline of the vessel showing an unbroken light over an arc of the horizon of 225 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on either side of the vessel except that on a vessel of less than 12 meters in length the masthead light shall be placed as nearly as practicable to the fore and aft centerline of the vessel."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) \"Sidelights\" means a green light on the starboard side and a red light on the port side each showing an unbroken light over an arc of the horizon of 112.5 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on its respective side. In a vessel of less than 20 meters in length the sidelights may be combined in one lantern carried on the fore and aft centerline of the vessel.",
          "inland": "(b) \"Sidelights\" means a green light on the starboard side and a red light on the port side each showing an unbroken light over an arc of the horizon of 112.5 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on its respective side. In a vessel of less than 20 meters in length the sidelights may be combined in one lantern carried on the fore and aft centerline of the vessel, except that on a vessel of less than 12 meters in length the sidelights when combined in one lantern shall be placed as nearly as practicable to the fore and aft centerline of the vessel."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) \"Sternlight\" means a white light placed as nearly as practicable at the stern showing an unbroken light over an arc of the horizon of 135 degrees and so fixed as to show the light 67.5 degrees from right aft on each side of the vessel.",
          "inland": "(c) \"Sternlight\" means a white light placed as nearly as practicable at the stern showing an unbroken light over an arc of the horizon of 135 degrees and so fixed as to show the light 67.5 degrees from right aft on each side of the vessel."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) \"Towing light\" means a yellow light having the same characteristics as the \"sternlight\" defined in Rule 21(c).",
          "inland": "(d) \"Towing light\" means a yellow light having the same characteristics as the \"sternlight\" defined in Rule 21(c)."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) \"All-round light\" means a light showing an unbroken light over an arc of the horizon of 360 degrees.",
          "inland": "(e) \"All-round light\" means a light showing an unbroken light over an arc of the horizon of 360 degrees."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) \"Flashing light\" means a light flashing at regular intervals at a frequency of 120 flashes or more per minute. ANNEX V – Pilot Rules {Inland Only} Law Enforcement Vessels { Flashing blue light } (33 CFR 88.05)",
          "inland": "(f) \"Flashing light\" means a light flashing at regular intervals at a frequency of 120 flashes or more per minute."
        },
        {
          "id": "g",
          "scope": "inland",
          "international": "",
          "inland": "(g) \"Special flashing light\" means a yellow light flashing at regular intervals at a frequency of 50 to 70 flashes per minute, placed as far forward and as nearly as practicable on the fore and aft centerline of the tow and showing an unbroken light over an arc of the horizon of not less than 180 degrees nor more than 225 degrees and so fixed as to show the light from right ahead to abeam and no more than 22.5 degrees abaft the beam on either side of the vessel. ANNEX V – Pilot Rules {Inland Only} Law Enforcement Vessels { Flashing blue light } (33 CFR 88.05)"
        },
        {
          "id": "b1:a",
          "scope": "both",
          "international": "(a) Law enforcement vessels may display a flashing blue light when engaged in direct law enforcement or public safety activities. This light must be located so that it does not interfere with the visibility of the vessel’s navigation lights.",
          "inland": "(a) Law enforcement vessels may display a flashing blue light when engaged in direct law enforcement or public safety activities. This light must be located so that it does not interfere with the visibility of the vessel’s navigation lights."
        },
        {
          "id": "b1:b",
          "scope": "both",
          "international": "(b) The blue light described in this section may be displayed by law enforcement vessels of the United States and the States and their political subdivisions. Public Safety Vessels { Alternating flashing red and yellow light } (33 CFR 88.07)",
          "inland": "(b) The blue light described in this section may be displayed by law enforcement vessels of the United States and the States and their political subdivisions. Public Safety Vessels { Alternating flashing red and yellow light } (33 CFR 88.07)"
        },
        {
          "id": "b2:a",
          "scope": "both",
          "international": "(a) Vessels engaged in government sanctioned public safety activities, and commercial vessels performing similar functions, may display an alternately flashing red and yellow light signal. This identification light signal must be located so that it does not interfere with the visibility of the vessel’s navigation lights. The identification light signal may be used only as an identification signal and conveys no special privilege. Vessels using the identification light signal during public safety activities must abide by the inland navigation rules, and must not presume that the light or the exigency gives them precedence or right of way.",
          "inland": "(a) Vessels engaged in government sanctioned public safety activities, and commercial vessels performing similar functions, may display an alternately flashing red and yellow light signal. This identification light signal must be located so that it does not interfere with the visibility of the vessel’s navigation lights. The identification light signal may be used only as an identification signal and conveys no special privilege. Vessels using the identification light signal during public safety activities must abide by the inland navigation rules, and must not presume that the light or the exigency gives them precedence or right of way."
        },
        {
          "id": "b2:b",
          "scope": "both",
          "international": "(b) Public safety activities include but are not limited to patrolling marine parades, regattas, or special water celebrations; traffic control; salvage; firefighting; medical assistance; assisting disabled vessels; and search and rescue.",
          "inland": "(b) Public safety activities include but are not limited to patrolling marine parades, regattas, or special water celebrations; traffic control; salvage; firefighting; medical assistance; assisting disabled vessels; and search and rescue."
        }
      ]
    },
    "22": {
      "number": 22,
      "title": "Visibility of Lights",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "The lights prescribed in Rules (Subpart C) shall have an intensity as specified in Annex I to these Rules (33 CFR part 84), so as to be visible at the following minimum ranges:",
          "inland": "The lights prescribed in Rules (Subpart C) shall have an intensity as specified in Annex I to these Rules (33 CFR part 84), so as to be visible at the following minimum ranges:"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) In vessels of 50 meters or more in length:",
          "inland": "(a) In vessels of 50 meters or more in length:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) a masthead light, 6 miles;",
          "inland": "(i) a masthead light, 6 miles;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) a sidelight, 3 miles;",
          "inland": "(ii) a sidelight, 3 miles;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) a sternlight, 3 miles;",
          "inland": "(iii) a sternlight, 3 miles;"
        },
        {
          "id": "a(iv)",
          "scope": "both",
          "international": "(iv) a towing light, 3 miles;",
          "inland": "(iv) a towing light, 3 miles;"
        },
        {
          "id": "a(v)",
          "scope": "both",
          "international": "(v) a white red, green or yellow all-round light, 3 miles; and",
          "inland": "(v) a white red, green or yellow all-round light, 3 miles; and (vi) a special flashing light, 2 miles."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) In vessels of 12 meters or more in length but less than 50 meters in length;",
          "inland": "(b) In vessels of 12 meters or more in length but less than 50 meters in length;"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) a masthead light, 5 miles; except that where the length of the vessel is less than 20 meters, 3 miles;",
          "inland": "(i) a masthead light, 5 miles; except that where the length of the vessel is less than 20 meters, 3 miles;"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) a sidelight, 2 miles;",
          "inland": "(ii) a sidelight, 2 miles;"
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) a sternlight, 2 miles;",
          "inland": "(iii) a sternlight, 2 miles;"
        },
        {
          "id": "b(iv)",
          "scope": "both",
          "international": "(iv) a towing light, 2 miles;",
          "inland": "(iv) a towing light, 2 miles;"
        },
        {
          "id": "b(v)",
          "scope": "both",
          "international": "(v) a white, red, green or yellow all-round light, 2 miles; and",
          "inland": "(v) a white, red, green or yellow all-round light, 2 miles; and (vi) a special flashing light, 2 miles."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) In vessels of less than 12 meters in length:",
          "inland": "(c) In vessels of less than 12 meters in length:"
        },
        {
          "id": "c(i)",
          "scope": "both",
          "international": "(i) a masthead light, 2 miles;",
          "inland": "(i) a masthead light, 2 miles;"
        },
        {
          "id": "c(ii)",
          "scope": "both",
          "international": "(ii) a sidelight, 1 mile;",
          "inland": "(ii) a sidelight, 1 mile;"
        },
        {
          "id": "c(iii)",
          "scope": "both",
          "international": "(iii) a sternlight, 2 miles;",
          "inland": "(iii) a sternlight, 2 miles;"
        },
        {
          "id": "c(iv)",
          "scope": "both",
          "international": "(iv) a towing light, 2 miles;",
          "inland": "(iv) a towing light, 2 miles;"
        },
        {
          "id": "c(v)",
          "scope": "both",
          "international": "(v) a white red, green or yellow all-round light, 2 miles; and",
          "inland": "(v) a white red, green or yellow all-round light, 2 miles; and (vi) a special flashing light, 2 miles."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) In inconspicuous, partly submerged vessels or objects being towed;",
          "inland": "(d) In inconspicuous, partly submerged vessels or objects being towed;"
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(i) a white all-round light; 3 miles.",
          "inland": "(i) a white all-round light; 3 miles."
        }
      ]
    },
    "23": {
      "number": 23,
      "title": "Power-driven Vessels Underway",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A power-driven vessel underway shall exhibit:",
          "inland": "(a) A power-driven vessel underway shall exhibit:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) a masthead light forward;",
          "inland": "(i) a masthead light forward;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii)a second masthead light abaft of and higher than the forward one; except that a vessel of less than 50 meters in length shall not be obliged to exhibit such a light but may do so;",
          "inland": "(ii)a second masthead light abaft of and higher than the forward one; except that a vessel of less than 50 meters in length shall not be obliged to exhibit such a light but may do so;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) sidelights; and,",
          "inland": "(iii) sidelights; and,"
        },
        {
          "id": "a(iv)",
          "scope": "both",
          "international": "(iv) a sternlight.",
          "inland": "(iv) a sternlight."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) An air-cushion vessel when operating in non-displacement mode shall, in addition to the lights prescribed in Rule 23(a), exhibit an all-round flashing yellow light.",
          "inland": "(b) An air-cushion vessel when operating in non-displacement mode shall, in addition to the lights prescribed in Rule 23(a), exhibit an all-round flashing yellow light, where it can best be seen."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A WIG craft only when taking off, landing and in flight near the surface shall, in addition to the lights prescribed in Rule 23(a), exhibit a high intensity all-round flashing red light.",
          "inland": "(c) A WIG craft only when taking off, landing and in flight near the surface shall, in addition to the lights prescribed in Rule 23(a), exhibit a high intensity all-round flashing red light."
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(d)(i) A power-driven vessel of less than 12 meters in length may in lieu of the lights prescribed in Rule 23(a) exhibit an all-round white light and sidelights.",
          "inland": "(d)(i) A power-driven vessel of less than 12 meters in length may in lieu of the lights prescribed in Rule 23(a) exhibit an all-round white light and sidelights."
        },
        {
          "id": "d(ii)",
          "scope": "international",
          "international": "(ii) a power-driven vessel of less than 7 meters in length whose maximum speed does not exceed 7 knots may in lieu of the lights prescribed in Rule 23(a) exhibit an all-round white light and shall, if practicable, also exhibit sidelights.",
          "inland": ""
        },
        {
          "id": "d(iii)",
          "scope": "international",
          "international": "(iii) the masthead light or all-round white light on a power-driven vessel of less than 12 meters in length may be displaced from the fore and aft center line of the vessel if center line fitting is not practicable, provided that the sidelights are combined in one lantern which shall be carried on the fore and aft center line of the vessel or located as nearly as practicable in the same fore and aft line as the masthead light or the all-round white light.",
          "inland": ""
        },
        {
          "id": "e",
          "scope": "inland",
          "international": "",
          "inland": "(e) A power-driven vessel when operating on the Great Lakes may carry an all-round white light in lieu of the second masthead light and sternlight prescribed in Rule 23(a). The light shall be carried in the position of the second masthead light and be visible at the same minimum range."
        }
      ]
    },
    "24": {
      "number": 24,
      "title": "Towing and Pushing",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A power-driven vessel when towing astern shall exhibit: (i) Instead of the light prescribed in Rule 23(a)(i) or Rule 23(a)(ii), two masthead lights in a vertical line. When the length of the tow, measuring from the stern of the towing vessel to the after end of the tow, exceeds 200 meters, three such lights in a vertical line;",
          "inland": "(a) A power-driven vessel when towing astern shall exhibit: (i) Instead of the light prescribed in Rule 23(a)(i) or Rule 23(a)(ii), two masthead lights in a vertical line. When the length of the tow, measuring from the stern of the towing vessel to the after end of the tow, exceeds 200 meters, three such lights in a vertical line;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) sidelights;",
          "inland": "(ii) sidelights;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) a sternlight;",
          "inland": "(iii) a sternlight;"
        },
        {
          "id": "a(iv)",
          "scope": "both",
          "international": "(iv) a towing light in a vertical line above the sternlight; and",
          "inland": "(iv) a towing light in a vertical line above the sternlight; and"
        },
        {
          "id": "a(v)",
          "scope": "both",
          "international": "(v) when the length of the tow exceeds 200 meters, a diamond shape where it can best be seen.",
          "inland": "(v) when the length of the tow exceeds 200 meters, a diamond shape where it can best be seen."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and exhibit the lights prescribed in Rule 23(a)",
          "inland": "(b) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and exhibit the lights prescribed in Rule 23(a)"
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A power-driven vessel when pushing ahead or towing alongside, except in the case of a composite unit, shall exhibit:",
          "inland": "(c) A power-driven vessel when pushing ahead or towing alongside, except as required by Rule 24(b) and (i), shall exhibit:"
        },
        {
          "id": "c(i)",
          "scope": "both",
          "international": "(i) instead of the light prescribed in Rule 23(a)(i) or Rule 23(a)(ii), two masthead lights in a vertical line;",
          "inland": "(i) instead of the light prescribed in Rule 23(a)(i) or Rule 23(a)(ii), two masthead lights in a vertical line;"
        },
        {
          "id": "c(ii)",
          "scope": "both",
          "international": "(ii) sidelights;",
          "inland": "(ii) sidelights; and"
        },
        {
          "id": "c(iii)",
          "scope": "both",
          "international": "(iii) a sternlight.",
          "inland": "(iii) two towing lights in a vertical line."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) A power-driven vessel to which Rule 24(a) or (c) applies shall also comply with Rule 23(a) (a)(ii).",
          "inland": "(d) A power-driven vessel to which Rule 24(a) or (c) applies shall also comply with Rule 23(a) (a)(i) and (a)(ii)."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel or object being towed, other than those mentioned in Rule 24(g), shall exhibit:",
          "inland": "(e) A vessel or object being towed, other than those referred in Rule 24(g), shall exhibit:"
        },
        {
          "id": "e(i)",
          "scope": "both",
          "international": "(i) sidelights;",
          "inland": "(i) sidelights;"
        },
        {
          "id": "e(ii)",
          "scope": "both",
          "international": "(ii) a sternlight;",
          "inland": "(ii) a sternlight; and"
        },
        {
          "id": "e(iii)",
          "scope": "both",
          "international": "(iii) when the length of the tow exceeds 200 meters, a diamond shape where it can best be seen.",
          "inland": "(iii) when the length of the tow exceeds 200 meters, a diamond shape where it can best be seen."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) Provided that any number of vessels being towed alongside or pushed in a group shall be lighted as one vessel.",
          "inland": "(f) Provided that any number of vessels being towed alongside or pushed in a group shall be lighted as one vessel except as provided in Rule 24(f)(iii)."
        },
        {
          "id": "f(i)",
          "scope": "both",
          "international": "(i) a vessel being pushed ahead, not being part of a composite unit, shall exhibit at the forward end, sidelights, and;",
          "inland": "(i) a vessel being pushed ahead, not being part of a composite unit, shall exhibit at the forward end, sidelights, and a special flashing light;"
        },
        {
          "id": "f(ii)",
          "scope": "both",
          "international": "(ii) a vessel being towed alongside shall exhibit a sternlight and at the forward end, sidelights, and;",
          "inland": "(ii) a vessel being towed alongside shall exhibit a sternlight and at the forward end, sidelights, and a special flashing light;"
        },
        {
          "id": "f(iii)",
          "scope": "inland",
          "international": "",
          "inland": "(iii) when vessels are towed alongside on both sides of the towing vessel a sternlight shall be exhibited on the stern of the outboard vessel on each side of the towing vessel, and a single set of sidelights as far forward and as far outboard as is practicable, and a single special flashing light;"
        },
        {
          "id": "g",
          "scope": "both",
          "international": "(g) An inconspicuous, partly submerged vessel or object, or combination of such vessels or objects being towed, shall exhibit:",
          "inland": "(g) An inconspicuous, partly submerged vessel or object, or combination of such vessels or objects being towed, shall exhibit:"
        },
        {
          "id": "g(i)",
          "scope": "both",
          "international": "(i) if it is less than 25 meters in breadth, one all-round white light at or near the forward end and one at or near the after end except that dracones need not exhibit a light at or near the forward end.",
          "inland": "(i) if it is less than 25 meters in breadth, one all-round white light at or near the forward end and one at or near the after end except that dracones need not exhibit a light at or near each end."
        },
        {
          "id": "g(ii)",
          "scope": "both",
          "international": "(ii) if it is 25 meters or more in breadth, two additional all-round white lights at or near the extremities of its breadth;",
          "inland": "(ii) if it is 25 meters or more in breadth, two additional all-round white lights at or near the extremities of its breadth;"
        },
        {
          "id": "g(ii)",
          "scope": "both",
          "international": "(ii) if it is 25 meters or more in breadth, four all-round white lights to mark its length and breadth;",
          "inland": "(ii) if it is 25 meters or more in breadth, four all-round white lights to mark its length and breadth;"
        },
        {
          "id": "g(iii)",
          "scope": "both",
          "international": "(iii) if it exceeds 100 meters in length, additional all-round white lights between the lights prescribed in Rule 24(g)(i) and so that the distance between the lights shall not exceed 100 meters;",
          "inland": "(iii) if it exceeds 100 meters in length, additional all-round white lights between the lights prescribed in Rule 24(g)(i) and (ii) and so that the distance between the lights shall not exceed 100 meters: provided that any vessels or objects being towed alongside each other shall be lighted as one vessel or object;"
        },
        {
          "id": "g(iv)",
          "scope": "both",
          "international": "(iv) a diamond shape at or near the aftermost extremity of the last vessel or object being towed; and if the length of the tow exceeds 200 meters an additional diamond shape where it can best be seen and located as far forward as is practicable;",
          "inland": "(iv) a diamond shape at or near the aftermost extremity of the last vessel or object being towed; and"
        },
        {
          "id": "g(v)",
          "scope": "inland",
          "international": "",
          "inland": "(v) the towing vessel may direct a searchlight in the direction of the tow to indicate its presence to an approaching vessel."
        },
        {
          "id": "h",
          "scope": "both",
          "international": "(h) Where from any sufficient cause it is impracticable for a vessel or object being towed to exhibit the lights or shapes prescribed in Rule 24(e) or (g), all possible measures shall be taken to light the vessel or object towed or at least to indicate the presence of such vessel or object.",
          "inland": "(h) Where from any sufficient cause it is impracticable for a vessel or object being towed to exhibit the lights or shapes prescribed in Rule 24(e) or (g), all possible measures shall be taken to light the vessel or object towed or at least to indicate the presence of the unlighted vessel or object."
        },
        {
          "id": "i",
          "scope": "both",
          "international": "(i) Where from any sufficient cause it is impracticable for a vessel not normally engaged in towing operations to display the lights prescribed in Rule 24(a), Rule 24(c), such vessel shall not be required to exhibit those lights when engaged in towing another vessel in distress or otherwise in need of assistance. All possible measures shall be taken to indicate the nature of the relationship between the towing vessel and the vessel being towed as authorized by Rule 36, in particular by illuminating the towline.",
          "inland": "(i) Where from any sufficient cause it is impracticable for a vessel not normally engaged in towing operations to display the lights prescribed in Rule 24(a), Rule 24(c), such vessel shall not be required to exhibit those lights when engaged in towing another vessel in distress or otherwise in need of assistance. All possible measures shall be taken to indicate the nature of the relationship between the towing vessel and the vessel being towed and the vessel being assisted. The searchlight authorized by Rule 36 may be used to illuminate the tow."
        },
        {
          "id": "j",
          "scope": "inland",
          "international": "",
          "inland": "(j) Notwithstanding Rule 24(c), on the Western Rivers (except below the Huey P. Long Bridge on the Mississippi River) and on waters specified by the Secretary*, a power-driven vessel when pushing ahead or towing alongside, except as Rule 24(b) applies, shall exhibit:"
        },
        {
          "id": "j(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) sidelights; and"
        },
        {
          "id": "j(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) two towing lights in a vertical line."
        },
        {
          "id": "b1:b",
          "scope": "both",
          "international": "(b) The Gulf Intracoastal Waterway from St. Marks, Florida, to the Rio Grande, Texas, including the Morgan City-Port Allen Alternate Route and the Galveston-Freeport Cutoff, except that a power-driven vessel pushing ahead or towing alongside shall exhibit the lights required by Inland Rule 24(c), while transiting within the following areas:",
          "inland": "(b) The Gulf Intracoastal Waterway from St. Marks, Florida, to the Rio Grande, Texas, including the Morgan City-Port Allen Alternate Route and the Galveston-Freeport Cutoff, except that a power-driven vessel pushing ahead or towing alongside shall exhibit the lights required by Inland Rule 24(c), while transiting within the following areas:"
        },
        {
          "id": "b1:b(1)",
          "scope": "both",
          "international": "(1) St. Andrews Bay from the Hathaway Fixed Bridge at Mile 284.6 East of Harvey Locks (EHL) to the Dupont Fixed Bridge at Mile 295.4 EHL.",
          "inland": "(1) St. Andrews Bay from the Hathaway Fixed Bridge at Mile 284.6 East of Harvey Locks (EHL) to the Dupont Fixed Bridge at Mile 295.4 EHL."
        },
        {
          "id": "b1:b(2)",
          "scope": "both",
          "international": "(2) Pensacola Bay, Santa Rosa Sound and Big Lagoon from the Light “10” off of Trout Point at Mile 176.9 EHL to the Pensacola Fixed Bridge at Mile 189.1 EHL.",
          "inland": "(2) Pensacola Bay, Santa Rosa Sound and Big Lagoon from the Light “10” off of Trout Point at Mile 176.9 EHL to the Pensacola Fixed Bridge at Mile 189.1 EHL."
        },
        {
          "id": "b1:b(3)",
          "scope": "both",
          "international": "(3) Mobile Bay and Bon Secour Bay from the Dauphin Island Causeway Fixed Bridge at Mile 127.7 EHL to Little Point Clear at Mile 140 EHL.",
          "inland": "(3) Mobile Bay and Bon Secour Bay from the Dauphin Island Causeway Fixed Bridge at Mile 127.7 EHL to Little Point Clear at Mile 140 EHL."
        },
        {
          "id": "b1:b(4)",
          "scope": "both",
          "international": "(4) Mississippi Sound from Grand Island Waterway Light “1” at Mile 53.8 EHL to Light “40” off the West Point of Dauphin Island at Mile 118.7 EHL.",
          "inland": "(4) Mississippi Sound from Grand Island Waterway Light “1” at Mile 53.8 EHL to Light “40” off the West Point of Dauphin Island at Mile 118.7 EHL."
        },
        {
          "id": "b1:b(5)",
          "scope": "both",
          "international": "(5) The Mississippi River at New Orleans, Mississippi River-Gulf Outlet Canal and the Inner Harbor Navigation Canal from the junction of the Harvey Canal and the Algiers Alternate Route at Mile 6.5 West of Harvey Locks (WHL) to the Michoud Canal at Mile 18 EHL.",
          "inland": "(5) The Mississippi River at New Orleans, Mississippi River-Gulf Outlet Canal and the Inner Harbor Navigation Canal from the junction of the Harvey Canal and the Algiers Alternate Route at Mile 6.5 West of Harvey Locks (WHL) to the Michoud Canal at Mile 18 EHL."
        },
        {
          "id": "b1:b(6)",
          "scope": "both",
          "international": "(6) The Calcasieu River from the Calcasieu Lock at Mile 238.6 WHL to the Ellender Lift Bridge at Mile 243.6 WHL.",
          "inland": "(6) The Calcasieu River from the Calcasieu Lock at Mile 238.6 WHL to the Ellender Lift Bridge at Mile 243.6 WHL."
        },
        {
          "id": "b1:b(7)",
          "scope": "both",
          "international": "(7) The Sabine Neches Canal from Mile 262.5 WHL to Mile 291.5 WHL.",
          "inland": "(7) The Sabine Neches Canal from Mile 262.5 WHL to Mile 291.5 WHL."
        },
        {
          "id": "b1:b(8)",
          "scope": "both",
          "international": "(8) Bolivar Roads from the Bolivar Assembling Basin at Mile 346 WHL to the Galveston Causeway Bridge at Mile 357.3 WHL.",
          "inland": "(8) Bolivar Roads from the Bolivar Assembling Basin at Mile 346 WHL to the Galveston Causeway Bridge at Mile 357.3 WHL."
        },
        {
          "id": "b1:b(9)",
          "scope": "both",
          "international": "(9) Freeport Harbor from Surfside Beach Fixed Bridge at Mile 393.8 WHL to the Bryan Beach Pontoon Bridge at Mile 397.6 WHL.",
          "inland": "(9) Freeport Harbor from Surfside Beach Fixed Bridge at Mile 393.8 WHL to the Bryan Beach Pontoon Bridge at Mile 397.6 WHL."
        },
        {
          "id": "b1:b(10)",
          "scope": "both",
          "international": "(10) Matagorda Ship Channel area of Matagorda Bay from Range “K” Front Light at Mile 468.7 WHL to the Port O’Connor Jetty at Mile 472.2 WHL.",
          "inland": "(10) Matagorda Ship Channel area of Matagorda Bay from Range “K” Front Light at Mile 468.7 WHL to the Port O’Connor Jetty at Mile 472.2 WHL."
        },
        {
          "id": "b1:b(11)",
          "scope": "both",
          "international": "(11) Corpus Christi Bay from Redfish Bay Day Beacon “55” at Mile 537.4 WHL when in the Gulf Intracoastal Waterway main route or from the north end of Lydia Ann Island Mile 531.1A when in the Gulf Intracoastal Waterway Alternate Route to Corpus Christi Bay LT 76 at Mile 543.7 WHL.",
          "inland": "(11) Corpus Christi Bay from Redfish Bay Day Beacon “55” at Mile 537.4 WHL when in the Gulf Intracoastal Waterway main route or from the north end of Lydia Ann Island Mile 531.1A when in the Gulf Intracoastal Waterway Alternate Route to Corpus Christi Bay LT 76 at Mile 543.7 WHL."
        },
        {
          "id": "b1:b(12)",
          "scope": "both",
          "international": "(12) Port Isabel and Brownsville Ship Channel south of the Padre Island Causeway Fixed Bridge at Mile 665.1 WHL.",
          "inland": "(12) Port Isabel and Brownsville Ship Channel south of the Padre Island Causeway Fixed Bridge at Mile 665.1 WHL."
        }
      ]
    },
    "25": {
      "number": 25,
      "title": "Sailing Vessels Underway and Vessels Under Oars",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "A sailing vessel underway shall exhibit:",
          "inland": "A sailing vessel underway shall exhibit:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) sidelights;",
          "inland": "(i) sidelights;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) a sternlight.",
          "inland": "(ii) a sternlight."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) In a sailing vessel of less than 20 meters in length the lights prescribed in Rule 25(a) may be combined in one lantern carried at or near the top of the mast where it can best be seen.",
          "inland": "(b) In a sailing vessel of less than 20 meters in length the lights prescribed in Rule 25(a) may be combined in one lantern carried at or near the top of the mast where it can best be seen."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A sailing vessel underway may, in addition to the lights prescribed in Rule 25(a), exhibit at or near the top of the mast, where they can best be seen, two all-round lights in a vertical line, the upper being red and the lower green, but these lights shall not be exhibited in conjunction with the combined lantern permitted by Rule 25(b).",
          "inland": "(c) A sailing vessel underway may, in addition to the lights prescribed in Rule 25(a), exhibit at or near the top of the mast, where they can best be seen, two all-round lights in a vertical line, the upper being red and the lower green, but these lights shall not be exhibited in conjunction with the combined lantern permitted by Rule 25(b)."
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(d)(i) A sailing vessel of less than 7 meter in length shall, if practicable, exhibit the lights prescribed in Rule 25(a) or (b), but if she does not, she shall have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision.",
          "inland": "(d)(i) A sailing vessel of less than 7 meter in length shall, if practicable, exhibit the lights prescribed in Rule 25(a) or (b), but if she does not, she shall exhibit an all around white light or have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision."
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) A vessel under oars may exhibit the lights prescribed in this rule for sailing vessels, but if she does not, she shall have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision.",
          "inland": "(ii) A vessel under oars may exhibit the lights prescribed in this rule for sailing vessels, but if she does not, she shall exhibit an all around white light or have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel proceeding under sail when also being propelled by machinery shall exhibit forward where it can best be seen a conical shape, apex downwards.",
          "inland": "(e) A vessel proceeding under sail when also being propelled by machinery shall exhibit forward where it can best be seen a conical shape, apex downwards. A vessel of less than 12 meters in length is not required to exhibit this shape, but may do so."
        }
      ]
    },
    "26": {
      "number": 26,
      "title": "Fishing Vessels",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel engaged in fishing, whether underway or at anchor, shall exhibit only the lights and shapes prescribed in this Rule.",
          "inland": "(a) A vessel engaged in fishing, whether underway or at anchor, shall exhibit only the lights and shapes prescribed in this Rule."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel when engaged in trawling, by which is meant the dragging through the water of a dredge net or other apparatus used as a fishing appliance, shall exhibit:",
          "inland": "(b) A vessel when engaged in trawling, by which is meant the dragging through the water of a dredge net or other apparatus used as a fishing appliance, shall exhibit:"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) two all-round lights in a vertical line, the upper being green and the lower white, or a shape consisting of two cones with their apexes together in a vertical line one above the other;",
          "inland": "(i) two all-round lights in a vertical line, the upper being green and the lower white, or a shape consisting of two cones with their apexes together in a vertical line one above the other;"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) a masthead light abaft of and higher than the all-round green light; a vessel of less than 50 meters in length shall not be obliged to exhibit such a light but may do so;",
          "inland": "(ii) a masthead light abaft of and higher than the all-round green light; a vessel of less than 50 meters in length shall not be obliged to exhibit such a light but may do so;"
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight.",
          "inland": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel engaged in fishing, other than trawling, shall exhibit:",
          "inland": "(c) A vessel engaged in fishing, other than trawling, shall exhibit:"
        },
        {
          "id": "c(i)",
          "scope": "both",
          "international": "(i) two all-round lights in a vertical line, the upper being red and the lower white, or a shape consisting of two cones with their apexes together in a vertical line one above the other;",
          "inland": "(i) two all-round lights in a vertical line, the upper being red and the lower white, or a shape consisting of two cones with their apexes together in a vertical line one above the other;"
        },
        {
          "id": "c(ii)",
          "scope": "both",
          "international": "(ii) when there is outlying gear extending more than 150 meters horizontally from the vessel, an all-round white light or a cone apex upwards in the direction of the gear.",
          "inland": "(ii) when there is outlying gear extending more than 150 meters horizontally from the vessel, an all-round white light or a cone apex upwards in the direction of the gear."
        },
        {
          "id": "c(iii)",
          "scope": "both",
          "international": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight.",
          "inland": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight."
        },
        {
          "id": "d",
          "scope": "international",
          "international": "(d) The additional signals described in Annex II to these Regulations apply to a vessel engaged in fishing in close proximity to other vessels engaged in fishing.",
          "inland": ""
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel when not engaged in fishing shall not exhibit the lights or shapes prescribed in this Rule, but only those prescribed for a vessel of her length. {same as International Rules Annex II} 1| (i) The lights mentioned herein shall, if exhibited in pursuance of Rule 26(d), be placed where they can best be seen. They shall be at least 0.9 meters apart but at a lower level than lights prescribed in Rule 26 (b)(i) and (c)(i). The lights shall be visible all round the horizon at a distance of at least 1 mile but at a lesser distance from the lights prescribed by Rules for fishing vessels. 2|(ii) Signals for trawlers.",
          "inland": "(e) A vessel not engaged in fishing shall not exhibit the lights or shapes prescribed in this Rule, but only those prescribed for a vessel of her length. (f) Additional signals for fishing vessels in close proximity {same as International Rules Annex II} 1| (i) The lights mentioned herein shall be placed where they can best be seen. They shall be at least 0.9 meters apart but at a lower level than lights prescribed in Rule 26. The lights shall be visible all round the horizon at a distance of at least 1 mile but at a lesser distance from the lights prescribed by Rule 26(a)-(c) for fishing vessels. 2|(ii) Signals for trawlers."
        },
        {
          "id": "b1:a",
          "scope": "both",
          "international": "(a)|(1) Vessels of 20 meters or more in length when engaged in trawling, whether using demersal or pelagic gear, shall exhibit:",
          "inland": "(a)|(1) Vessels when engaged in trawling, whether using demersal or pelagic gear, may exhibit:"
        },
        {
          "id": "b1:a(i)",
          "scope": "both",
          "international": "(i)|(A) when shooting their nets: two white lights in a vertical line;",
          "inland": "(i)|(A) when shooting their nets: two white lights in a vertical line;"
        },
        {
          "id": "b1:a(ii)",
          "scope": "both",
          "international": "(ii)|(B) when hauling their nets: one white light over one red light in a vertical line;",
          "inland": "(ii)|(B) when hauling their nets: one white light over one red light in a vertical line;"
        },
        {
          "id": "b1:a(iii)",
          "scope": "both",
          "international": "(iii)|(C) when the net has come fast upon an obstruction: two red lights in a vertical line.",
          "inland": "(iii)|(C) when the net has come fast upon an obstruction: two red lights in a vertical line."
        },
        {
          "id": "b1:b",
          "scope": "both",
          "international": "(b)|(2) A vessel of 20 meters or more in length engaged in pair trawling shall exhibit:",
          "inland": "(b)|(2) Each vessel engaged in pair trawling may exhibit:"
        },
        {
          "id": "b1:b(i)",
          "scope": "both",
          "international": "(i)|(A) by night, a searchlight directed forward and in the direction of the other vessel of the pair;",
          "inland": "(i)|(A) by night, a searchlight directed forward and in the direction of the other vessel of the pair;"
        },
        {
          "id": "b1:b(ii)",
          "scope": "both",
          "international": "(ii)|(B) when shooting or hauling their nets or when their nets have come fast upon an obstruction, the lights prescribed in Rule 26(f) (f)(2)(a)|(f)(ii)(1). 3|(iii) Signals for purse seiners.",
          "inland": "(ii)|(B) when shooting or hauling their nets or when their nets have come fast upon an obstruction, the lights prescribed in Rule 26(f) (f)(2)(a)|(f)(ii)(1). 3|(iii) Signals for purse seiners."
        },
        {
          "id": "b2:a",
          "scope": "both",
          "international": "(a)|(1) Vessels engaged in fishing with purse seine gear may exhibit two yellow lights in a vertical line. These lights shall flash alternately every second and with equal light and occultation theseduration. These lights may be exhibited only when the vessel is hampered by its fishing gear.",
          "inland": "(a)|(1) Vessels engaged in fishing with purse seine gear may exhibit two yellow lights in a vertical line. These lights shall flash alternately every second and with equal light and occultation theseduration. These lights may be exhibited only when the vessel is hampered by its fishing gear."
        }
      ]
    },
    "27": {
      "number": 27,
      "title": "Vessels Not Under Command or Restricted in Their Ability to Maneuver",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel not under command shall exhibit:",
          "inland": "(a) A vessel not under command shall exhibit:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) two all-round red lights in a vertical line where they can best be seen;",
          "inland": "(i) two all-round red lights in a vertical line where they can best be seen;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) two balls or similar shapes in a vertical line where they can best be seen;",
          "inland": "(ii) two balls or similar shapes in a vertical line where they can best be seen;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight.",
          "inland": "(iii) when making way through the water, in addition to the lights prescribed in this §, sidelights and a sternlight."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel restricted in her ability to maneuver, except a vessel engaged in mine clearance operations, shall exhibit:",
          "inland": "(b) A vessel restricted in her ability to maneuver, except a vessel engaged in mine clearance operations, shall exhibit:"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;",
          "inland": "(i) three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) three shapes in a vertical line where they can best be seen. The highest and lowest of these shapes shall be balls and the middle one a diamond.",
          "inland": "(ii) three shapes in a vertical line where they can best be seen. The highest and lowest of these shapes shall be balls and the middle one a diamond."
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) when making way through the water, a masthead light(s), sidelights and a sternlight in addition to the lights prescribed in Rule 27(b)(i);",
          "inland": "(iii) when making way through the water, a masthead light(s), sidelights and a sternlight in addition to the lights prescribed in Rule 27(b)(i);"
        },
        {
          "id": "b(iv)",
          "scope": "both",
          "international": "(iv) when at anchor, in addition to the lights or shapes prescribed in Rule 27(b)(i) and (ii), the light, lights, or shapes prescribed in Rule 30.",
          "inland": "(iv) when at anchor, in addition to the lights or shapes prescribed in Rule 27(b)(i) and (ii), the light, lights, or shapes prescribed in Rule 30."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A power-driven vessel engaged in a towing operation such as severely restricts the towing vessel and her tow in their ability to deviate from their course shall, in addition to the lights or shape prescribed in Rule 24(a), exhibit the lights or shapes prescribed in subparagraphs (b)(i) and (ii) of this Rule.",
          "inland": "(c) A power-driven vessel engaged in a towing operation such as severely restricts the towing vessel and her tow in their ability to deviate from their course shall, in addition to the lights or shape prescribed in Rule 24(a), exhibit the lights or shapes prescribed in subparagraphs (b)(i) and (ii) of this Rule."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) A vessel engaged in dredging or underwater operations, when restricted in her ability to maneuver, shall exhibit the lights and shapes prescribed in Rules 27(b)(i), (ii) and (iii) and shall in addition when an obstruction exists, exhibit:",
          "inland": "(d) A vessel engaged in dredging or underwater operations, when restricted in her ability to maneuver, shall exhibit the lights and shapes prescribed in Rules 27(b)(i), (ii) and (iii) and shall in addition when an obstruction exists, exhibit:"
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(i) two all-round red lights or two balls in a vertical line to indicate the side on which the obstruction exists;",
          "inland": "(i) two all-round red lights or two balls in a vertical line to indicate the side on which the obstruction exists;"
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) two all-round green lights or two diamonds in a vertical line to indicate the side on which another vessel may pass; and",
          "inland": "(ii) two all-round green lights or two diamonds in a vertical line to indicate the side on which another vessel may pass; and"
        },
        {
          "id": "d(iii)",
          "scope": "both",
          "international": "(iii) when at anchor, the lights or shapes prescribed in this paragraph instead of the lights or shapes prescribed in Rule 30.",
          "inland": "(iii) when at anchor, the lights or shapes prescribed in this paragraph instead of the lights or shapes prescribed in Rule 30."
        },
        {
          "id": "d(iv)",
          "scope": "inland",
          "international": "",
          "inland": "(iv) Dredge pipelines that are floating or supported on trestles shall display the following lights at night and in periods of restricted visibility."
        },
        {
          "id": "d(iv)(1)",
          "scope": "inland",
          "international": "",
          "inland": "(1) One row of yellow lights. The lights must be: (A) Flashing 50 to 70 times per minute, (B) Visible all round the horizon, (C) Visible for at least 2 miles, (D) Not less than 1 and not more than 3.5 meters above the water, (E) Approximately equally spaced, and (F) Not more than 10 meters apart where the pipeline crosses a navigable channel. Where the pipeline does not cross a navigable channel the lights must be sufficient in number to clearly show the pipeline’s length and course."
        },
        {
          "id": "d(iv)(2)",
          "scope": "inland",
          "international": "",
          "inland": "(2) Two red lights at each end of the pipeline, including the ends in a channel where the pipeline is separated to allow vessels to pass (whether open or closed). The lights must be: (A) Visible all round the horizon, and (B) Visible for at least 2 miles, and (C) One meter apart in a vertical line with the lower light at the same height above the water as the flashing yellow light."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) Whenever the size of a vessel engaged in diving operations makes it impracticable to exhibit all lights and shapes prescribed in Rule 27(d)(d), the following shall be exhibited:",
          "inland": "(e) Whenever the size of a vessel engaged in diving operations makes it impracticable to exhibit all lights and shapes prescribed in Rule 27(d)(d), the following shall be exhibited:"
        },
        {
          "id": "e(i)",
          "scope": "both",
          "international": "(i) Three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;",
          "inland": "(i) Three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;"
        },
        {
          "id": "e(ii)",
          "scope": "both",
          "international": "(ii) a rigid replica of the International Code flag \"A\" not less than 1 meter in height. Measures shall be taken to ensure its all-round visibility.",
          "inland": "(ii) a rigid replica of the International Code flag \"A\" not less than 1 meter in height. Measures shall be taken to ensure its all-round visibility."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) A vessel engaged in mine clearance operations shall, in addition to the lights prescribed for a power-driven vessel in Rule 23(a) or to the lights or shape prescribed for a vessel at anchor in Rule 30 as appropriate, exhibit three all-round green lights or three balls. One of these lights or shapes shall be exhibited near the foremast head and one at each end of the fore yard. These lights or shapes indicate that it is dangerous for another vessel to approach within 1000 meters of the mine clearance vessel.",
          "inland": "(f) A vessel engaged in mine clearance operations shall, in addition to the lights prescribed for a power-driven vessel in Rule 23(a) or to the lights or shape prescribed for a vessel at anchor in Rule 30 as appropriate, exhibit three all-round green lights or three balls. One of these lights or shapes shall be exhibited near the foremast head and one at each end of the fore yard. These lights or shapes indicate that it is dangerous for another vessel to approach within 1000 meters of the mine clearance vessel."
        },
        {
          "id": "g",
          "scope": "both",
          "international": "(g) Vessels of less than 12 meters in length, except those engaged in diving operations, shall not be required to exhibit the lights and shapes prescribed in this Rule.",
          "inland": "(g) Vessels of less than 12 meters in length, except when engaged in diving operations, is not required to exhibit the lights or shapes prescribed in this Rule."
        },
        {
          "id": "h",
          "scope": "both",
          "international": "(h) The signals prescribed in this Rule are not signals of vessels in distress and requiring assistance. Such signals are contained in Annex IV to these Rules.",
          "inland": "(h) The signals prescribed in this Rule are not signals of vessels in distress and requiring assistance. Such signals are contained in Annex IV to these Rules."
        }
      ]
    },
    "28": {
      "number": 28,
      "title": "Vessels Constrained by Their Draft {International Rules Only}",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "international",
          "international": "A vessel constrained by her draft may, in addition to the lights prescribed for power-driven vessels in Rule 23(a), exhibit where they can best be seen three all-round red lights in a vertical line, or a cylinder.",
          "inland": ""
        }
      ]
    },
    "29": {
      "number": 29,
      "title": "Pilot Vessels",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel engaged on pilotage duty shall exhibit:",
          "inland": "(a) A vessel engaged on pilotage duty shall exhibit:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) at or near the masthead, two all-round lights in a vertical line, the upper being white and the lower red;",
          "inland": "(i) at or near the masthead, two all-round lights in a vertical line, the upper being white and the lower red;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) when underway, in addition, sidelights and a sternlight;",
          "inland": "(ii) when underway, in addition, sidelights and a sternlight;"
        },
        {
          "id": "a(iii)",
          "scope": "both",
          "international": "(iii) when at anchor, in addition to the lights prescribed in Rule 29(a)(i), the light, lights, or shape prescribed in Rule 30 for vessels at anchor.",
          "inland": "(iii) when at anchor, in addition to the lights prescribed in Rule 29(a)(i), the light, lights, or shape prescribed in Rule 30 for vessels at anchor."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A pilot vessel when not engaged on pilotage duty shall exhibit the lights or shapes prescribed for a similar vessel of her length.",
          "inland": "(b) A pilot vessel when not engaged on pilotage duty shall exhibit the lights or shapes prescribed for a similar vessel of her length."
        }
      ]
    },
    "30": {
      "number": 30,
      "title": "Anchored Vessels and Vessels Aground",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel at anchor shall exhibit where it can best be seen:",
          "inland": "(a) A vessel at anchor shall exhibit where it can best be seen:"
        },
        {
          "id": "a(i)",
          "scope": "both",
          "international": "(i) in the fore part, an all-round white light or one ball;",
          "inland": "(i) in the fore part, an all-round white light or one ball;"
        },
        {
          "id": "a(ii)",
          "scope": "both",
          "international": "(ii) at or near the stern and at a lower level than the light prescribed in Rule 30(a)(i), an all-round white light",
          "inland": "(ii) at or near the stern and at a lower level than the light prescribed in Rule 30(a)(i), an all-round white light"
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel of less than 50 meters in length may exhibit an all-round white light where it can best be seen instead of the lights prescribed in Rule 30(a).",
          "inland": "(b) A vessel of less than 50 meters in length may exhibit an all-round white light where it can best be seen instead of the lights prescribed in Rule 30(a)."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel at anchor may, and a vessel of 100 meters and more in length shall, also use the available working or equivalent lights to illuminate her decks.",
          "inland": "(c) A vessel at anchor may, and a vessel of 100 meters and more in length shall, also use the available working or equivalent lights to illuminate her decks."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) A vessel aground shall exhibit the lights prescribed in Rule 30(a) or (b) and in addition, if practicable, where they can best be seen;",
          "inland": "(d) A vessel aground shall exhibit the lights prescribed in Rule 30(a) or (b) and in addition, if practicable, where they can best be seen;"
        },
        {
          "id": "d(i)",
          "scope": "both",
          "international": "(i) two all-round red lights in a vertical line;",
          "inland": "(i) two all-round red lights in a vertical line;"
        },
        {
          "id": "d(ii)",
          "scope": "both",
          "international": "(ii) three balls in a vertical line.",
          "inland": "(ii) three balls in a vertical line."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel of less than 7 meters in length, when at anchor not in or near a narrow channel, fairway or where other vessels normally navigate, shall not be required to exhibit the lights or shape prescribed in Rule 30(a) and (b).",
          "inland": "(e) A vessel of less than 7 meters in length, when at anchor not in or near a narrow channel, fairway or where other vessels normally navigate, shall not be required to exhibit the lights or shape prescribed in Rule 30(a) and (b)."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) A vessel of less than 12 meters in length, when aground, shall not be required to exhibit the lights or shapes prescribed in Rule 30(d)(i) and (ii).",
          "inland": "(f) A vessel of less than 12 meters in length, when aground, shall not be required to exhibit the lights or shapes prescribed in Rule 30(d)(i) and (ii)."
        },
        {
          "id": "g",
          "scope": "inland",
          "international": "",
          "inland": "(g) A vessel of less than 20 meters in length, when at anchor in a special anchorage area designated by the Coast Guard, shall not be required to exhibit the anchor lights and shapes required by this Rule."
        },
        {
          "id": "h",
          "scope": "inland",
          "international": "",
          "inland": "(h) The following barges shall display at night and if practicable in periods of restricted visibility the lights described in Rule 30(i):"
        },
        {
          "id": "h(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) Every barge projecting into a buoyed or restricted channel."
        },
        {
          "id": "h(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) Every barge so moored that it reduces the available navigable width of any channel to less than 80 meters."
        },
        {
          "id": "h(iii)",
          "scope": "inland",
          "international": "",
          "inland": "(iii) Barges moored in groups more than two barges wide or to a maximum width of over 25 meters."
        },
        {
          "id": "h(iv)",
          "scope": "inland",
          "international": "",
          "inland": "(iv) Every barge not moored parallel to the bank or dock."
        },
        {
          "id": "i",
          "scope": "inland",
          "international": "",
          "inland": "(i) Barges described in Rule 30(h) shall carry two unobstructed all-round white lights of an intensity to be visible for at least 1 nautical mile and meeting the technical requirements as prescribed in Annex I."
        },
        {
          "id": "j",
          "scope": "inland",
          "international": "",
          "inland": "(j) A barge or a group of barges at anchor or made fast to one or more mooring buoys or other similar device, in lieu of the provisions of Rule 30, may carry unobstructed all-round white lights of an intensity to be visible for at least 1 nautical mile that meet the requirements of Annex I and shall be arranged as follows:"
        },
        {
          "id": "j(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) Any barge that projects from a group formation, shall be lighted on its outboard corners."
        },
        {
          "id": "j(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) On a single barge moored in water where other vessels normally navigate on both sides of the barge, lights shall be placed to mark the corner extremities of the barge."
        },
        {
          "id": "j(iii)",
          "scope": "inland",
          "international": "",
          "inland": "(iii) On barges moored in group formation, moored in water where other vessels normally navigate on both sides of the group, lights shall be placed to mark the corner extremities of the group."
        },
        {
          "id": "k",
          "scope": "inland",
          "international": "",
          "inland": "(k) The following are exempt from the requirements of Rule 30:"
        },
        {
          "id": "k(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) A barge or group of barges moored in a slip or slough used primarily for mooring purposes."
        },
        {
          "id": "k(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) A barge or group of barges moored behind a pierhead."
        },
        {
          "id": "k(iii)",
          "scope": "inland",
          "international": "",
          "inland": "(iii) A barge less than 20 meters in length when moored in a special anchorage area designated in accordance with 33 CFR 109.10."
        },
        {
          "id": "l",
          "scope": "inland",
          "international": "",
          "inland": "(l) Barges moored in well-illuminated areas are exempt from the lighting requirements of Rule 30. These areas are as follows: CHICAGO SANITARY SHIP CANAL"
        },
        {
          "id": "l(1)",
          "scope": "inland",
          "international": "",
          "inland": "(1) Mile 293.2 to 293.9"
        },
        {
          "id": "l(2)",
          "scope": "inland",
          "international": "",
          "inland": "(2) Mile 295.2 to 296.1"
        },
        {
          "id": "l(3)",
          "scope": "inland",
          "international": "",
          "inland": "(3) Mile 297.5 to 297.8"
        },
        {
          "id": "l(4)",
          "scope": "inland",
          "international": "",
          "inland": "(4) Mile 298 to 298.2"
        },
        {
          "id": "l(5)",
          "scope": "inland",
          "international": "",
          "inland": "(5) Mile 298.6 to 298.8"
        },
        {
          "id": "l(6)",
          "scope": "inland",
          "international": "",
          "inland": "(6) Mile 299.3 to 299.4"
        },
        {
          "id": "l(7)",
          "scope": "inland",
          "international": "",
          "inland": "(7) Mile 299.8 to 300.5"
        },
        {
          "id": "l(8)",
          "scope": "inland",
          "international": "",
          "inland": "(8) Mile 303 to 303.2"
        },
        {
          "id": "l(9)",
          "scope": "inland",
          "international": "",
          "inland": "(9) Mile 303.7 to 303.9"
        },
        {
          "id": "l(10)",
          "scope": "inland",
          "international": "",
          "inland": "(10) Mile 305.7 to 305.8"
        },
        {
          "id": "l(11)",
          "scope": "inland",
          "international": "",
          "inland": "(11) Mile 310.7 to 310.9"
        },
        {
          "id": "l(12)",
          "scope": "inland",
          "international": "",
          "inland": "(12) Mile 311 to 311.2"
        },
        {
          "id": "l(13)",
          "scope": "inland",
          "international": "",
          "inland": "(13) Mile 312.5 to 312.6"
        },
        {
          "id": "l(14)",
          "scope": "inland",
          "international": "",
          "inland": "(14) Mile 313.8 to 314.2"
        },
        {
          "id": "l(15)",
          "scope": "inland",
          "international": "",
          "inland": "(15) Mile 314.6"
        },
        {
          "id": "l(16)",
          "scope": "inland",
          "international": "",
          "inland": "(16) Mile 314.8 to 315.3"
        },
        {
          "id": "l(17)",
          "scope": "inland",
          "international": "",
          "inland": "(17) Mile 315.7 to 316"
        },
        {
          "id": "l(18)",
          "scope": "inland",
          "international": "",
          "inland": "(18) Mile 316.8"
        },
        {
          "id": "l(19)",
          "scope": "inland",
          "international": "",
          "inland": "(19) Mile 316.85 to 317.05"
        },
        {
          "id": "l(20)",
          "scope": "inland",
          "international": "",
          "inland": "(20) Mile 317.5"
        },
        {
          "id": "l(21)",
          "scope": "inland",
          "international": "",
          "inland": "(21) Mile 318.4 to 318.9"
        },
        {
          "id": "l(22)",
          "scope": "inland",
          "international": "",
          "inland": "(22) Mile 318.7 to 318.8"
        },
        {
          "id": "l(23)",
          "scope": "inland",
          "international": "",
          "inland": "(23) Mile 320 to 320.3"
        },
        {
          "id": "l(24)",
          "scope": "inland",
          "international": "",
          "inland": "(24) Mile 320.6"
        },
        {
          "id": "l(25)",
          "scope": "inland",
          "international": "",
          "inland": "(25) Mile 322.3 to 322.4"
        },
        {
          "id": "l(26)",
          "scope": "inland",
          "international": "",
          "inland": "(26) Mile 322.8"
        },
        {
          "id": "l(27)",
          "scope": "inland",
          "international": "",
          "inland": "(27) Mile 322.9 to 327.2 CALUMET SAG CHANNEL"
        },
        {
          "id": "l(28)",
          "scope": "inland",
          "international": "",
          "inland": "(28) Mile 316.5 LITTLE CALUMET RIVER"
        },
        {
          "id": "l(29)",
          "scope": "inland",
          "international": "",
          "inland": "(29) Mile 321.2"
        },
        {
          "id": "l(30)",
          "scope": "inland",
          "international": "",
          "inland": "(30) Mile 322.3 CALUMET RIVER"
        },
        {
          "id": "l(31)",
          "scope": "inland",
          "international": "",
          "inland": "(31) Mile 328.5 to 328.7"
        },
        {
          "id": "l(32)",
          "scope": "inland",
          "international": "",
          "inland": "(32) Mile 329.2 to 329.4"
        },
        {
          "id": "l(33)",
          "scope": "inland",
          "international": "",
          "inland": "(33) Mile 330 west bank to 330.2"
        },
        {
          "id": "l(34)",
          "scope": "inland",
          "international": "",
          "inland": "(34) Mile 331.4 to 331.6"
        },
        {
          "id": "l(35)",
          "scope": "inland",
          "international": "",
          "inland": "(35) Mile 332.2 to 332.4"
        },
        {
          "id": "l(36)",
          "scope": "inland",
          "international": "",
          "inland": "(36) Mile 332.6 to 332.8 CUMBERLAND RIVER"
        },
        {
          "id": "l(37)",
          "scope": "inland",
          "international": "",
          "inland": "(37) Mile 126.8"
        },
        {
          "id": "l(38)",
          "scope": "inland",
          "international": "",
          "inland": "(38) Mile 191"
        }
      ]
    },
    "31": {
      "number": 31,
      "title": "Seaplanes",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "Where it is impracticable for a seaplane or a WIG craft to exhibit lights or shapes of the characteristics or in the positions prescribed in Rules 20-31 she shall exhibit lights and shapes as closely similar in characteristics and position as is possible. PART D - SOUND AND LIGHT SIGNALS",
          "inland": "Where it is impracticable for a seaplane or a WIG craft to exhibit lights or shapes of the characteristics or in the positions prescribed in Rules 20-31 she shall exhibit lights and shapes as closely similar in characteristics and position as is possible. PART D - SOUND AND LIGHT SIGNALS"
        }
      ]
    },
    "32": {
      "number": 32,
      "title": "Definitions",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) The word \"whistle\" means any sound signaling appliance capable of producing the prescribed blasts and which complies with the specifications in Annex III to these Rules.",
          "inland": "(a) The word \"whistle\" means any sound signaling appliance capable of producing the prescribed blasts and which complies with the specifications in Annex III to these Rules."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) The term \"short blast\" means a blast of about one seconds duration.",
          "inland": "(b) The term \"short blast\" means a blast of about one seconds duration."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) The term \"prolonged blast\" means a blast of from four to six seconds duration.",
          "inland": "(c) The term \"prolonged blast\" means a blast of from four to six seconds duration."
        }
      ]
    },
    "33": {
      "number": 33,
      "title": "Equipment for Sound Signals (See also Annex III).",
      "paragraphs": [
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A vessel of 12 meters or more in length shall be provided with a whistle, a vessel of 20 meters or more in length shall be provided with a bell in addition to a whistle, and a vessel of 100 meters or more in length shall, in addition be provided with a gong, the tone and sound of which cannot be confused with that of the bell. The whistle, bell and gong shall comply with the specifications in Annex III to these Regulations. The bell or gong or both may be replaced by other equipment having the same respective sound characteristics, provided that manual sounding of the prescribed signals shall always be possible.",
          "inland": "(a) A vessel of 12 meters or more in length shall be provided with a whistle, a vessel of 20 meters or more in length shall be provided with a bell in addition to a whistle, and a vessel of 100 meters or more in length shall, in addition be provided with a gong, the tone and sound of which cannot be confused with that of the bell. The whistle, bell and gong shall comply with the specifications in Annex III to these Regulations. The bell or gong or both may be replaced by other equipment having the same respective sound characteristics, provided that manual sounding of the prescribed signals shall always be possible."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A vessel of less than 12 meters in length shall not be obliged to carry the sound signaling appliances prescribed in Rule 33(a) but if she does not, she shall be provided with some other means of making an efficient signal.",
          "inland": "(b) A vessel of less than 12 meters in length shall not be obliged to carry the sound signaling appliances prescribed in Rule 33(a) but if she does not, she shall be provided with some other means of making an efficient signal."
        }
      ]
    },
    "34": {
      "number": 34,
      "title": "Maneuvering and Warning Signals",
      "paragraphs": [
        {
          "id": "a",
          "scope": "international",
          "international": "(a) When vessels are in sight of one, a power-driven vessel underway, when maneuvering as authorized or required by these Rules, shall indicate that maneuver by the following signals on her whistle: –One short blasts to mean “I am altering my course to starboard” –Two short blasts to mean “I am altering my course to port” – Three short blasts to mean “I am operating astern propulsion”",
          "inland": ""
        },
        {
          "id": "a",
          "scope": "inland",
          "international": "",
          "inland": "(a) When power-driven vessels are in sight of one another and meeting or crossing at a distance within half a mile of each other, each vessel underway, when maneuvering as authorized or required by these Rules,"
        },
        {
          "id": "a(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) shall indicate that maneuver by the following signals on her whistle: –One short blasts to mean “I intend to leave you on my port side> –Two short blasts to mean “I intend to leave you on my starboard side” – Three short blasts to mean “I am operating astern propulsion”"
        },
        {
          "id": "a(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) upon hearing the one or two blast signal of the other shall, if in agreement, sound the same whistle signal and take the steps necessary to effect a safe passing. If, however, from any cause, the vessel doubts the safety of the proposed maneuver, she shall sound the signal specified in Rule 34(d) and each vessel shall take appropriate precautionary action until a safe passing agreement is made."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) Any vessel may supplement the whistle signals prescribed in Rule 34(a) by light signals, repeated as appropriate, while the maneuver is being carried out:",
          "inland": "(b) A vessel may supplement the whistle signals prescribed in Rule 34(a) by light signals,"
        },
        {
          "id": "b(i)",
          "scope": "both",
          "international": "(i) these signals shall have the following significance:",
          "inland": "(i) these signals shall have the following significance:"
        },
        {
          "id": "b(ii)",
          "scope": "both",
          "international": "(ii) the duration of each flash shall be about one second, the interval between flashes shall be about one second, and the interval between successive signals shall not be less than ten seconds",
          "inland": "(ii) the duration of each flash shall be about one second"
        },
        {
          "id": "b(iii)",
          "scope": "both",
          "international": "(iii) the light used for this signal shall, if fitted, be an all-round white, visible at a minimum range of 5 miles, and shall comply with the provisions of Annex I to these Regulations. –One flash to mean “I am altering my course to starboard” –Two flashes to mean “I am altering my course to port” –Three flashes to mean “I am operating astern propulsion”",
          "inland": "(iii) the light used for this signal shall, if fitted, be an all-round white or yellow, visible at a minimum range of 2 miles, synchronized with the whistle and shall comply with the provisions of Annex I to these Regulations. –One flash to mean “I intend to leave you on my port side” –Two flashes to mean “I intend to leave you on my starboard side” –Three flashes to mean “I am operating astern propulsion”"
        },
        {
          "id": "c",
          "scope": "international",
          "international": "(c) When in sight of one another in a narrow channel or fairway:",
          "inland": ""
        },
        {
          "id": "c(i)",
          "scope": "international",
          "international": "(i) a vessel intending to overtake another shall in compliance with Rule 9(e)(i) indicate her intention by the following signals on her whistle: –two prolonged blasts followed by one short blast to mean \"I intend to overtake you on your starboard side\" –two prolonged blasts followed by two short blasts to mean \"I intend to overtake you on your port side\"",
          "inland": ""
        },
        {
          "id": "c",
          "scope": "inland",
          "international": "",
          "inland": "(c) When in sight of one another:"
        },
        {
          "id": "c(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) a power-driven vessel intending to overtake another power-driven vessel shall indicate her intention by the following signals on her whistle: –one short blast to mean \"I intend to overtake you on your starboard side\" –two short blasts to mean \"I intend to overtake you on your port side\""
        },
        {
          "id": "c(ii)",
          "scope": "international",
          "international": "(ii) the vessel about to be overtaken when acting in accordance with Rule 9(e)(i) shall indicate her agreement by the following signal on her whistle: –one prolonged, one short, one prolonged and one short blast, in that order.",
          "inland": ""
        },
        {
          "id": "c(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) the power-driven vessel about to be overtaken shall, if in agreement, sound a similar sound signal. If in doubt she shall sound the signal prescribed in Rule 34(d)."
        },
        {
          "id": "d",
          "scope": "both",
          "international": "(d) When vessels in sight of one another are approaching each other and from any cause either vessel fails to understand the intentions or actions of the other, or is in doubt whether sufficient action is being taken by the other to avoid collision, the vessel in doubt shall immediately indicate such doubt by giving at least five short and rapid blasts on the whistle. Such signal may be supplemented by at least five short and rapid flashes.",
          "inland": "(d) When vessels in sight of one another are approaching each other and from any cause either vessel fails to understand the intentions or actions of the other, or is in doubt whether sufficient action is being taken by the other to avoid collision, the vessel in doubt shall immediately indicate such doubt by giving at least five short and rapid blasts on the whistle. Such signal may be supplemented by at least five short and rapid flashes."
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel nearing a bend or an area of a channel or fairway where other vessels may be obscured by an intervening obstruction shall sound one prolonged blast. This signal shall be answered with a prolonged blast by any approaching vessel that may be within hearing around the bend or behind the intervening obstruction.",
          "inland": "(e) A vessel nearing a bend or an area of a channel or fairway where other vessels may be obscured by an intervening obstruction shall sound one prolonged blast. This signal shall be answered with a prolonged blast by any approaching vessel that may be within hearing around the bend or behind the intervening obstruction."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) If whistles are fitted on a vessel at a distance apart of more than 100 meters, one whistle only shall be used for giving maneuvering and warning signals.",
          "inland": "(f) If whistles are fitted on a vessel at a distance apart of more than 100 meters, one whistle only shall be used for giving maneuvering and warning signals."
        },
        {
          "id": "g",
          "scope": "inland",
          "international": "",
          "inland": "(g) When a power-driven vessel is leaving a dock or berth, she shall sound one prolonged blast."
        },
        {
          "id": "h",
          "scope": "inland",
          "international": "",
          "inland": "(h) A vessel that reaches agreement with another vessel in a head-on, crossing, or overtaking situation, as for example, by using the radiotelephone as prescribed by the Vessel Bridge-to-Bridge Radiotelephone Act (85 Stat. 164; 33 U.S.C. 1201 et seq.), is not obliged to sound the whistle signals prescribed by this Rule, but may do so. If agreement is not reached, then whistle signals shall be exchanged in a timely manner and shall prevail."
        }
      ]
    },
    "35": {
      "number": 35,
      "title": "Sound Signals in Restricted Visibility",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "In or near an area of restricted visibility, whether by day or night the signals prescribed in this Rule shall be used as follows:",
          "inland": "In or near an area of restricted visibility, whether by day or night the signals prescribed in this Rule shall be used as follows:"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) A power-driven vessel making way through the water shall sound at intervals of not more than 2 minutes one prolonged blast.",
          "inland": "(a) A power-driven vessel making way through the water shall sound at intervals of not more than 2 minutes one prolonged blast."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) A power-driven vessel underway but stopped and making no way through the water shall sound at intervals of no more than 2 minutes two prolonged blasts in succession with an interval of about 2 seconds between them.",
          "inland": "(b) A power-driven vessel underway but stopped and making no way through the water shall sound at intervals of no more than 2 minutes two prolonged blasts in succession with an interval of about 2 seconds between them."
        },
        {
          "id": "c",
          "scope": "both",
          "international": "(c) A vessel not under command, a vessel restricted in her ability to maneuver, a vessel constrained by her draft, a sailing vessel, a vessel engaged in fishing and a vessel engaged in towing or pushing another vessel shall, instead of the signals prescribed in Rule 35(a) or (b), sound at intervals of not more than 2 minutes three blasts in succession, namely one prolonged followed by two short blasts.",
          "inland": "(c) A vessel not under command, a vessel restricted in her ability to maneuver whether underway or at anchor,, a sailing vessel, a vessel engaged in fishing and a vessel engaged in towing or pushing another vessel shall, instead of the signals prescribed in Rule 35(a) or (b), sound at intervals of not more than 2 minutes three blasts in succession, namely one prolonged followed by two short blasts."
        },
        {
          "id": "d",
          "scope": "international",
          "international": "(d) A vessel engaged in fishing, when at anchor, and a vessel restricted in her ability to maneuver when carrying out her work at anchor, shall instead of the signals prescribed in Rule 35(g) sound the signal prescribed in Rule 35(c).",
          "inland": ""
        },
        {
          "id": "e",
          "scope": "both",
          "international": "(e) A vessel towed or if more than one vessel is towed the last vessel of the tow, if manned, shall at intervals of not more than 2 minutes sound four blasts in succession, namely one prolonged followed by three short blasts. When practicable, this signal shall be made immediately after the signal made by the towing vessel.",
          "inland": "(e) A vessel towed or if more than one vessel is towed the last vessel of the tow, if manned, shall at intervals of not more than 2 minutes sound four blasts in succession, namely one prolonged followed by three short blasts. When practicable, this signal shall be made immediately after the signal made by the towing vessel."
        },
        {
          "id": "f",
          "scope": "both",
          "international": "(f) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and shall give the signals prescribed in Rule 35(a) or (b).",
          "inland": "(f) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and shall give the signals prescribed in Rule 35(a) or (b)."
        },
        {
          "id": "g",
          "scope": "both",
          "international": "(g) A vessel at anchor shall at intervals of not more than 1 minute ring the bell rapidly for about 5 seconds. In a vessel 100 meters or more in length the bell shall be sounded in the forepart of the vessel and immediately after the ringing of the bell the gong shall be sounded rapidly for about 5 seconds in the after part of the vessel. A vessel at anchor may in addition sound three blasts in succession, namely one short, one prolonged and one short blast, to give warning of her position and of the possibility of collision to an approaching vessel.",
          "inland": "(g) A vessel at anchor shall at intervals of not more than 1 minute ring the bell rapidly for about 5 seconds. In a vessel 100 meters or more in length the bell shall be sounded in the forepart of the vessel and immediately after the ringing of the bell the gong shall be sounded rapidly for about 5 seconds in the after part of the vessel. A vessel at anchor may in addition sound three blasts in succession, namely one short, one prolonged and one short blast, to give warning of her position and of the possibility of collision to an approaching vessel."
        },
        {
          "id": "h",
          "scope": "both",
          "international": "(h) A vessel aground shall give the bell signal and if required the gong signal prescribed in Rule 35(g) and shall, in addition, give three separate and distinct strokes on the bell immediately before and after the rapid ringing of the bell. A vessel aground may in addition sound an appropriate whistle signal.",
          "inland": "(h) A vessel aground shall give the bell signal and if required the gong signal prescribed in Rule 35(g) and shall, in addition, give three separate and distinct strokes on the bell immediately before and after the rapid ringing of the bell. A vessel aground may in addition sound an appropriate whistle signal."
        },
        {
          "id": "i",
          "scope": "both",
          "international": "(i) A vessel of 12 meters or more but less than 20 meters in length shall not be obliged to give the bell signals prescribed in Rule 35(g) and (h). However, if she does not, she shall make some other efficient sound signal at intervals of not more than 2 minutes.",
          "inland": "(i) A vessel of 12 meters or more but less than 20 meters in length shall not be obliged to give the bell signals prescribed in Rule 35(g) and (h). However, if she does not, she shall make some other efficient sound signal at intervals of not more than 2 minutes."
        },
        {
          "id": "j",
          "scope": "both",
          "international": "(j) A vessel of less than 12 meters in length shall not be obliged to give the above mentioned signals but, if she does not, shall make some other efficient sound signal at intervals of not more than 2 minutes.",
          "inland": "(j) A vessel of less than 12 meters in length shall not be obliged to give the above mentioned signals but, if she does not, shall make some other efficient sound signal at intervals of not more than 2 minutes."
        },
        {
          "id": "k",
          "scope": "both",
          "international": "(k) A pilot vessel when engaged on pilotage duty may, in addition to the signals prescribed in Rule 35(a), (b) or (g), sound an identity signal consisting of four short blasts.",
          "inland": "(k) A pilot vessel when engaged on pilotage duty may, in addition to the signals prescribed in Rule 35(a), (b) or (g), sound an identity signal consisting of four short blasts."
        },
        {
          "id": "l",
          "scope": "inland",
          "international": "",
          "inland": "(l) The following vessels shall not be required to sound signals as prescribed in Rule 35(g) when anchored in a special anchorage area designated by the Coast Guard:"
        },
        {
          "id": "l(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) a vessel of less than 20 meters in length; and"
        },
        {
          "id": "l(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) a barge, canal boat, scow, or other nondescript craft."
        }
      ]
    },
    "36": {
      "number": 36,
      "title": "Signals to Attract Attention",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "If necessary to attract the attention of another vessel, any vessel may make light or sound signals that cannot be mistaken for any signal authorized elsewhere in these Rules, or may direct the beam of her searchlight in the direction of the danger, in such a way as not to embarrass any vessel. Any light to attract the attention of another vessel shall be such that it cannot be mistaken for any aid to navigation. For the purpose of this Rule the use of high intensity intermittent or revolving lights, such as strobe lights, shall be avoided.",
          "inland": "If necessary to attract the attention of another vessel, any vessel may make light or sound signals that cannot be mistaken for any signal authorized elsewhere in these Rules, or may direct the beam of her searchlight in the direction of the danger, in such a way as not to embarrass any vessel."
        }
      ]
    },
    "37": {
      "number": 37,
      "title": "Distress Signals",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "When a vessel is in distress and requires assistance she shall use or exhibit the signals described in Annex IV to these Rules.",
          "inland": "When a vessel is in distress and requires assistance she shall use or exhibit the signals described in Annex IV to these Rules."
        }
      ]
    },
    "38": {
      "number": 38,
      "title": "Exemptions",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "international",
          "international": "Any vessel (or class of vessel) provided that she complies with the requirements of — the International Regulations for the Preventing of Collisions at Sea, 1960, the keel of which is laid or is at a corresponding stage of construction before the entry into force of these Regulations may be exempted from compliance therewith as follows:",
          "inland": ""
        },
        {
          "id": "x1",
          "scope": "inland",
          "international": "",
          "inland": "Any vessel or class of vessels, the keel of which was laid or which is at a corresponding stage of construction before December 24, 1980, provided that she complies with the requirements of —"
        },
        {
          "id": "a",
          "scope": "international",
          "international": "(a) The installation of lights with ranges prescribed in Rule 22, until 4 years after the date of entry into force of these Regulations.",
          "inland": ""
        },
        {
          "id": "a",
          "scope": "inland",
          "international": "",
          "inland": "(a) The Act of June 7, 1897 (30 Stat. 96), as amended (33 U.S.C. 154-232) for vessels navigating the waters subject to that statute;"
        },
        {
          "id": "b",
          "scope": "inland",
          "international": "",
          "inland": "(b) §4233 of the Revised Statutes (33 U.S.C. 301-356) for vessels navigating the waters subject to that statute;"
        },
        {
          "id": "c",
          "scope": "international",
          "international": "(c) The repositioning of lights as a result of conversion from Imperial to metric units and rounding off measurement figures, permanent exemption.",
          "inland": ""
        },
        {
          "id": "c",
          "scope": "inland",
          "international": "",
          "inland": "(c) The Act of February 8, 1895 (28 Stat. 645), as amended (33 U.S.C. 241-295) for vessels navigating the waters subject to that statute; or"
        },
        {
          "id": "d",
          "scope": "international",
          "international": "(d)",
          "inland": ""
        },
        {
          "id": "d(i)",
          "scope": "international",
          "international": "(i) The repositioning of masthead lights on vessels of less than 150 meters in length, resulting from the prescriptions of §3(a) of Annex I to these Regulations, permanent exemption.",
          "inland": ""
        },
        {
          "id": "d(ii)",
          "scope": "international",
          "international": "(ii) The repositioning of masthead lights on vessels of 150 meters or more in length, resulting from the prescriptions of §3(a) of Annex I to these Regulations, until 9 years after the date of entry into force of these Regulations.",
          "inland": ""
        },
        {
          "id": "d",
          "scope": "inland",
          "international": "",
          "inland": "(d) §§3, 4, and 5 of the Act of April 25, 1940 (54 Stat. 163), as amended (46 U.S.C. 526 b, c, and d) for motorboats navigating the waters subject to that statute; shall be exempted from compliance with the technical Annexes to these Rules as follows:"
        },
        {
          "id": "d(i)",
          "scope": "inland",
          "international": "",
          "inland": "(i) The installation of lights with ranges prescribed in Rule 22, vessels of less than 20 meters in length are permanently exempt;"
        },
        {
          "id": "d(ii)",
          "scope": "inland",
          "international": "",
          "inland": "(ii) The installation of lights with color specifications as prescribed in §7 of Annex I to these Rules, until 4 years after the effective date of the Inland Navigational Rules Act of 1980 (Pub. L. 96-591), except that vessels of less than 20 meters in length are permanently exempt;"
        },
        {
          "id": "d(iii)",
          "scope": "inland",
          "international": "",
          "inland": "(iii) The repositioning of lights as a result of a conversion to metric units and rounding off of measurement figures, are permanently exempt."
        },
        {
          "id": "d(iv)",
          "scope": "inland",
          "international": "",
          "inland": "(iv) The horizontal repositioning of masthead lights prescribed by Annex I to these Rules, vessels of less than 150 meters in length are permanently exempted."
        },
        {
          "id": "d(v)",
          "scope": "inland",
          "international": "",
          "inland": "(v) Power-driven vessels of 12 meters or more but less than 20 meters in length are permanently exempt from the provisions of Rule 23(a)(i) and Rule 23(a)"
        },
        {
          "id": "d(iv)",
          "scope": "inland",
          "international": "",
          "inland": "(iv) provided that, in place of these lights, the vessel exhibits a white light aft visible all-around the horizon."
        },
        {
          "id": "e",
          "scope": "international",
          "international": "(e) The repositioning of masthead lights resulting from the prescriptions of §2(b) of Annex I to these Regulations, until 9 years after the date of entry into force of these Regulations.",
          "inland": ""
        },
        {
          "id": "f",
          "scope": "international",
          "international": "(f) The repositioning of sidelights resulting from the prescriptions of §2(g) and 3(b) of Annex I to these Regulations, until 9 years after the date of entry into force of these Regulations.",
          "inland": ""
        },
        {
          "id": "g",
          "scope": "international",
          "international": "(g) The requirements for sound signal appliances prescribed in Annex II to these Regulations, until 9 years after the date of entry into force of these Regulations.",
          "inland": ""
        },
        {
          "id": "h",
          "scope": "international",
          "international": "(h) The repositioning of all-round lights resulting from the prescription of §9(b) of Annex I to these Regulations, permanent exemption.",
          "inland": ""
        }
      ]
    },
    "39": {
      "number": 39,
      "title": "Definitions",
      "paragraphs": [
        {
          "id": "a",
          "scope": "international",
          "international": "(a) \"Audit\" means a systematic, independent and documented process for obtaining audit evidence and evaluating it objectively to determine the extent to which audit criteria are fulfilled.",
          "inland": ""
        },
        {
          "id": "b",
          "scope": "international",
          "international": "(b) \"Audit Scheme\" means the IMO {International Maritime Organization} Member State Audit Scheme established by the Organization and taking into account the guidelines developed by the Organization*.",
          "inland": ""
        },
        {
          "id": "c",
          "scope": "international",
          "international": "(c) \"Code for Implementation\" means the IMO {International Maritime Organization} Instruments Implementation Code (III Code) adopted by the Organization by resolution A.1070(28).",
          "inland": ""
        },
        {
          "id": "d",
          "scope": "international",
          "international": "(d) \"Audit Standard\" means the Code for Implementation.",
          "inland": ""
        }
      ]
    },
    "40": {
      "number": 40,
      "title": "Application",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "international",
          "international": "Contracting Parties shall use the provisions of the Code for Implementation in the execution of their obligations and responsibilities contained in the present Convention.",
          "inland": ""
        }
      ]
    },
    "41": {
      "number": 41,
      "title": "Verification of compliance",
      "paragraphs": [
        {
          "id": "a",
          "scope": "international",
          "international": "(a) Every Contracting Party shall be subject to periodic audits by the Organization in accordance with the audit standard to verify compliance with and implementation of the present Convention.",
          "inland": ""
        },
        {
          "id": "b",
          "scope": "international",
          "international": "(b) The Secretary-General of the Organization shall have responsibility for administering the Audit Scheme, based on the guidelines developed by the Organization*.",
          "inland": ""
        },
        {
          "id": "c",
          "scope": "international",
          "international": "(c) Every Contracting Party shall have responsibility for facilitating the conduct of the audit and implementation of a programme of actions to address the findings, based on the guidelines developed by the Organization*.",
          "inland": ""
        },
        {
          "id": "d",
          "scope": "international",
          "international": "(d) Audit of all Contracting Parties shall be:",
          "inland": ""
        },
        {
          "id": "d(i)",
          "scope": "international",
          "international": "(i) based on an overall schedule developed by the Secretary-General of the Organization, taking into account the guidelines developed by the Organization*; and",
          "inland": ""
        },
        {
          "id": "d(ii)",
          "scope": "international",
          "international": "(ii) conducted at periodic intervals, taking into account the guidelines developed by the Organization*. __________________ * Refer to the Framework and Procedures for the IMO Member State Audit Scheme, adopted by the Organization by resolution A.1067(28). ANNEXES",
          "inland": ""
        }
      ]
    },
    "101": {
      "number": 101,
      "title": "Positioning and Technical Details of Lights and Shapes (33 CFR 84)",
      "label": "Annex I",
      "paragraphs": [
        {
          "id": "s1:a",
          "scope": "both",
          "international": "(a) The term “height above the hull” means height above the uppermost continuous deck. This height shall be measured from the position vertically beneath the location of the light.",
          "inland": "(a) The term “height above the hull” means height above the uppermost continuous deck. This height shall be measured from the position vertically beneath the location of the light."
        },
        {
          "id": "s1:b",
          "scope": "inland",
          "international": "",
          "inland": "(b) High-speed craft means a craft capable of maximum speed in meters per second (m/s) equal to or exceeding: 3.7∇0.1667; where ∇ = displacement corresponding to the design waterline (cubic meters). Note: The same formula expressed in pounds and knots is maximum speed in knots (kts) equal to exceeding 1.98(lbs) 3.7∇0.1667; where ∇=displacement corresponding to design waterline in pounds."
        },
        {
          "id": "s1:c",
          "scope": "inland",
          "international": "",
          "inland": "(c) The term “practical cut-off” means, for vessels 20 meters or more in length, 12.5 percent of the minimum luminous intensity (Table 14(b)) corresponding to the greatest range of visibility for which the requirements of Annex I are met."
        },
        {
          "id": "s1:d",
          "scope": "inland",
          "international": "",
          "inland": "(d) The term “Rule” or “Rules” has the same meaning as in Rule 3(r)."
        },
        {
          "id": "s2:a",
          "scope": "both",
          "international": "(a) On a power-driven vessel of 20 meters or more in length the masthead light shall be placed as follows:",
          "inland": "(a) On a power-driven vessel of 20 meters or more in length the masthead light shall be placed as follows:"
        },
        {
          "id": "s2:a(i)",
          "scope": "both",
          "international": "(i) The forward masthead light, or if only one masthead light is carried, then that light, at a height above the hull of not less than 6 meters, and, if the breadth of the vessel exceeds 6 meters, then at a height above the hull not less than such breadth, so however that the light need not be placed at a greater height above the hull than 12 meters;",
          "inland": "(i) The forward masthead light, or if only one masthead light is carried, then that light, at a height above the hull of not less than 5 meters, and, if the breadth of the vessel exceeds 5 meters, then at a height above the hull not less than such breadth, so however that the light need not be placed at a greater height above the hull than 8 meters;"
        },
        {
          "id": "s2:a(ii)",
          "scope": "both",
          "international": "(ii) when two masthead lights are carried the after one shall be at least 4.5 meters vertically higher than the forward one.",
          "inland": "(ii) when two masthead lights are carried the after one shall be at least 2 meters vertically higher than the forward one."
        },
        {
          "id": "s2:b",
          "scope": "both",
          "international": "(b) The vertical separation of the masthead lights of power-driven vessels shall be such that in all normal conditions of trim the after light will be seen over and separate from the forward light at a distance of 1000 meters from the stem when viewed from sea level.",
          "inland": "(b) The vertical separation of the masthead lights of power-driven vessels shall be such that in all normal conditions of trim the after light will be seen over and separate from the forward light at a distance of 1000 meters from the stem when viewed from water level."
        },
        {
          "id": "s2:c",
          "scope": "both",
          "international": "(c) The masthead light of a power-driven vessel of 12 meters but less than 20 meters in length shall be placed at a height above the gunwale of not less than 2.5 meters.",
          "inland": "(c) The masthead light of a power-driven vessel of 12 meters but less than 20 meters in length shall be placed at a height above the gunwale of not less than 2.5 meters."
        },
        {
          "id": "s2:d",
          "scope": "international",
          "international": "(d) A power-driven vessel of less than 12 meters in length may carry the uppermost light at a height of less than 2.5 meters above the gunwale. When, however, a masthead light is carried in addition to sidelights and a sternlight or the all-round light prescribed in Rule 23(d)(i) is carried in addition to sidelights, then such masthead light or all-round light shall be carried at least 1 meter higher than the sidelights.",
          "inland": ""
        },
        {
          "id": "s2:d",
          "scope": "inland",
          "international": "",
          "inland": "(d) The masthead light, or the all-round light described in Rule 23(d), of a power-driven vessel of less than 12 meters in length shall be carried at least 1 meter higher than the sidelights."
        },
        {
          "id": "s2:e",
          "scope": "both",
          "international": "(e) One of the two or three masthead lights prescribed for a power-driven vessel when engaged in towing or pushing another vessel shall be placed in the same position as either the forward masthead light or the after masthead light, provided that, if carried on the after mast, the lowest after masthead light shall be at least 4.5 meters vertically higher than the forward masthead light.",
          "inland": "(e) One of the two or three masthead lights prescribed for a power-driven vessel when engaged in towing or pushing another vessel shall be placed in the same position as either the forward masthead light or the after masthead light, provided that the lowest after masthead light shall be at least 2 meters vertically higher than the highest forward masthead light."
        },
        {
          "id": "s2:f(i)",
          "scope": "both",
          "international": "(f)(i) The masthead lights or lights prescribed in Rule 23(a) shall be so placed as to be above and clear of all other lights and obstructions except as described in §(f)(ii).",
          "inland": "(f)(i) The masthead lights or lights prescribed in Rule 23(a) shall be so placed as to be above and clear of all other lights and obstructions except as described in §(f)(ii)."
        },
        {
          "id": "s2:f(ii)",
          "scope": "both",
          "international": "(ii) When it is impracticable to carry the all-round lights prescribed by Rule 27(b)(i) or Rule 28 below the masthead lights, they may be carried above the after masthead light(s) or vertically in between the forward masthead light(s) and after masthead light(s), provided that in the latter case the requirement of §3(c) shall be complied with.",
          "inland": "(ii) When it is impracticable to carry the all-round lights prescribed by Rule 27(b)(i) below the masthead lights, they may be carried above the after masthead light(s) or vertically in between the forward masthead light(s) and after masthead light(s), provided that in the latter case the requirement of §3(c) shall be complied with."
        },
        {
          "id": "s2:g",
          "scope": "both",
          "international": "(g) The sidelights of a power-driven vessel shall be placed at a height above the hull not greater than three quarters of that of « least one meter lower than » the forward masthead light. They shall not be so low as to be interfered with by deck lights.",
          "inland": "(g) The sidelights of a power-driven vessel shall be placed at « least one meter lower than » the forward masthead light. They shall not be so low as to be interfered with by deck lights."
        },
        {
          "id": "s2:h",
          "scope": "international",
          "international": "(h) The sidelights, if in a combined lantern and carried on a power-driven vessel of less than 20 meters in length, shall be placed not less than 1 meter below the masthead light.",
          "inland": ""
        },
        {
          "id": "s2:i",
          "scope": "both",
          "international": "(i) When the Rules prescribe two or three lights to be carried in a vertical line, they shall be spaced as follows:",
          "inland": "(i) When the Rules prescribe two or three lights to be carried in a vertical line, they shall be spaced as follows:"
        },
        {
          "id": "s2:i(i)",
          "scope": "both",
          "international": "(i) On a vessel of 20 meters in length or more such lights shall be spaced not less than 2 meter apart, and the lowest of these lights shall, except where a towing light is required, be placed at a height of not less than 4 meters above the hull.",
          "inland": "(i) On a vessel of 20 meters in length or more such lights shall be spaced not less than 1 meter apart, and the lowest of these lights shall, except where a towing light is required, be placed at a height of not less than 4 meters above the hull."
        },
        {
          "id": "s2:i(ii)",
          "scope": "both",
          "international": "(ii) On a vessel of less than 20 meters in length such lights shall be spaced not less than 1 meter apart and the lowest of these lights shall, except where a towing light is required, be placed at a height of not less than 2 meters above the gunwale.",
          "inland": "(ii) On a vessel of less than 20 meters in length such lights shall be spaced not less than 1 meter apart and the lowest of these lights shall, except where a towing light is required, be placed at a height of not less than 2 meters above the gunwale."
        },
        {
          "id": "s2:i(iii)",
          "scope": "both",
          "international": "(iii) When three lights are carried they shall be equally spaced.",
          "inland": "(iii) When three lights are carried they shall be equally spaced."
        },
        {
          "id": "s2:j",
          "scope": "both",
          "international": "(j) The lower of the two all-round lights prescribed for a vessel when engaged in fishing shall be at a height above the sidelights not less than twice the distance between the two vertical lights.",
          "inland": "(j) The lower of the two all-round lights prescribed for a vessel when engaged in fishing shall be at a height above the sidelights not less than twice the distance between the two vertical lights."
        },
        {
          "id": "s2:k",
          "scope": "both",
          "international": "(k) The forward anchor light prescribed in Rule 30(a)(i), when two are carried, shall not be less than 4.5 meters above the after one. On a vessel of 50 meters or more in length this forward anchor light shall be placed at a height or not less than 6 meters above the hull.",
          "inland": "(k) The forward anchor light prescribed in Rule 30(a)(i), when two are carried, shall not be less than 4.5 meters above the after one. On a vessel of 50 meters or more in length this forward anchor light shall be placed at a height or not less than 6 meters above the hull."
        },
        {
          "id": "s3:a",
          "scope": "both",
          "international": "(a) Except as specified in §(e), when two masthead lights are prescribed for a power-driven vessel, the horizontal distance between them shall not be less than one quarter of the length of the vessel but need not be more than 50 meters. The forward light shall be placed not more than one half of the length of the vessel from the stem.",
          "inland": "(a) Except as specified in §(e), when two masthead lights are prescribed for a power-driven vessel, the horizontal distance between them must not be less than one quarter of the length of the vessel but need not be more than 50 meters. The forward light must be placed not more than one half of the length of the vessel from the stem."
        },
        {
          "id": "s3:b",
          "scope": "both",
          "international": "(b) On a power-driven vessel of 20 meters or more in length the sidelights shall not be placed in front of the forward masthead lights. They shall be placed at or near the side of the vessel.",
          "inland": "(b) On a power-driven vessel of 20 meters or more in length the sidelights shall not be placed in front of the forward masthead lights. They shall be placed at or near the side of the vessel."
        },
        {
          "id": "s3:c",
          "scope": "both",
          "international": "(c) When the lights prescribed in Rule 27(b)(i) are placed vertically between the forward masthead light(s) and the after masthead light(s), these all-round lights shall be placed at a horizontal distance of not less than 2 meters from the fore and aft centerline of the vessel in the athwartship direction.",
          "inland": "(c) When the lights prescribed in Rule 27(b)(i) are placed vertically between the forward masthead light(s) and the after masthead light(s), these all-round lights shall be placed at a horizontal distance of not less than 2 meters from the fore and aft centerline of the vessel in the athwartship direction."
        },
        {
          "id": "s3:d",
          "scope": "both",
          "international": "(d) When only one masthead light is prescribed for a power-driven vessel, this light shall be exhibited forward of amidships. For a vessel of less than 20 meters in length, the vessel shall exhibit one masthead light as far forward as is practicable.",
          "inland": "(d) When only one masthead light is prescribed for a power-driven vessel, this light must be exhibited forward of amidships. For a vessel of less than 20 meters in length, the vessel shall exhibit one masthead light as far forward as is practicable. On power-driven vessels 50 meters but less than 60 meters in length operated on the Western Rivers, and those {waters specified by the Secretary}, the horizontal distance between masthead lights shall not be less than 10 meters."
        },
        {
          "id": "s4:a",
          "scope": "both",
          "international": "(a) The light indicating the direction of the outlying gear from a vessel engaged in fishing as prescribed in Rule 26(c)(ii) shall be placed at a horizontal distance of not less than 2 meters and not more than 6 meters away from the two all-round red and white lights. This light shall be placed not higher than the all-round white light prescribed in Rule 26(c)(i) and not lower than the sidelights.",
          "inland": "(a) The light indicating the direction of the outlying gear from a vessel engaged in fishing as prescribed in Rule 26(c)(ii) shall be placed at a horizontal distance of not less than 2 meters and not more than 6 meters away from the two all-round red and white lights. This light shall be placed not higher than the all-round white light prescribed in Rule 26(c)(i) and not lower than the sidelights."
        },
        {
          "id": "s4:b",
          "scope": "both",
          "international": "(b) The lights and shapes on a vessel engaged in dredging or underwater operations to indicate the obstructed side and/or the side on which it is safe to pass, as prescribed in Rule 27(d)(i) and (ii), shall be placed at the maximum practical horizontal distance, but in no case less than 2 meters, from the lights or shapes prescribed in Rule 27(b)(i) and (ii). In no case shall the upper of these lights or shapes be at a greater height than the lower of the three lights or shapes prescribed in Rule 27(b)(i) and (ii).",
          "inland": "(b) The lights and shapes on a vessel engaged in dredging or underwater operations to indicate the obstructed side and/or the side on which it is safe to pass, as prescribed in Rule 27(d)(i) and (ii), shall be placed at the maximum practical horizontal distance, but in no case less than 2 meters, from the lights or shapes prescribed in Rule 27(b)(i) and (ii). In no case shall the upper of these lights or shapes be at a greater height than the lower of the three lights or shapes prescribed in Rule 27(b)(i) and (ii)."
        },
        {
          "id": "s5:a",
          "scope": "both",
          "international": "(a) The sidelights of vessels of 20 meters or more in length shall be fitted with inboard screens painted matte black, and meeting the requirements of §9|15. On vessels of less than 20 meters in length, the sidelights, if necessary to meet the requirements of §9|15, shall be fitted with inboard matte black screens. With a combined lantern, using a single vertical filament and a very narrow division between the green and red sections, external screens need not be fitted.",
          "inland": "(a) The sidelights of vessels of 20 meters or more in length shall be fitted with matte black, inboard screens and meet the requirements of §9|15. On vessels of less than 20 meters in length, the sidelights, if necessary to meet the requirements of §9|15, shall be fitted with matte black inboard screens. With a combined lantern, using a single vertical filament and a very narrow division between the green and red sections, external screens need not be fitted."
        },
        {
          "id": "s5:b",
          "scope": "inland",
          "international": "",
          "inland": "(b) On power-driven vessels less than 12 meters in length constructed after July 31, 1983, the masthead light, or the all-round light described in Rule 23(d) shall be screened to prevent direct illumination of the vessel forward of the operator’s position."
        },
        {
          "id": "s6:a",
          "scope": "both",
          "international": "(a) Shapes shall be black and of the following sizes:",
          "inland": "(a) Shapes shall be black and of the following sizes:"
        },
        {
          "id": "s6:a(i)",
          "scope": "both",
          "international": "(i) A ball shall have a diameter of not less than 0.6 meter;",
          "inland": "(i) A ball shall have a diameter of not less than 0.6 meter;"
        },
        {
          "id": "s6:a(ii)",
          "scope": "both",
          "international": "(ii) a cone shall have a base diameter of not less than 0.6 meter and a height equal to its diameter; (iii) a cylinder shall have a diameter of at least 0.6 meter and a height of twice its diameter;",
          "inland": "(ii) a cone shall have a base diameter of not less than 0.6 meter s and a height equal to its diameter;"
        },
        {
          "id": "s6:a(iv)",
          "scope": "both",
          "international": "(iv)|(iii) a diamond shape shall consist of two cones as defined in §(a)(ii) having a common base.",
          "inland": "(iv)|(iii) a diamond shape shall consist of two cones as defined in §(a)(ii) having a common base."
        },
        {
          "id": "s6:b",
          "scope": "both",
          "international": "(b) The vertical distance between shapes shall be at least 1.5 meters.",
          "inland": "(b) The vertical distance between shapes shall be at least 1.5 meter."
        },
        {
          "id": "s6:c",
          "scope": "both",
          "international": "(c) In a vessel of less than 20 meters in length shapes of lesser dimensions but commensurate with the size of the vessel may be used and the distance apart may be correspondingly reduced. 7|13. Color specification of lights.",
          "inland": "(c) In a vessel of less than 20 meters in length shapes of lesser dimensions but commensurate with the size of the vessel may be used and the distance apart may be correspondingly reduced. 7|13. Color specification of lights."
        },
        {
          "id": "s7:a",
          "scope": "both",
          "international": "(a) The chromaticity of all navigation lights shall conform to the following standards, which lie within the boundaries of the area of the diagram specified for each color by the International Commission on Illumination (CIE),< in the “Colors of Light Signals”, which is incorporated by reference. It is Publication CIE No. 2.2. (TC-1.6), 1975, and is available from the Illumination Engineering Society, 345 East 47th Street, New York, NY 10017 and is available for inspection at the Coast Guard, Shore Infrastructure Logistics Center, Aids to Navigation and Marine Environmental Response Product Line (CG-SILC-ATON/MER), 2703 Martin Luther King, Jr. Ave SE, Mailstop 7714, Washington, DC 20593-7714. It is also available for inspection at the National Archives and Records Administration (NARA). For information on the availability of this material at NARA, call 202-741-6030, or go to: http://www.archives.gov/federal_register/code_of_federal_regulations/ibr_locations.html. This incorporation by reference was approved by the Director of the Federal Register>.",
          "inland": "(a) The chromaticity of all navigation lights shall conform to the following standards, which lie within the boundaries of the area of the diagram specified for each color by the International Commission on Illumination (CIE),< in the “Colors of Light Signals”, which is incorporated by reference. It is Publication CIE No. 2.2. (TC-1.6), 1975, and is available from the Illumination Engineering Society, 345 East 47th Street, New York, NY 10017 and is available for inspection at the Coast Guard, Shore Infrastructure Logistics Center, Aids to Navigation and Marine Environmental Response Product Line (CG-SILC-ATON/MER), 2703 Martin Luther King, Jr. Ave SE, Mailstop 7714, Washington, DC 20593-7714. It is also available for inspection at the National Archives and Records Administration (NARA). For information on the availability of this material at NARA, call 202-741-6030, or go to: http://www.archives.gov/federal_register/code_of_federal_regulations/ibr_locations.html. This incorporation by reference was approved by the Director of the Federal Register>."
        },
        {
          "id": "s7:b",
          "scope": "both",
          "international": "(b) The boundaries of the area for each color are given by indicating the corner co-ordinates, which are as follows:",
          "inland": "(b) The boundaries of the area for each color are given by indicating the corner co-ordinates, which are as follows:"
        },
        {
          "id": "s7:b(i)",
          "scope": "both",
          "international": "(i) White: x 0.525 0.525 0.452 0.310 0.310 0.443 y 0.382 0.440 0.440 0.348 0.283 0.382",
          "inland": "(i) White: x 0.525 0.525 0.452 0.310 0.310 0.443 y 0.382 0.440 0.440 0.348 0.283 0.382"
        },
        {
          "id": "s7:b(ii)",
          "scope": "both",
          "international": "(ii) Green: x 0.028 0.009 0.300 0.203 y 0.385 0.723 0.511 0.356",
          "inland": "(ii) Green: x 0.028 0.009 0.300 0.203 y 0.385 0.723 0.511 0.356"
        },
        {
          "id": "s7:b(iii)",
          "scope": "both",
          "international": "(iii) Red: x 0.680 0.660 0.735 0.721 y 0.320 0.320 0.265 0.259",
          "inland": "(iii) Red: x 0.680 0.660 0.735 0.721 y 0.320 0.320 0.265 0.259"
        },
        {
          "id": "s7:b(iv)",
          "scope": "both",
          "international": "(iv) Yellow: x 0.612 0.618 0.575 0.575 y 0.382 0.382 0.425 0.406 8|14. Intensity of lights.",
          "inland": "(iv) Yellow: x 0.612 0.618 0.575 0.575 y 0.382 0.382 0.425 0.406 8|14. Intensity of lights."
        },
        {
          "id": "s8:a",
          "scope": "both",
          "international": "(a) The minimum luminous intensity of lights shall be calculated by using the formula: I = 3.43 x 106 x T x D2 x K-D where: I is luminous intensity in candelas under service conditions, T is threshold factor 2 x 10-7 lux, D is range of visibility (luminous range) of the light in nautical miles, K is atmospheric transmissivity. For prescribed lights the value of K shall be 0.8, corresponding to a meteorological visibility of approximately 13 nautical miles.",
          "inland": "(a) The minimum luminous intensity of lights shall be calculated by using the formula: I = 3.43 x 106 x T x D2 x K-D where: I is luminous intensity in candelas under service conditions, T is threshold factor 2 x 10-7 lux, D is range of visibility (luminous range) of the light in nautical miles, K is atmospheric transmissivity. For prescribed lights the value of K shall be 0.8, corresponding to a meteorological visibility of approximately 13 nautical miles."
        },
        {
          "id": "s8:b",
          "scope": "both",
          "international": "(b) A selection of figures derived from the formula is given in the following table: Range of visibility (luminous range) of light in nautical miles D Minimum luminous intensity of light in candelas for K = 0.8 I 1 0.9 2 4.3 3 12 4 27 5 52 6 94 Note: The maximum luminous intensity of navigation lights should be limited to avoid undue glare. This shall not be achieved by a variable control of the luminous intensity. 9|15. Horizontal sectors.",
          "inland": "(b) A selection of figures derived from the formula is given in the following table: Range of visibility (luminous range) of light in nautical miles D Minimum luminous intensity of light in candelas for K = 0.8 I 1 0.9 2 4.3 3 12 4 27 5 52 6 94 9|15. Horizontal sectors."
        },
        {
          "id": "s9:a(i)",
          "scope": "both",
          "international": "(a)(i) In the forward direction, sidelights as fitted on the vessel shall show the minimum required intensities. The intensities shall decrease to reach practical cut-off between 1 and 3 degrees outside the prescribed sectors.",
          "inland": "(a)(i) In the forward direction, sidelights as fitted on the vessel shall show the minimum required intensities. The intensities shall decrease to reach practical cut-off between 1 and 3 degrees outside the prescribed sectors."
        },
        {
          "id": "s9:a(ii)",
          "scope": "both",
          "international": "(ii) For sternlights and masthead lights and at 22.5 degrees abaft the beam for sidelights, the minimum required intensities shall be maintained over the arc of the horizon up to 5 degrees within the limits of the sectors prescribed in Rule 21. From 5 degrees within the prescribed sectors the intensity may decrease by 50 percent up to the prescribed limits; it shall decrease steadily to reach practical cut-off at not more than 5 degrees outside the prescribed sectors.",
          "inland": "(ii) For sternlights and masthead lights and at 22.5 degrees abaft the beam for sidelights, the minimum required intensities shall be maintained over the arc of the horizon up to 5 degrees within the limits of the sectors prescribed in Rule 21. From 5 degrees within the prescribed sectors the intensity may decrease by 50 percent up to the prescribed limits; it shall decrease steadily to reach practical cut-off at not more than 5 degrees outside the prescribed sectors."
        },
        {
          "id": "s9:b(i)",
          "scope": "both",
          "international": "(b)(i) All-round lights shall be so located as not to be obscured by masts, topmasts or structures within angular sectors of more than 6 degrees, except anchor lights prescribed in Rule 23(a), which need not be placed at an impracticable height above the hull.",
          "inland": "(b)(i) All-round lights shall be so located as not to be obscured by masts, topmasts or structures within angular sectors of more than 6 degrees, except anchor lights prescribed in Rule 23(a), which need not be placed at an impracticable height above the hull, and the all-round white light described in Rule 23(e), which may not be obscured at all."
        },
        {
          "id": "s9:b(ii)",
          "scope": "both",
          "international": "(ii) If it is impracticable to comply with §(b)(i) by exhibiting only one all-round light, two all-round lights shall be used suitably positioned or screened so that they appear, as far as practicable, as one light at a distance of 1 mile. 10|16. Vertical sectors.",
          "inland": "(ii) If it is impracticable to comply with §(b)(i) by exhibiting only one all-round light, two all-round lights shall be used suitably positioned or screened so that they to appear, as far as practicable, as one light at a minimum distance of 1 nautical mile. Note: Two unscreened all-round lights that are 1.28 meters apart or less will appear as one light to the naked eye at a distance of 1 nautical mile. 10|16. Vertical sectors."
        },
        {
          "id": "s10:a",
          "scope": "both",
          "international": "(a) The vertical sectors of electric lights as fitted, with the exception of lights on sailing vessels underway, shall ensure that:",
          "inland": "(a) The vertical sectors of electric lights as fitted, with the exception of lights on sailing vessels underway and on unmanned barges, shall ensure that:"
        },
        {
          "id": "s10:a(i)",
          "scope": "both",
          "international": "(i) At least the required minimum intensity is maintained at all angles from 5 degrees above to 5 degrees below the horizontal;",
          "inland": "(i) At least the required minimum intensity is maintained at all angles from 5 degrees above to 5 degrees below the horizontal;"
        },
        {
          "id": "s10:a(ii)",
          "scope": "both",
          "international": "(ii) at least 60 percent of the required minimum intensity is maintained from 7.5 degrees above to 7.5 degrees below the horizontal.",
          "inland": "(ii) at least 60 percent of the required minimum intensity is maintained from 7.5 degrees above to 7.5 degrees below the horizontal."
        },
        {
          "id": "s10:b",
          "scope": "both",
          "international": "(b) In the case of sailing vessels underway the vertical sectors of electric lights as fitted shall ensure that:",
          "inland": "(b) In the case of sailing vessels underway the vertical sectors of electric lights as fitted shall ensure that:"
        },
        {
          "id": "s10:b(i)",
          "scope": "both",
          "international": "(i) At least the required minimum intensity is maintained at all angles from 5 degrees above to 5 degrees below the horizontal;",
          "inland": "(i) At least the required minimum intensity is maintained at all angles from 5 degrees above to 5 degrees below the horizontal;"
        },
        {
          "id": "s10:b(ii)",
          "scope": "both",
          "international": "(ii) at least 50 percent of the required minimum intensity is maintained from 25 degrees above to 25 degrees below the horizontal.",
          "inland": "(ii) at least 50 percent of the required minimum intensity is maintained from 25 degrees above to 25 degrees below the horizontal."
        },
        {
          "id": "s10:c",
          "scope": "inland",
          "international": "",
          "inland": "(c) In the case of unmanned barges the minimum required intensity of electric lights as fitted shall be maintained on the horizontal."
        },
        {
          "id": "s11:c",
          "scope": "both",
          "international": "(c)|(d) In the case of lights other than electric lights these specifications shall be met as closely as possible. 11|17. Intensity of non-electric lights. Non-electric lights shall so far as practicable comply with the minimum intensities, as specified in the Table. 12|18. Maneuvering light. , the maneuvering light described in Rule 34(b) shall be placed in the same fore and aft vertical plane as the masthead light or lights and, where practicable, at a minimum height of 2 meter vertically above the forward masthead light, provided that it shall be carried not less than 2 meter vertically above or below the after masthead light. On a vessel where only one masthead light is carried, the maneuvering light, if fitted, shall be carried where it can best be seen, not less than 2 meters vertically apart from the masthead light. 13|19. High-speed Craft.",
          "inland": "(c)|(d) In the case of lights other than electric lights these specifications shall be met as closely as possible. 11|17. Intensity of non-electric lights. Non-electric lights shall so far as practicable comply with the minimum intensities, as specified in the Intensity of Lights Table. 12|18. Maneuvering light. Notwithstanding the provisions of §2(f), the maneuvering light described in Rule 34(b) shall be placed approximately in the same fore and aft vertical plane as the masthead light or lights and, where practicable, at a minimum height of 1.5 meter vertically above the forward masthead light, provided that it shall be carried not less than 1.5 meter vertically above or below the after masthead light. On a vessel where only one masthead light is carried, the maneuvering light, if fitted, shall be carried where it can best be seen, not less than 1.5 meters vertically apart from the masthead light. 13|19. High-speed Craft."
        },
        {
          "id": "s12:a",
          "scope": "both",
          "international": "(a) The masthead light of high-speed craft may be placed at a height related to the breadth lower than that prescribed in §2(a)(i), provided that the base angle of the isosceles triangle formed by the sidelights and masthead light when seen in end elevation is not less than 27 degrees.",
          "inland": "(a) The masthead light of high-speed craft may be placed at a height related to the breadth of the craft lower than that prescribed in §2(a)(i), provided that the base angle of the isosceles triangle formed by the sidelights and masthead light when seen in end elevation is not less than 27 degrees."
        },
        {
          "id": "s12:b",
          "scope": "both",
          "international": "(b) On high-speed craft of 50 meters or more in length, the vertical separation between foremast and mainmast light of 4.5 meters required by §2(a)(ii) {editorial correction; amending §2(k) in 33 CFR §84.19 to §2(a)(ii) pends rulemaking} may be modified provided that such distance shall not be less than the value determined by the following formula: where: y is the height of the mainmast light above the foremast light in meters; a is the height of the foremast light above the water surface in service condition in meters; Y is the trim in service condition in degrees; C is the horizontal separation of masthead lights in meters. Note: Refer to the International Code of Safety for High-Speed Craft, 1994 and the International Code of Safety for High-Speed Craft, 2000. 14|20. Approval. The construction of lights and shapes and the installation of lights on board the vessel shall be to the satisfaction of the appropriate authority of the State whose flag the vessel is entitled to fly.",
          "inland": "(b) On high-speed craft of 50 meters or more in length, the vertical separation between foremast and mainmast light of 4.5 meters required by §2(a)(ii) {editorial correction; amending §2(k) in 33 CFR §84.19 to §2(a)(ii) pends rulemaking} may be modified provided that such distance shall not be less than the value determined by the following formula: where: y is the height of the mainmast light above the foremast light in meters; a is the height of the foremast light above the water surface in service condition in meters; Y is the trim in service condition in degrees; C is the horizontal separation of masthead lights in meters. Note: Refer to the International Code of Safety for High-Speed Craft, 1994 and the International Code of Safety for High-Speed Craft, 2000. 14|20. Approval. The construction of lights and shapes and the installation of lights on board the vessel must satisfy the Commandant, U. S. Coast Guard."
        }
      ]
    },
    "102": {
      "number": 102,
      "title": "Additional Signals for Fishing Vessels Fishing In Close Proximity {at Rule 26(f)}",
      "label": "Annex II",
      "paragraphs": []
    },
    "103": {
      "number": 103,
      "title": "Technical Details of Sound Signal Appliances (33 CFR 86)",
      "label": "Annex III",
      "paragraphs": [
        {
          "id": "s1:a",
          "scope": "both",
          "international": "(a) Frequencies and range of audibility. The fundamental frequency of the signal shall lie within the range 70-700 Hz. The range of audibility of the signal from a whistle shall be determined by those frequencies, which may include the fundamental and/or one or more higher frequencies, which lie within the range 180-700 Hz (+/- 1 percent) for a vessel of 20 meters or more in length, or 180-2100 Hz (+/- 1 percent) for a vessel of less than 20 meters in length and which provide the sound pressure levels specified in §1(c).",
          "inland": "(a) Frequencies and range of audibility. The fundamental frequency of the signal shall lie within the range 70-700 Hz. The range of audibility of the signal from a whistle shall be determined by those frequencies, which may include the fundamental and/or one or more higher frequencies, which lie within the range 180-700 Hz (+/- 1 percent) for a vessel of 20 meters or more in length, or 180-2100 Hz (+/- 1 percent) for a vessel of less than 20 meters in length and which provide the sound pressure levels specified in §1(c)."
        },
        {
          "id": "s1:b",
          "scope": "both",
          "international": "(b) Limits of fundamental frequencies. To ensure a wide variety of whistle characteristics, the fundamental frequency of a whistle shall be between the following limits:",
          "inland": "(b) Limits of fundamental frequencies. To ensure a wide variety of whistle characteristics, the fundamental frequency of a whistle shall be between the following limits:"
        },
        {
          "id": "s1:b(i)",
          "scope": "both",
          "international": "(i) 70-200 Hz, for a vessel 200 meters or more in length;",
          "inland": "(i) 70-200 Hz, for a vessel 200 meters or more in length;"
        },
        {
          "id": "s1:b(ii)",
          "scope": "both",
          "international": "(ii) 130-350 Hz, for a vessel 75 meters but less than 200 meters in length;",
          "inland": "(ii) 130-350 Hz, for a vessel 75 meters but less than 200 meters in length;"
        },
        {
          "id": "s1:b(iii)",
          "scope": "both",
          "international": "(iii) 250-700 Hz, for a vessel less than 75 meters in length.",
          "inland": "(iii) 250-700 Hz, for a vessel less than 75 meters in length."
        },
        {
          "id": "s1:c",
          "scope": "both",
          "international": "(c) Sound signal intensity and range of audibility. A whistle fitted in a vessel shall provide, in the direction of maximum intensity of the whistle and at a distance of 1 meter from it, a sound pressure level in at least one one-third octave band within the range of frequencies 180-700 Hz (+/- 1 percent) for a vessel of 20 meters or more in length, or 180-2100 Hz (+/- 1 percent) for a vessel of less than 20 meters in length, of not less than the appropriate figure given in the table below. Length of vessel in meters One-third octave band level at 1 meter in dB referred to 2 × 10−5N/m2 Audibility range in nautical miles 200 or more 143 2.0 75 but less than 200 138 1.5 20 but less than 75 130 1.0 Less than 20 120* 115** 111*** 0.5 * When the measured frequencies lie within the range 180-450 Hz ** When the measured frequencies lie within the range 450-800 Hz *** When the measured frequencies lie within the range 800-2100 Hz The range of audibility in the table is for information and is approximately the range at which a whistle may be heard on its forward axis with 90 percent probability in conditions of still air on board a vessel having average background noise level at the listening posts (taken to be 68 dB in the octave band centered on 250 Hz and 63 dB in the octave band centered on 500 Hz). In practice, the range at which a whistle may be heard is extremely variable and depends critically on weather conditions; the values given can be regarded as typical but under conditions of strong wind or high ambient noise level at the listening post the range may be reduced.",
          "inland": "(c) Sound signal intensity and range of audibility. A whistle fitted in a vessel shall provide, in the direction of maximum intensity of the whistle and at a distance of 1 meter from it, a sound pressure level in at least one one-third octave band within the range of frequencies 180-700 Hz (+/- 1 percent) for a vessel of 20 meters, of not less than the appropriate figure given in the table below. Length of vessel in meters One-third octave band level at 1 meter in dB referred to 2 × 10−5N/m2 Audibility range in nautical miles 200 or more 143 2.0 75 but less than 200 138 1.5 20 but less than 75 130 1.0 Less than 20 120* 115** 111*** 0.5 * When the measured frequencies lie within the range 180-450 Hz ** When the measured frequencies lie within the range 450-800 Hz *** When the measured frequencies lie within the range 800-2100 Hz The range of audibility in the table is for information and is approximately the range at which a whistle may be heard on its forward axis with 90 percent probability in conditions of still air on board a vessel having average background noise level at the listening posts (taken to be 68 dB in the octave band centered on 250 Hz and 63 dB in the octave band centered on 500 Hz). It is shown for informational purposes only. In practice, the range at which a whistle may be heard is extremely variable and depends critically on weather conditions; the values given can be regarded as typical but under conditions of strong wind or high ambient noise level at the listening post the range may be reduced."
        },
        {
          "id": "s1:d",
          "scope": "both",
          "international": "(d) Directional properties. The sound pressure level of a directional whistle shall be not more than 4 dB below the prescribed sound pressure level on the axis at, any direction in the horizontal plane within +/- 45 degrees of the axis. The sound pressure level at any other direction in the horizontal plane shall be not more than 10 dB below the prescribed sound pressure level on the forward axis, so that the range in any direction will be at least half the range on the forward axis. The sound pressure level shall be measured in that one-third octave band which determines the audibility range.",
          "inland": "(d) Directional properties. The sound pressure level of a directional whistle shall be not more than 4 dB below the sound pressure level, specified in §(c) any direction in the horizontal plane within +/- 45 degrees of the axis. The sound pressure level of the whistle in any other direction in the horizontal plane shall be not more than 10 dB less than the sound pressure level specified for the forward axis, so that the range audibility in any direction will be at least half the range required on the forward axis. The sound pressure level shall be measured in that one-third octave band which determines the audibility range."
        },
        {
          "id": "s1:e",
          "scope": "both",
          "international": "(e) Positioning of whistles.",
          "inland": "(e) Positioning of whistles."
        },
        {
          "id": "s1:e(i)",
          "scope": "both",
          "international": "(i) When a directional whistle is to be used as the only whistle on a vessel, it shall be installed with its maximum intensity directed straight ahead.",
          "inland": "(i) When a directional whistle is to be used as the only whistle on the vessel and is permanently installed, it shall be installed with its forward axis directed forward."
        },
        {
          "id": "s1:e(ii)",
          "scope": "both",
          "international": "(ii) A whistle shall be placed as high as practicable on a vessel, in order to reduce interception of the emitted sound by obstructions and also to minimize hearing damage risk to personnel. The sound pressure level of the vessel’s own signal at listening posts shall not exceed 110 dB(A) and so far as practicable should not exceed 100 dB(A).",
          "inland": "(ii) A whistle shall be placed as high as practicable on a vessel, in order to reduce interception of the emitted sound by obstructions and also to minimize hearing damage risk to personnel. The sound pressure level of the vessel’s own signal at listening posts shall not exceed 110 dB(A) and so far as practicable should not exceed 100 dB(A)."
        },
        {
          "id": "s1:f",
          "scope": "both",
          "international": "(f) Fitting of more than one whistle. If whistles are fitted at a distance apart of more than 100 meters, it shall be so arranged that they are not sounded simultaneously.",
          "inland": "(f) Fitting of more than one whistle. If whistles are fitted at a distance apart of more than 100 meters, they shall not be sounded simultaneously."
        },
        {
          "id": "s1:g",
          "scope": "both",
          "international": "(g) Combined whistle systems. If due to the presence of obstructions the sound field of a single whistle or of one of the whistles referred to in §(f) is likely to have a zone of greatly reduced signal level, it is recommended that a combined whistle system be fitted so as to overcome this reduction. The whistles of a combined system shall be located at a distance apart of not more than 100 meters and arranged to be sounded simultaneously. The frequency of any one whistle shall differ from those of the others by at least 10 Hz.",
          "inland": "(g) Combined whistle systems. If due to the presence of obstructions the sound field of a single whistle or of one of the whistles referred to in §(f) is likely to have a zone of greatly reduced signal level, it is recommended that a combined whistle system be fitted so as to overcome this reduction. The whistles of a combined system shall be located at a distance apart of not more than 100 meters and arranged to be sounded simultaneously. The frequency of any one whistle shall differ from those of the others by at least 10 Hz."
        },
        {
          "id": "s2:g",
          "scope": "both",
          "international": "(g) Combined whistle systems.",
          "inland": "(g) Combined whistle systems."
        },
        {
          "id": "s2:g(i)",
          "scope": "both",
          "international": "(i) A combined whistle system is a number of whistles (sound emitting sources) operated together. For the purposes of the Rules of Annex III a combined whistle system is to be regarded as a single whistle.",
          "inland": "(i) A combined whistle system is a number of whistles (sound emitting sources) operated together. For the purposes of the Rules of Annex III a combined whistle system is to be regarded as a single whistle."
        },
        {
          "id": "s2:g(ii)",
          "scope": "both",
          "international": "(ii) The whistles of a combined system shall:",
          "inland": "(ii) The whistles of a combined system shall:"
        },
        {
          "id": "s2:g(ii)(1)",
          "scope": "both",
          "international": "(1) Be located at a distance apart of not more than 100 meters;",
          "inland": "(1) Be located at a distance apart of not more than 100 meters;"
        },
        {
          "id": "s2:g(ii)(2)",
          "scope": "both",
          "international": "(2) Be sounded simultaneously;",
          "inland": "(2) Be sounded simultaneously;"
        },
        {
          "id": "s2:g(ii)(3)",
          "scope": "both",
          "international": "(3) Each have a fundamental frequency different from those of the others by at least 10 Hz; and",
          "inland": "(3) Each have a fundamental frequency different from those of the others by at least 10 Hz; and"
        },
        {
          "id": "s2:g(ii)(4)",
          "scope": "both",
          "international": "(4) Have a tonal characteristic appropriate for the length of vessel which shall be evidenced by at least two-thirds of the whistles in the combined system having fundamental frequencies falling within the limits prescribed in §(b), or if there are only two whistles in the combined system, by the higher fundamental frequency falling within the limits prescribed in §(b). Note to §(g): If, due to the presence of obstructions, the sound field of a single whistle or of one of the whistles referred to in §(f) is likely to have a zone of greatly reduced signal level, a combined whistle system should be fitted so as to overcome this reduction.",
          "inland": "(4) Have a tonal characteristic appropriate for the length of vessel which shall be evidenced by at least two-thirds of the whistles in the combined system having fundamental frequencies falling within the limits prescribed in §(b), or if there are only two whistles in the combined system, by the higher fundamental frequency falling within the limits prescribed in §(b). Note to §(g): If, due to the presence of obstructions, the sound field of a single whistle or of one of the whistles referred to in §(f) is likely to have a zone of greatly reduced signal level, a combined whistle system should be fitted so as to overcome this reduction."
        },
        {
          "id": "s2:h",
          "scope": "inland",
          "international": "",
          "inland": "(h) Towing vessel whistles. A power-driven vessel normally engaged in pushing ahead or towing alongside may, at all times, use a whistle whose characteristic falls within the limits prescribed by §1(b) for the longest customary composite length of the vessel and its tow."
        },
        {
          "id": "s2:a",
          "scope": "both",
          "international": "(a) Intensity of signal. A bell or gong, or other device having similar sound characteristics shall produce a sound pressure level of not less than 110 dB at a distance of 1 meter from it.",
          "inland": "(a) Intensity of signal. A bell or gong, or other device having similar sound characteristics shall produce a sound pressure level of not less than 110 dB at 1 meter."
        },
        {
          "id": "s2:b",
          "scope": "both",
          "international": "(b) Construction. Bells and gongs shall be made of corrosion-resistant material and designed to give clear tone. The diameter of the mouth of the bell shall be not less than 300 mm for vessels of 20 meters or more in length. Where practicable, a power-driven bell striker is recommended to ensure constant force but manual operation shall be possible. The mass of the striker shall be not less than 3 percent of the mass of the bell. The construction of sound signal appliances, their performance and their installation on board the vessel shall be to the satisfaction of the appropriate authority of the State whose flag the vessel is entitled to fly.",
          "inland": "(b) Construction. Bells and gongs shall be made of corrosion-resistant material and designed to give clear tone. The diameter of the mouth of the bell shall be not less than 300 mm for vessels of 20 meters or more in length. Where practicable, a power-driven bell striker is recommended to ensure constant force but manual operation shall be possible. The mass of the striker shall be not less than 3 percent of the mass of the bell."
        }
      ]
    },
    "104": {
      "number": 104,
      "title": "Distress Signals (33 CFR 87)",
      "label": "Annex IV",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "The following signals, used or exhibited either together or separately, indicate distress and need of assistance:",
          "inland": "The following signals, used or exhibited either together or separately, indicate distress and need of assistance:"
        },
        {
          "id": "s1:a",
          "scope": "both",
          "international": "(a) a gun or other explosive signal fired at intervals of about a minute;",
          "inland": "(a) a gun or other explosive signal fired at intervals of about a minute;"
        },
        {
          "id": "s1:b",
          "scope": "both",
          "international": "(b) a continuous sounding with any fog-signaling apparatus;",
          "inland": "(b) a continuous sounding with any fog-signaling apparatus;"
        },
        {
          "id": "s1:c",
          "scope": "both",
          "international": "(c) rockets or shells, throwing red stars fired one at a time at short intervals;",
          "inland": "(c) rockets or shells, throwing red stars fired one at a time at short intervals;"
        },
        {
          "id": "s1:d",
          "scope": "both",
          "international": "(d) a signal made by any signaling method consisting of the group... – – –... (SOS) in the Morse Code;",
          "inland": "(d) a signal made by any signaling method consisting of the group... – – –... (SOS) in the Morse Code;"
        },
        {
          "id": "s1:e",
          "scope": "both",
          "international": "(e) a signal sent by radiotelephony consisting of the spoken word “Mayday”;",
          "inland": "(e) a signal sent by radiotelephony consisting of the spoken word “Mayday”;"
        },
        {
          "id": "s1:f",
          "scope": "both",
          "international": "(f) the International Code Signal of distress indicated by N.C.;",
          "inland": "(f) the International Code Signal of distress indicated by N.C.;"
        },
        {
          "id": "s1:g",
          "scope": "both",
          "international": "(g) a signal consisting of a square flag having above or below it a ball or anything resembling a ball;",
          "inland": "(g) a signal consisting of a square flag having above or below it a ball or anything resembling a ball;"
        },
        {
          "id": "s1:h",
          "scope": "both",
          "international": "(h) flames on the vessel (as from a burning tar barrel, oil barrel, etc.);",
          "inland": "(h) flames on the vessel (as from a burning tar barrel, oil barrel, etc.);"
        },
        {
          "id": "s1:i",
          "scope": "both",
          "international": "(i) a rocket parachute flare or a hand flare showing a red light;",
          "inland": "(i) a rocket parachute flare or a hand flare showing a red light;"
        },
        {
          "id": "s1:j",
          "scope": "both",
          "international": "(j) a smoke signal giving off orange-colored smoke;",
          "inland": "(j) a smoke signal giving off orange-colored smoke;"
        },
        {
          "id": "s1:k",
          "scope": "both",
          "international": "(k) slowly and repeatedly raising and lowering arms outstretched to each side;",
          "inland": "(k) slowly and repeatedly raising and lowering arms outstretched to each side;"
        },
        {
          "id": "s1:l",
          "scope": "both",
          "international": "(l) a distress alert by means of digital selective calling (DSC) transmitted on:",
          "inland": "(l) a distress alert by means of digital selective calling (DSC) transmitted on:"
        },
        {
          "id": "s1:l(i)",
          "scope": "both",
          "international": "(i) VHF channel 70, or",
          "inland": "(i) VHF channel 70, or"
        },
        {
          "id": "s1:l(ii)",
          "scope": "both",
          "international": "(ii) MF/HF on the frequencies 2187.5 kHz, 8414.5 kHz, 4207.5 kHz, 6312 kHz, 12577 kHz or 16804.5 kHz;",
          "inland": "(ii) MF/HF on the frequencies 2187.5 kHz, 8414.5 kHz, 4207.5 kHz, 6312 kHz, 12577 kHz or 16804.5 kHz;"
        },
        {
          "id": "s1:m",
          "scope": "both",
          "international": "(m) a ship-to-shore distress alert transmitted by the ship’s Inmarsat or other mobile satellite service provider ship earth station;",
          "inland": "(m) a ship-to-shore distress alert transmitted by the ship’s Inmarsat or other mobile satellite service provider ship earth station;"
        },
        {
          "id": "s1:n",
          "scope": "both",
          "international": "(n) signals transmitted by emergency position-indicating radio beacons;",
          "inland": "(n) signals transmitted by emergency position-indicating radio beacons;"
        },
        {
          "id": "s1:o",
          "scope": "both",
          "international": "(o) approved signals transmitted by radiocommunication systems, including survival craft radar transponders. The use or exhibition of any of the foregoing signals except for the purpose of indicating distress and need of assistance and the use of other signals which may be confused with any of the above signals is prohibited. Attention is drawn to the relevant sections of the International Code of Signals, the International Aeronautical and Maritime Search and Rescue Manual, Volume III, the International Telecommunication Union Radio Regulations, and the following signals:",
          "inland": "(o) approved signals transmitted by radiocommunication systems, including survival craft radar transponders 'meeting the requirements of 47 CFR 80.1095 {search and rescue locating devices}. (p) A high intensity white light flashing at regular intervals from 50 to 70 times per minute. The use or exhibition of any of the foregoing signals except for the purpose of indicating distress and need of assistance and the use of other signals which may be confused with any of the above signals is prohibited. Attention is drawn to the relevant sections of the International Code of Signals, the International Aeronautical and Maritime Search and Rescue Manual, Volume III, and the following signals:"
        },
        {
          "id": "s3:a",
          "scope": "both",
          "international": "(a) A piece of orange-colored canvas with either a black square and circle or other appropriate symbol (for identification from the air);",
          "inland": "(a) A piece of orange-colored canvas with either a black square and circle or other appropriate symbol (for identification from the air);"
        },
        {
          "id": "s3:b",
          "scope": "both",
          "international": "(b) A dye marker. PART E - EXEMPTIONS",
          "inland": "(b) A dye marker. PART E - EXEMPTIONS"
        }
      ]
    },
    "105": {
      "number": 105,
      "title": "Pilot Rules {at Rule 21}",
      "label": "Annex V",
      "paragraphs": [
        {
          "id": "intro",
          "scope": "both",
          "international": "*** AMENDMENTS AND ASSOCIATED PROVISIONS AMENDMENTS TO THE RULES & Webpage Corrections International Navigational Rules Act of 1977, 91 Stat. 308 (1977), 33 U.S.C. 1600-1608 (1982) Amendments to the International Navigation Rules (72 COLREGS), International Maritime Organization (IMO) resolutions: A.464(12), November 19th, 1981 A.626(15), November 19th, 1987 A.678(16), October 19th, 1989 A.736(18), November 4th, 1993 A.910(22), November 29th, 2001 A.1004(25), November 29th, 2007 A.1085(28), December 4th, 2013 For additional U.S. navigation regulations see Title 33 of the U.S. Code and U S. Code of Federal Regulations. SPECIAL RULES WITH RESPECT TO ADDITIONAL STATION AND SIGNAL LIGHTS",
          "inland": "*** AMENDMENTS AND ASSOCIATED PROVISIONS AMENDMENTS TO THE RULES & Webpage Corrections Inland Navigation Rules Act of 1980, 94 Stat. 3415 (1980); Inland Navigation Rules, 33 CFR 83, see 79 FR 37898, July 2nd, 2014 Navigation Rules 1999-2013 compilation of changes, compilation with reference sources, 33 CFR 83-88 redline version. Amendments to the Inland Navigation Rules (33 CFR 83), Federal Register documents: 79 FR 68619, November 18th, 2014 80 FR 44274, July 27th, 2015 82 FR 35073, July 18th, 2017 83 FR 3273, January 24th, 2018 84 FR 30870, June 28th, 2019 85 FR 58268, September 18th, 2020 67 FR 53382, September 6th, 2022 69 FR 42192, June 12th, 2023 For additional U.S. navigation regulations see Title 33 of the U.S. Code and U S. Code of Federal Regulations. SPECIAL RULES WITH RESPECT TO ADDITIONAL STATION AND SIGNAL LIGHTS"
        },
        {
          "id": "a",
          "scope": "both",
          "international": "(a) The Secretary of the Navy is authorized to promulgate special rules with respect to additional station or signal lights or whistle signals for ships of war or vessels proceeding under convoy, and the Secretary of the department in which the Coast Guard is operating is authorized to promulgate special rules with respect to additional station or signal lights for fishing vessels engaged in fishing as a fleet.",
          "inland": "(a) The Secretary of the Navy is authorized to promulgate special rules with respect to additional station or signal lights or whistle signals for ships of war or vessels proceeding under convoy, and the Secretary of the department in which the Coast Guard is operating is authorized to promulgate special rules with respect to additional station or signal lights for fishing vessels engaged in fishing as a fleet."
        },
        {
          "id": "b",
          "scope": "both",
          "international": "(b) The additional station or signal lights or whistle signals contained in the special rules authorized under subsection (a) shall be, as far as possible, such that they cannot be mistaken for any light or signal authorized by the International Regulations. Notice of such special rules shall be published in the Federal Register and, after the effective date specified in such notice, they shall have effect as if they were a part of the International Regulation. {These are additional signal lights used by the U. S. Navy previously published in 32 CFR 707 see 84 FR 530 }. All ships are warned that when U.S. naval vessels are met in international and inland waters, some of the navigational lights displayed by them may be special lights for naval purposes. When used, they may be displayed simultaneously with the ordinary navigational lights required by the International Regulations for Preventing Collisions at Sea, 1972, or the Inland Navigational Rules. The lights are located and characterized in such a fashion that, as far as possible, they cannot be mistaken for any light authorized by either set of rules. This part publishes the special rules with respect to these additional station and signal lights promulgated by the Secretary of the Navy for vessels of the Navy. 2.Man overboard lights Naval vessels may display, as a means of indicating man overboard, two pulsating, all round red lights in the vertical line located on a mast from where they can best be seen. Naval vessels may display, as a means of visual signaling, white all round lights at the ends of the yard arms. These lights will flash in varying sequences to convey the intended signal. Naval vessels may display, as a means of indicating the presence of an obstruction to low flying aircraft, one all-round red light on each obstruction. Naval vessels may display, as a means of outlining the contour of the delivery ship during nighttime underway replenishment operations, either red or blue lights at delivery-ship-deck-edge extremities. Naval vessels engaged in minesweeping operations may display, as an aid in maintaining prescribed intervals and bearings, two white lights in a vertical line visible from 070 degrees through 290 degrees relative. Submarines may display, as a distinctive means of identification, an intermittent flashing amber beacon with a sequence of operation of one flash per second for three (3) seconds followed by a three (3) second off-period. The light will be located where it can best be seen, as near as practicable, all around the horizon. It shall not be located less than two (2) feet above or below the masthead lights. Naval vessels may display, as a means of coordinating certain special operations, a revolving beam colored red, green, or amber, located on either yard arm or the mast platform from where it can best be seen all around the horizon. Naval vessels may display, during periods of convoy operations, a blue light located near the stern with the same characteristics as, but in lieu of, the normal white stern light. Naval vessels may display a white spotlight located near the stern to illuminate the wake. Naval vessels engaged in night flight operations may display various arrangements of light systems containing combinations of different colored lights as a means of assisting in the launch and recovery of aircraft and enhancing flight safety. These light systems will be located at various points on the vessels, depending on the vessel type and the nature of the flight operations being conducted. Naval vessels engaged in night amphibious operations may display various arrangements of light systems containing combinations of different colored lights as a means of assisting in the launch and recovery of assault craft and enhancing the safety of the amphibious operation. These light systems will be located at various points on the vessel, depending on the vessel type and the nature of the amphibious operations being conducted. ALTERNATIVE COMPLIANCE (33 CFR 81|89) As used in this part: “72 COLREGS” refers to the International Regulations for Preventing Collisions at Sea, 1972, done at London, October 20, 1972, as rectified by the Proces-Verbal of December 1, 1973, as amended. A “vessel of special construction or purpose” means a vessel designed or modified to perform a special function and whose arrangement is thereby made relatively inflexible. “Interference with the special function of the vessel” occurs when installation or use of lights, shapes, or sound-signaling appliances under the 72 COLREGS prevents or significantly hinders the operation in which the vessel is usually engaged. Vessels of special construction or purpose which cannot fully comply with the light, shape, and sound signal provisions of the Rules without interfering with their special function may instead meet alternative requirements. The Chief of the Prevention Division in each Coast Guard District Office makes this determination and requires that alternative compliance be as close as possible with the Rules. These regulations set out the procedure by which a vessel may be certified for alternative compliance. The information collection and record keeping requirements in §§5 and 18 have been approved by the Office of Management and Budget under OMB control No. 1625-0019.",
          "inland": "(b) The additional station or signal lights or whistle signals contained in the special rules authorized under subsection (a) shall be, as far as possible, such that they cannot be mistaken for any light or signal authorized by the International Regulations. Notice of such special rules shall be published in the Federal Register and, after the effective date specified in such notice, they shall have effect as if they were a part of the International Regulation. {These are additional signal lights used by the U. S. Navy previously published in 32 CFR 707 see 84 FR 530 }. All ships are warned that when U.S. naval vessels are met in international and inland waters, some of the navigational lights displayed by them may be special lights for naval purposes. When used, they may be displayed simultaneously with the ordinary navigational lights required by the International Regulations for Preventing Collisions at Sea, 1972, or the Inland Navigational Rules. The lights are located and characterized in such a fashion that, as far as possible, they cannot be mistaken for any light authorized by either set of rules. This part publishes the special rules with respect to these additional station and signal lights promulgated by the Secretary of the Navy for vessels of the Navy. 2.Man overboard lights Naval vessels may display, as a means of indicating man overboard, two pulsating, all round red lights in the vertical line located on a mast from where they can best be seen. Naval vessels may display, as a means of visual signaling, white all round lights at the ends of the yard arms. These lights will flash in varying sequences to convey the intended signal. Naval vessels may display, as a means of indicating the presence of an obstruction to low flying aircraft, one all-round red light on each obstruction. Naval vessels may display, as a means of outlining the contour of the delivery ship during nighttime underway replenishment operations, either red or blue lights at delivery-ship-deck-edge extremities. Naval vessels engaged in minesweeping operations may display, as an aid in maintaining prescribed intervals and bearings, two white lights in a vertical line visible from 070 degrees through 290 degrees relative. Submarines may display, as a distinctive means of identification, an intermittent flashing amber beacon with a sequence of operation of one flash per second for three (3) seconds followed by a three (3) second off-period. The light will be located where it can best be seen, as near as practicable, all around the horizon. It shall not be located less than two (2) feet above or below the masthead lights. Naval vessels may display, as a means of coordinating certain special operations, a revolving beam colored red, green, or amber, located on either yard arm or the mast platform from where it can best be seen all around the horizon. Naval vessels may display, during periods of convoy operations, a blue light located near the stern with the same characteristics as, but in lieu of, the normal white stern light. Naval vessels may display a white spotlight located near the stern to illuminate the wake. Naval vessels engaged in night flight operations may display various arrangements of light systems containing combinations of different colored lights as a means of assisting in the launch and recovery of aircraft and enhancing flight safety. These light systems will be located at various points on the vessels, depending on the vessel type and the nature of the flight operations being conducted. Naval vessels engaged in night amphibious operations may display various arrangements of light systems containing combinations of different colored lights as a means of assisting in the launch and recovery of assault craft and enhancing the safety of the amphibious operation. These light systems will be located at various points on the vessel, depending on the vessel type and the nature of the amphibious operations being conducted. ALTERNATIVE COMPLIANCE (33 CFR 81|89) As used in this part: “Inland Rules” refers to the Inland Navigation Rules contained in the Inland Navigational Rules Act of 1980 (Pub. L. 96-591) and the technical annexes established under that Act. A “vessel of special construction or purpose” means a vessel designed or modified to perform a special function and whose arrangement is thereby made relatively inflexible. “Interference with the special function of the vessel” occurs when installation or use of lights, shapes, or sound-signaling appliances under the Inland Rules prevents or significantly hinders the operation in which the vessel is usually engaged. Vessels of special construction or purpose which cannot fully comply with the light, shape, and sound signal provisions of the Rules without interfering with their special function may instead meet alternative requirements. The Chief of the Prevention Division in each Coast Guard District Office makes this determination and requires that alternative compliance be as close as possible with the Rules. These regulations set out the procedure by which a vessel may be certified for alternative compliance. The information collection and record keeping requirements in §§5 and 18 have been approved by the Office of Management and Budget under OMB control No. 1625-0019."
        },
        {
          "id": "s5:a",
          "scope": "both",
          "international": "(a) The owner, builder, operator, or agent of a vessel of special construction or purpose who believes the vessel cannot fully comply with the Rules light, shape, or sound signal provisions without interference with its special function may apply for a determination that alternative compliance is justified. The application must be in writing, submitted to the Chief of the Prevention Division of the Coast Guard District in which the vessel is being built or operated, and include the following information:",
          "inland": "(a) The owner, builder, operator, or agent of a vessel of special construction or purpose who believes the vessel cannot fully comply with the Rules light, shape, or sound signal provisions without interference with its special function may apply for a determination that alternative compliance is justified. The application must be in writing, submitted to the Chief of the Prevention Division of the Coast Guard District in which the vessel is being built or operated, and include the following information:"
        },
        {
          "id": "s5:a(1)",
          "scope": "both",
          "international": "(1) The name, address, and telephone number of the applicant.",
          "inland": "(1) The name, address, and telephone number of the applicant."
        },
        {
          "id": "s5:a(2)",
          "scope": "both",
          "international": "(2) The identification of the vessel by its:",
          "inland": "(2) The identification of the vessel by its:"
        },
        {
          "id": "s5:a(i)",
          "scope": "both",
          "international": "(i) Official number;",
          "inland": "(i) Official number;"
        },
        {
          "id": "s5:a(ii)",
          "scope": "both",
          "international": "(ii) Shipyard hull number;",
          "inland": "(ii) Shipyard hull number;"
        },
        {
          "id": "s5:a(iii)",
          "scope": "both",
          "international": "(iii) Hull identification number; or",
          "inland": "(iii) Hull identification number; or"
        },
        {
          "id": "s5:a(iv)",
          "scope": "both",
          "international": "(iv) State number, if the vessel does not have an official number or hull identification number.",
          "inland": "(iv) State number, if the vessel does not have an official number or hull identification number."
        },
        {
          "id": "s5:a(iv)(3)",
          "scope": "both",
          "international": "(3) Vessel name and home port, if known.",
          "inland": "(3) Vessel name and home port, if known."
        },
        {
          "id": "s5:a(iv)(4)",
          "scope": "both",
          "international": "(4) A description of the vessel’s area of operation.",
          "inland": "(4) A description of the vessel’s area of operation."
        },
        {
          "id": "s5:a(iv)(5)",
          "scope": "both",
          "international": "(5) A description of the provision for which the Certificate of Alternative Compliance is sought, including:",
          "inland": "(5) A description of the provision for which the Certificate of Alternative Compliance is sought, including:"
        },
        {
          "id": "s5:i",
          "scope": "both",
          "international": "(i) the Rules or Annex section number for which the Certificate of Alternative Compliance is sought;",
          "inland": "(i) the Rules or Annex section number for which the Certificate of Alternative Compliance is sought;"
        },
        {
          "id": "s5:i(ii)",
          "scope": "both",
          "international": "(ii) a description of the special function of the vessel that would be interfered with by full compliance with the provision of that Rule or Annex section; and",
          "inland": "(ii) a description of the special function of the vessel that would be interfered with by full compliance with the provision of that Rule or Annex section; and"
        },
        {
          "id": "s5:i(iii)",
          "scope": "both",
          "international": "(iii) a statement of how full compliance would interfere with the special function of the vessel.",
          "inland": "(iii) a statement of how full compliance would interfere with the special function of the vessel."
        },
        {
          "id": "s5:i(iii)(6)",
          "scope": "both",
          "international": "(6) A description of the alternative installation that is in closest possible compliance with the applicable Rules Rule or Annex section.",
          "inland": "(6) A description of the alternative installation that is in closest possible compliance with the applicable Rules Rule or Annex section."
        },
        {
          "id": "s5:i(iii)(7)",
          "scope": "both",
          "international": "(7) A copy of the vessel’s plans or an accurate scale drawing that clearly shows:",
          "inland": "(7) A copy of the vessel’s plans or an accurate scale drawing that clearly shows:"
        },
        {
          "id": "s5:i(i)",
          "scope": "both",
          "international": "(i) the required installation of the equipment under the Rules,",
          "inland": "(i) the required installation of the equipment under the Rules,"
        },
        {
          "id": "s5:i(ii)",
          "scope": "both",
          "international": "(ii) the proposed installation of the equipment for which certification is being sought, and",
          "inland": "(ii) the proposed installation of the equipment for which certification is being sought, and"
        },
        {
          "id": "s5:i(iii)",
          "scope": "both",
          "international": "(iii) any obstructions that may interfere with the equipment when installed in: (A) the required location; and (B) the proposed location.",
          "inland": "(iii) any obstructions that may interfere with the equipment when installed in: (A) the required location; and (B) the proposed location."
        },
        {
          "id": "s6:b",
          "scope": "both",
          "international": "(b) The Coast Guard may request from the applicant additional information concerning the application. The Chief of the Prevention Division issues the Certificate of Alternative Compliance to the vessel based on a determination that it cannot comply fully with Rules light, shape, and sound signal provisions without interference with its special function. This Certificate includes:",
          "inland": "(b) The Coast Guard may request from the applicant additional information concerning the application. The Chief of the Prevention Division issues the Certificate of Alternative Compliance to the vessel based on a determination that it cannot comply fully with Rules light, shape, and sound signal provisions without interference with its special function. This Certificate includes:"
        },
        {
          "id": "s9:a",
          "scope": "both",
          "international": "(a) Identification of the vessel as supplied in the application under §5(a)(2);",
          "inland": "(a) Identification of the vessel as supplied in the application under §5(a)(2);"
        },
        {
          "id": "s9:b",
          "scope": "both",
          "international": "(b) The provision of the Rules for which the Certificate authorizes alternative compliance;",
          "inland": "(b) The provision of the Rules for which the Certificate authorizes alternative compliance;"
        },
        {
          "id": "s9:c",
          "scope": "both",
          "international": "(c) A certification that the vessel is unable to comply fully with the Rules light, shape, and sound signal requirements without interference with its special function;",
          "inland": "(c) A certification that the vessel is unable to comply fully with the Rules light, shape, and sound signal requirements without interference with its special function;"
        },
        {
          "id": "s9:d",
          "scope": "both",
          "international": "(d) A statement of why full compliance would interfere with the special function of the vessel;",
          "inland": "(d) A statement of why full compliance would interfere with the special function of the vessel;"
        },
        {
          "id": "s9:e",
          "scope": "both",
          "international": "(e) The required alternative installation;",
          "inland": "(e) The required alternative installation;"
        },
        {
          "id": "s9:f",
          "scope": "both",
          "international": "(f) A statement that the required alternative installation is in the closest possible compliance with the Rules without interfering with the special function of the vessel;",
          "inland": "(f) A statement that the required alternative installation is in the closest possible compliance with the Rules without interfering with the special function of the vessel;"
        },
        {
          "id": "s9:g",
          "scope": "both",
          "international": "(g) The date of issuance;",
          "inland": "(g) The date of issuance;"
        },
        {
          "id": "s9:h",
          "scope": "both",
          "international": "(h) A statement that the Certificate of Alternative Compliance terminates when the vessel ceases to be usually engaged in the operation for which the certificate is issued. The Certificate of Alternative Compliance terminates if the information supplied under §5(a) or the Certificate issued under §9 is no longer applicable to the vessel.",
          "inland": "(h) A statement that the Certificate of Alternative Compliance terminates when the vessel ceases to be usually engaged in the operation for which the certificate is issued. The Certificate of Alternative Compliance terminates if the information supplied under §5(a) or the Certificate issued under §9 is no longer applicable to the vessel."
        },
        {
          "id": "s18:a",
          "scope": "international",
          "international": "(a) In accordance with 33 U.S.C. 1605(c), a notice is published in the Federal Register if the following:",
          "inland": ""
        },
        {
          "id": "s18:a(i)",
          "scope": "international",
          "international": "(i) each Certificate of Alternative Compliance issued under §9; and",
          "inland": ""
        },
        {
          "id": "s18:a(ii)",
          "scope": "international",
          "international": "(ii) each Coast Guard vessel determined by the Commandant to be a vessel of special construction or purpose.",
          "inland": ""
        },
        {
          "id": "s18:b",
          "scope": "both",
          "international": "(b)|(a) Copies of Certificates of Alternative Compliance and documentation concerning Coast Guard vessels are available for inspection at the offices of the Marine Transportation Systems Directorate, U.S. Coast Guard Headquarters (CG–5PW), Stop 7509, 2703 Martin Luther King Ave SE, Washington, DC 20593–7509.",
          "inland": "(b)|(a) Copies of Certificates of Alternative Compliance and documentation concerning Coast Guard vessels are available for inspection at the offices of the Marine Transportation Systems Directorate, U.S. Coast Guard Headquarters (CG–5PW), Stop 7509, 2703 Martin Luther King Ave SE, Washington, DC 20593–7509."
        },
        {
          "id": "s18:c",
          "scope": "both",
          "international": "(c)|(b) The owner or operator of a vessel issued a certificate shall ensure that the vessel does not operate unless the Certificate of Alternative Compliance or a certified copy of that certificate is on board the vessel and available for inspection by Coast Guard personnel. PENALTIES: Civil Penalties (33 U.S.C 1608) | Violations of Inland Navigational Rules (33 U.S.C 2072)",
          "inland": "(c)|(b) The owner or operator of a vessel issued a certificate shall ensure that the vessel does not operate unless the Certificate of Alternative Compliance or a certified copy of that certificate is on board the vessel and available for inspection by Coast Guard personnel. PENALTIES: Civil Penalties (33 U.S.C 1608) | Violations of Inland Navigational Rules (33 U.S.C 2072)"
        },
        {
          "id": "s19:a",
          "scope": "both",
          "international": "(a) Liability of operator for civil penalty. Whoever operates a vessel in violation of 33 U.S.C. 1601-1608 | 33 CFR 83-90 is liable to a civil penalty of not more than $5,000 for each violation.",
          "inland": "(a) Liability of operator for civil penalty. Whoever operates a vessel in violation of 33 U.S.C. 1601-1608 | 33 CFR 83-90 or of any regulation issued thereunder, or in violation of a certificate of alternative compliance issued under Rule 1 is liable to a civil penalty of not more than $5,000 for each violation."
        },
        {
          "id": "s19:b",
          "scope": "both",
          "international": "(b) Liability of vessel for violations; seizure of vessel. Every vessel subject to the provisions of 33 U.S.C. 1601-1608 | 33 CFR 83-90 other than a public vessel being used for noncommercial purposes, which that ›› is operated in violation of 33 U.S.C. 1601-1608 | 33 CFR 83-90 or of any regulation promulgated pursuant to §1607, shall be liable to a civil penalty of not more than $5,000 for each such violation, for which penalty the vessel may be seized and proceeded against in the district court of the United States of any district within which such vessel may be found.",
          "inland": "(b) Liability of vessel for civil penalties; seizure of vessel. Every vessel subject to 33 U.S.C. 1601-1608 | 33 CFR 83-90 other than a public vessel being used for noncommercial purposes, that ›› is operated in violation of 33 U.S.C. 1601-1608 | 33 CFR 83-90 or of any regulation issued there under, or in violation of a certificate of alternative compliance issued under {Inland} Rule 1 is liable to a civil penalty of not more than $5,000 for each such violation, for which penalty the vessel may be seized and proceeded against in the district court of the United States of any district within which such vessel may be found."
        },
        {
          "id": "s19:c",
          "scope": "both",
          "international": "(c) Assessment of penalties; notice; opportunity for hearing; remission, mitigation, and compromise of penalty; action for collection. The Secretary of the department in which the Coast Guard is operating may assess any civil penalty authorized by this section. No such penalty may be assessed until the person charged, or the owner of the vessel charged, as appropriate, shall have been given notice of the violation involved and an opportunity for a hearing. For good cause shown, the Secretary may remit, mitigate, or compromise any penalty assessed. Upon the failure of the person charged, or the owner of the vessel charged, to pay an assessed penalty, as it may have been mitigated or compromised, the Secretary may request the Attorney General to commence an action in the appropriate district court of the United States for collection of the penalty as assessed, without regard to the amount involved, together with such other relief as may be appropriate. PENALTIES FOR NEGLIGENT OPERATIONS AND INTERFERING WITH SAFE OPERATION (33 U.S.C. 2302)",
          "inland": "(c) Assessment of civil penalty by Secretary; collection. The Secretary may assess any civil penalty authorized by this section. No such penalty may be assessed until the person charged, or the owner of the vessel charged, as appropriate, shall have been given notice of the violation involved and an opportunity for a hearing. For good cause shown, the Secretary may remit, mitigate, or compromise any penalty assessed. Upon the failure of the person charged, or the owner of the vessel charged, to pay an assessed penalty, as it may have been mitigated or compromised, the Secretary may request the Attorney General to commence an action in the appropriate district court of the United States for collection of the penalty as assessed, without regard to the amount involved, together with such other relief as may be appropriate."
        },
        {
          "id": "s19:d",
          "scope": "inland",
          "international": "",
          "inland": "(d) Withholding of clearance."
        },
        {
          "id": "s19:d(1)",
          "scope": "inland",
          "international": "",
          "inland": "(1) If any owner, operator, or individual in charge of a vessel is liable for a penalty under this section, or if reasonable cause exists to believe that the owner, operator, or individual in charge may be subject to a penalty under this section, the Secretary of the Treasury, upon the request of the Secretary, shall with respect to such vessel refuse or revoke any clearance required by §60105 of Title 46."
        },
        {
          "id": "s19:d(2)",
          "scope": "inland",
          "international": "",
          "inland": "(2) Clearance or a permit refused or revoked under this subsection may be granted upon filing of a bond or other surety satisfactory to the Secretary. PENALTIES FOR NEGLIGENT OPERATIONS AND INTERFERING WITH SAFE OPERATION (33 U.S.C. 2302)"
        },
        {
          "id": "s20:a",
          "scope": "both",
          "international": "(a) A person operating a vessel in a negligent manner or interfering with the safe operation of a vessel, so as to endanger the life, limb, or property of a person is liable to the United States Government for a civil penalty of not more than $5,000 in the case of a recreational vessel, or $25,000 in the case of any other vessel.",
          "inland": "(a) A person operating a vessel in a negligent manner or interfering with the safe operation of a vessel, so as to endanger the life, limb, or property of a person is liable to the United States Government for a civil penalty of not more than $5,000 in the case of a recreational vessel, or $25,000 in the case of any other vessel."
        },
        {
          "id": "s20:b",
          "scope": "both",
          "international": "(b) A person operating a vessel in a grossly negligent manner that endangers the life, limb, or property of a person commits a class A misdemeanor.",
          "inland": "(b) A person operating a vessel in a grossly negligent manner that endangers the life, limb, or property of a person commits a class A misdemeanor."
        },
        {
          "id": "s20:c",
          "scope": "both",
          "international": "(c) An individual who is under the influence of alcohol, or a dangerous drug in violation of a law of the United States when operating a vessel, as determined under standards prescribed by the Secretary by regulation—",
          "inland": "(c) An individual who is under the influence of alcohol, or a dangerous drug in violation of a law of the United States when operating a vessel, as determined under standards prescribed by the Secretary by regulation—"
        },
        {
          "id": "s20:c(1)",
          "scope": "both",
          "international": "(1) is liable to the United States Government for a civil penalty of not more than $5,000; or",
          "inland": "(1) is liable to the United States Government for a civil penalty of not more than $5,000; or"
        },
        {
          "id": "s20:c(2)",
          "scope": "both",
          "international": "(2) commits a class A misdemeanor.",
          "inland": "(2) commits a class A misdemeanor."
        },
        {
          "id": "s20:d",
          "scope": "both",
          "international": "(d) For a penalty imposed under this section, the vessel also is liable in rem unless the vessel is—",
          "inland": "(d) For a penalty imposed under this section, the vessel also is liable in rem unless the vessel is—"
        },
        {
          "id": "s20:d(1)",
          "scope": "both",
          "international": "(1) owned by a State or a political subdivision of a State;",
          "inland": "(1) owned by a State or a political subdivision of a State;"
        },
        {
          "id": "s20:d(2)",
          "scope": "both",
          "international": "(2) operated principally for governmental purposes; and",
          "inland": "(2) operated principally for governmental purposes; and"
        },
        {
          "id": "s20:d(3)",
          "scope": "both",
          "international": "(3) identified clearly as a vessel of that State or subdivision.",
          "inland": "(3) identified clearly as a vessel of that State or subdivision."
        },
        {
          "id": "s20:e",
          "scope": "both",
          "international": "(e) (1) A vessel may not transport Government-impelled cargoes if— (A) the vessel has been detained and determined to be substandard by the Secretary for violation of an international safety convention to which the United States is a party, and the Secretary has published notice of that detention and determination in an electronic form, including the name of the owner of the vessel; or (B) the operator of the vessel has on more than one occasion had a vessel detained and determined to be substandard by the Secretary for violation of an international safety convention to which the United States is a party, and the Secretary has published notice of that detention and determination in an electronic form, including the name of the owner of the vessel.",
          "inland": "(e) (1) A vessel may not transport Government-impelled cargoes if— (A) the vessel has been detained and determined to be substandard by the Secretary for violation of an international safety convention to which the United States is a party, and the Secretary has published notice of that detention and determination in an electronic form, including the name of the owner of the vessel; or (B) the operator of the vessel has on more than one occasion had a vessel detained and determined to be substandard by the Secretary for violation of an international safety convention to which the United States is a party, and the Secretary has published notice of that detention and determination in an electronic form, including the name of the owner of the vessel."
        },
        {
          "id": "s20:e(2)",
          "scope": "both",
          "international": "(2) The prohibition in §(1) expires for a vessel on the earlier of— (A) one year after the date of the publication in electronic form on which the prohibition is based; or (B) any date on which the owner or operator of the vessel prevails in an appeal of the violation of the relevant international convention on which the detention is based. VESSEL BRIDGE-TO-BRIDGE RADIOTELEPHONE REGULATIONS (33 CFR 26)",
          "inland": "(2) The prohibition in §(1) expires for a vessel on the earlier of— (A) one year after the date of the publication in electronic form on which the prohibition is based; or (B) any date on which the owner or operator of the vessel prevails in an appeal of the violation of the relevant international convention on which the detention is based. VESSEL BRIDGE-TO-BRIDGE RADIOTELEPHONE REGULATIONS (33 CFR 26)"
        },
        {
          "id": "s1:a",
          "scope": "both",
          "international": "(a) The purpose of this part is to implement the provisions of the Vessel Bridge-to-Bridge Radiotelephone Act. This part:",
          "inland": "(a) The purpose of this part is to implement the provisions of the Vessel Bridge-to-Bridge Radiotelephone Act. This part:"
        },
        {
          "id": "s1:a(1)",
          "scope": "both",
          "international": "(1) Requires the use of the vessel bridge-to-bridge radiotelephone;",
          "inland": "(1) Requires the use of the vessel bridge-to-bridge radiotelephone;"
        },
        {
          "id": "s1:a(2)",
          "scope": "both",
          "international": "(2) Provides the Coast Guard's interpretation of the meaning of important terms in the Act;",
          "inland": "(2) Provides the Coast Guard's interpretation of the meaning of important terms in the Act;"
        },
        {
          "id": "s1:a(3)",
          "scope": "both",
          "international": "(3) Prescribes the procedures for applying for an exemption from the Act and the regulations issued under the Act and a listing of exemptions.",
          "inland": "(3) Prescribes the procedures for applying for an exemption from the Act and the regulations issued under the Act and a listing of exemptions."
        },
        {
          "id": "s1:b",
          "scope": "both",
          "international": "(b) Nothing in this part relieves any person from the obligation of complying with the rules of the road and the applicable pilot rules. For the purpose of this part and interpreting the Act: “Act” means the “Vessel Bridge-to-Bridge Radiotelephone Act”, 33 U.S.C. §§1201-1208; “Length” is measured from end to end over the deck excluding sheer; “Power-driven vessel” means any vessel propelled by machinery; and “Secretary” means the Secretary of the Department in which the Coast Guard is operating; “Territorial sea” means all waters as defined in {33 CFR} §2.22(a)(1). “Towing vessel” means any commercial vessel engaged in towing another vessel astern, alongside, or by pushing ahead. “Vessel Traffic Services (VTS)” means a service implemented under 33 CFR 161 by the United States Coast Guard designed to improve the safety and efficiency of vessel traffic and to protect the environment. The VTS has the capability to interact with marine traffic and respond to traffic situations developing in the VTS area. \"Vessel Traffic Service Area or VTS Area” means the geographical area encompassing a specific VTS area of service as described in 33 CFR 161. This area of service may be subdivided into sectors for the purpose of allocating responsibility to individual Vessel Traffic Centers or to identify different operating requirements. Note: Although regulatory jurisdiction is limited to the navigable waters of the United States, certain vessels will be encouraged or may be required, as a condition of port entry, to report beyond this area to facilitate traffic management within the VTS area.",
          "inland": "(b) Nothing in this part relieves any person from the obligation of complying with the rules of the road and the applicable pilot rules. For the purpose of this part and interpreting the Act: “Act” means the “Vessel Bridge-to-Bridge Radiotelephone Act”, 33 U.S.C. §§1201-1208; “Length” is measured from end to end over the deck excluding sheer; “Power-driven vessel” means any vessel propelled by machinery; and “Secretary” means the Secretary of the Department in which the Coast Guard is operating; “Territorial sea” means all waters as defined in {33 CFR} §2.22(a)(1). “Towing vessel” means any commercial vessel engaged in towing another vessel astern, alongside, or by pushing ahead. “Vessel Traffic Services (VTS)” means a service implemented under 33 CFR 161 by the United States Coast Guard designed to improve the safety and efficiency of vessel traffic and to protect the environment. The VTS has the capability to interact with marine traffic and respond to traffic situations developing in the VTS area. \"Vessel Traffic Service Area or VTS Area” means the geographical area encompassing a specific VTS area of service as described in 33 CFR 161. This area of service may be subdivided into sectors for the purpose of allocating responsibility to individual Vessel Traffic Centers or to identify different operating requirements. Note: Although regulatory jurisdiction is limited to the navigable waters of the United States, certain vessels will be encouraged or may be required, as a condition of port entry, to report beyond this area to facilitate traffic management within the VTS area."
        },
        {
          "id": "s3:a",
          "scope": "both",
          "international": "(a) Unless an exemption is granted under §9 and except as provided in §(a)(4), this part applies to:",
          "inland": "(a) Unless an exemption is granted under §9 and except as provided in §(a)(4), this part applies to:"
        },
        {
          "id": "s3:a(1)",
          "scope": "both",
          "international": "(1) Every power-driven vessel of 20 meters or over in length while navigating;",
          "inland": "(1) Every power-driven vessel of 20 meters or over in length while navigating;"
        },
        {
          "id": "s3:a(2)",
          "scope": "both",
          "international": "(2) Every vessel of 100 gross tons and upward carrying one or more passengers for hire while navigating;",
          "inland": "(2) Every vessel of 100 gross tons and upward carrying one or more passengers for hire while navigating;"
        },
        {
          "id": "s3:a(3)",
          "scope": "both",
          "international": "(3) Every towing vessel of 26 feet or over in length while navigating; and",
          "inland": "(3) Every towing vessel of 26 feet or over in length while navigating; and"
        },
        {
          "id": "s3:a(4)",
          "scope": "both",
          "international": "(4) Every dredge and floating plant engaged in or near a channel or fairway in operations likely to restrict or affect navigation of other vessels except for an unmanned or intermittently manned floating plant under the control of a dredge.",
          "inland": "(4) Every dredge and floating plant engaged in or near a channel or fairway in operations likely to restrict or affect navigation of other vessels except for an unmanned or intermittently manned floating plant under the control of a dredge."
        },
        {
          "id": "s3:b",
          "scope": "both",
          "international": "(b) Every vessel, dredge, or floating plant described in §(a) must have a radiotelephone on board capable of operation from its navigational bridge, or in the case of a dredge, from its main control station, and capable of transmitting and receiving on the frequency or frequencies within the 156-162 Mega-Hertz band using the classes of emissions designated by the Federal Communications Commission for the exchange of navigational information.",
          "inland": "(b) Every vessel, dredge, or floating plant described in §(a) must have a radiotelephone on board capable of operation from its navigational bridge, or in the case of a dredge, from its main control station, and capable of transmitting and receiving on the frequency or frequencies within the 156-162 Mega-Hertz band using the classes of emissions designated by the Federal Communications Commission for the exchange of navigational information."
        },
        {
          "id": "s3:c",
          "scope": "both",
          "international": "(c) The radiotelephone required by §(b) must be carried on board the described vessels, dredges, and floating plants upon the navigable waters of the United States.",
          "inland": "(c) The radiotelephone required by §(b) must be carried on board the described vessels, dredges, and floating plants upon the navigable waters of the United States."
        },
        {
          "id": "s3:d",
          "scope": "both",
          "international": "(d) The radiotelephone required by §(b) must be capable of transmitting and receiving on VHF FM channel 22A (157.1 MHz).",
          "inland": "(d) The radiotelephone required by §(b) must be capable of transmitting and receiving on VHF FM channel 22A (157.1 MHz)."
        },
        {
          "id": "s3:e",
          "scope": "both",
          "international": "(e) While transiting any of the following waters, each vessel described in §(a) also must have on board a radiotelephone capable of transmitting and receiving on VHF FM channel 67 (156.375 MHz):",
          "inland": "(e) While transiting any of the following waters, each vessel described in §(a) also must have on board a radiotelephone capable of transmitting and receiving on VHF FM channel 67 (156.375 MHz):"
        },
        {
          "id": "s3:e(1)",
          "scope": "both",
          "international": "(1) The lower Mississippi River from the territorial sea boundary, and within either the Southwest Pass safety fairway or the South Pass safety fairway specified in 33 CFR 166.200, to mile 242.4 AHP (Above Head of Passes) near Baton Rouge;",
          "inland": "(1) The lower Mississippi River from the territorial sea boundary, and within either the Southwest Pass safety fairway or the South Pass safety fairway specified in 33 CFR 166.200, to mile 242.4 AHP (Above Head of Passes) near Baton Rouge;"
        },
        {
          "id": "s3:e(2)",
          "scope": "both",
          "international": "(2) The Mississippi River-Gulf Outlet from the territorial sea boundary, and within the Mississippi River-Gulf outlet Safety Fairway specified in 33 CFR 166.200, to that channel's junction with the Inner Harbor Navigation Canal; and",
          "inland": "(2) The Mississippi River-Gulf Outlet from the territorial sea boundary, and within the Mississippi River-Gulf outlet Safety Fairway specified in 33 CFR 166.200, to that channel's junction with the Inner Harbor Navigation Canal; and"
        },
        {
          "id": "s3:e(3)",
          "scope": "both",
          "international": "(3) The full length of the Inner Harbor Navigation Canal from its junction with the Mississippi River to that canal's entry to Lake Pontchartrain at the New Seabrook vehicular bridge.",
          "inland": "(3) The full length of the Inner Harbor Navigation Canal from its junction with the Mississippi River to that canal's entry to Lake Pontchartrain at the New Seabrook vehicular bridge."
        },
        {
          "id": "s3:f",
          "scope": "both",
          "international": "(f) In addition to the radiotelephone required by §(b), each vessel described in §(a) while transiting any waters within a Vessel Traffic Service Area, must have on board a radiotelephone capable of transmitting and receiving on the VTS designated frequency in Table 161.12(c) (VTS and VMRS Centers, Call Signs/MMSI, Designated Frequencies, and Monitoring Areas). Note: A single VHF-FM radio capable of scanning or sequential monitoring (often referred to as “dual watch” capability) will not meet the requirements for two radios.",
          "inland": "(f) In addition to the radiotelephone required by §(b), each vessel described in §(a) while transiting any waters within a Vessel Traffic Service Area, must have on board a radiotelephone capable of transmitting and receiving on the VTS designated frequency in Table 161.12(c) (VTS and VMRS Centers, Call Signs/MMSI, Designated Frequencies, and Monitoring Areas). Note: A single VHF-FM radio capable of scanning or sequential monitoring (often referred to as “dual watch” capability) will not meet the requirements for two radios."
        },
        {
          "id": "s4:a",
          "scope": "both",
          "international": "(a) No person may use the frequency designated by the Federal Communications Commission under §8 of the Act, 33 U.S.C. 1207(a), to transmit any information other than information necessary for the safe navigation of vessels or necessary tests.",
          "inland": "(a) No person may use the frequency designated by the Federal Communications Commission under §8 of the Act, 33 U.S.C. 1207(a), to transmit any information other than information necessary for the safe navigation of vessels or necessary tests."
        },
        {
          "id": "s4:b",
          "scope": "both",
          "international": "(b) Each person who is required to maintain a listening watch under §5 of the Act shall, when necessary, transmit and confirm, on the designated frequency, the intentions of his vessel and any other information necessary for the safe navigation of vessels.",
          "inland": "(b) Each person who is required to maintain a listening watch under §5 of the Act shall, when necessary, transmit and confirm, on the designated frequency, the intentions of his vessel and any other information necessary for the safe navigation of vessels."
        },
        {
          "id": "s4:c",
          "scope": "both",
          "international": "(c) Nothing in these regulations may be construed as prohibiting the use of the designated frequency to communicate with shore stations to obtain or furnish information necessary for the safe navigation of vessels.",
          "inland": "(c) Nothing in these regulations may be construed as prohibiting the use of the designated frequency to communicate with shore stations to obtain or furnish information necessary for the safe navigation of vessels."
        },
        {
          "id": "s4:d",
          "scope": "both",
          "international": "(d) On the navigable waters of the United States, channel 13 (156.65 MHz) is the designated frequency required to be monitored in accordance with §5(a) except that in the area prescribed in §3(e), channel 67 (156.375 MHz) is the designated frequency.",
          "inland": "(d) On the navigable waters of the United States, channel 13 (156.65 MHz) is the designated frequency required to be monitored in accordance with §5(a) except that in the area prescribed in §3(e), channel 67 (156.375 MHz) is the designated frequency."
        },
        {
          "id": "s4:e",
          "scope": "both",
          "international": "(e) On those navigable waters of the United States within a VTS area, the designated VTS frequency is an additional designated frequency required to be monitored in accordance with §5. §5 of the Act states that the radiotelephone required by this Act is for the exclusive use of the master or person in charge of the vessel, or the person designated by the master or person in charge to pilot or direct the movement of the vessel, who shall maintain a listening watch on the designated frequency. Nothing herein shall be interpreted as precluding the use of portable radiotelephone equipment to satisfy the requirements of this act. §6 of the Act states:",
          "inland": "(e) On those navigable waters of the United States within a VTS area, the designated VTS frequency is an additional designated frequency required to be monitored in accordance with §5. §5 of the Act states that the radiotelephone required by this Act is for the exclusive use of the master or person in charge of the vessel, or the person designated by the master or person in charge to pilot or direct the movement of the vessel, who shall maintain a listening watch on the designated frequency. Nothing herein shall be interpreted as precluding the use of portable radiotelephone equipment to satisfy the requirements of this act. §6 of the Act states:"
        },
        {
          "id": "s6:a",
          "scope": "both",
          "international": "(a) Whenever radiotelephone capability is required by this Act, a vessel's radiotelephone equipment shall be maintained in effective operating condition. If the radiotelephone equipment carried aboard a vessel ceases to operate, the master shall exercise due diligence to restore it or cause it to be restored to effective operating condition at the earliest practicable time. The failure of a vessel's radiotelephone equipment shall not, in itself, constitute a violation of this Act, nor shall it obligate the master of any vessel to moor or anchor his vessel; however, the loss of radiotelephone capability shall be given consideration in the navigation of the vessel. No person may use the services of, and no person may serve as, a person required to maintain a listening watch under §5 of the Act, 33 U.S.C. 1204, unless the person can communicate in the English language.",
          "inland": "(a) Whenever radiotelephone capability is required by this Act, a vessel's radiotelephone equipment shall be maintained in effective operating condition. If the radiotelephone equipment carried aboard a vessel ceases to operate, the master shall exercise due diligence to restore it or cause it to be restored to effective operating condition at the earliest practicable time. The failure of a vessel's radiotelephone equipment shall not, in itself, constitute a violation of this Act, nor shall it obligate the master of any vessel to moor or anchor his vessel; however, the loss of radiotelephone capability shall be given consideration in the navigation of the vessel. No person may use the services of, and no person may serve as, a person required to maintain a listening watch under §5 of the Act, 33 U.S.C. 1204, unless the person can communicate in the English language."
        },
        {
          "id": "s8:a",
          "scope": "both",
          "international": "(a) The Commandant has redelegated to the Assistant Commandant for Prevention Policy, U.S. Coast Guard Headquarters, with the reservation that this authority shall not be further redelegated, the authority to grant exemptions from provisions of the Vessel Bridge-to-Bridge Radiotelephone Act and this part.",
          "inland": "(a) The Commandant has redelegated to the Assistant Commandant for Prevention Policy, U.S. Coast Guard Headquarters, with the reservation that this authority shall not be further redelegated, the authority to grant exemptions from provisions of the Vessel Bridge-to-Bridge Radiotelephone Act and this part."
        },
        {
          "id": "s8:b",
          "scope": "both",
          "international": "(b) Any person may petition for an exemption from any provision of the Act or this part;",
          "inland": "(b) Any person may petition for an exemption from any provision of the Act or this part;"
        },
        {
          "id": "s8:c",
          "scope": "both",
          "international": "(c) Each petition must be submitted in writing to Commandant (CG-DCO-D), Attn: Deputy for Operations Policy and Capabilities, U.S. Coast Guard Stop 7318, 2703 Martin Luther King Jr. Avenue SE., Washington, DC 20593-7318, and must state:",
          "inland": "(c) Each petition must be submitted in writing to Commandant (CG-DCO-D), Attn: Deputy for Operations Policy and Capabilities, U.S. Coast Guard Stop 7318, 2703 Martin Luther King Jr. Avenue SE., Washington, DC 20593-7318, and must state:"
        },
        {
          "id": "s8:c(1)",
          "scope": "both",
          "international": "(1) The provisions of the Act or this part from which an exemption is requested; and",
          "inland": "(1) The provisions of the Act or this part from which an exemption is requested; and"
        },
        {
          "id": "s8:c(2)",
          "scope": "both",
          "international": "(2) The reasons why marine navigation will not be adversely affected if the exemption is granted and if the exemption relates to a local communication system how that system would fully comply with the intent of the concept of the Act but would not conform in detail if the exemption is granted.",
          "inland": "(2) The reasons why marine navigation will not be adversely affected if the exemption is granted and if the exemption relates to a local communication system how that system would fully comply with the intent of the concept of the Act but would not conform in detail if the exemption is granted."
        },
        {
          "id": "s9:a",
          "scope": "both",
          "international": "(a) All vessels navigating on those waters governed by the navigation rules for Great Lakes and their connecting and tributary waters (33 U.S.C. 241 et seq.) are exempt from the requirements of the Vessel Bridge-to-Bridge Radiotelephone Act and this part until May 6, 1975.",
          "inland": "(a) All vessels navigating on those waters governed by the navigation rules for Great Lakes and their connecting and tributary waters (33 U.S.C. 241 et seq.) are exempt from the requirements of the Vessel Bridge-to-Bridge Radiotelephone Act and this part until May 6, 1975."
        },
        {
          "id": "s9:b",
          "scope": "both",
          "international": "(b) Each vessel navigating on the Great Lakes as defined in the Inland Navigational Rules Act of 1980 (33 U.S.C. 2001 et seq.) and to which the Vessel Bridge-to-Bridge Radiotelephone Act (33 U.S.C. 1201-1208) applies is exempt from the requirements in 33 U.S.C. 1203, 1204, and 1205 and the regulations under §§3, 4, 5, 6, and 7. Each of these vessels and each person to whom 33 U.S.C. 1208(a) applies must comply with Articles VII, X, XI, XII, XIII, XV, and XVI and Technical Regulations 1-9 of “The Agreement Between the United States of America and Canada for Promotion of Safety on the Great Lakes by Means of Radio, 1973.” CONVERSION OF LENGTHS USED IN THE RULES Approximate Conversion of Metric to Imperial / U.S. Customary Measurements 0.3 meters 0.6 meters 2 feet 0.9 meters 3 feet 1 meters 3.3 feet 1.3 meters 1.5 meters 2.5 meters 8.2 feet 3.5 meters 11.5 feet 4.5 meters 14.8 feet 5 meters 16.4 feet 6 meters 19.7 feet 7 meters 23 feet 8 meters 26.2 feet 12 meters< 39.4 feet 20 meters 65.6 feet 25 meters 82 feet 30 meters 100 feet 50 meters 164 feet 75 meters 246 feet 100 meters 109 yards 150 meters< 164 yards 200 meters 219 yards 463 meters 0.25 nautical miles 506 yards 914 meters 0.49 nautical miles 1000 yards 1,000 meters 0.54 nautical miles< 1 kilometer< 1609 meters 0.87 nautical miles 1 mile 1,829 meters 0.99 nautical miles 2,000 yards 1,852 meters 1 nautical mile 1.2 miles 2,000 meters 1.08 nautical miles 1.2 miles 2,743 meters 1.48 nautical miles 3,000 yards 3,658 meters 1.97 nautical miles 4,000 yards 3,704 meters 2 nautical miles 2.3 miles 4,572 meters 2.47 nautical miles 5,000 yards 7,408 meters 4 nautical miles 4.6 miles 9,260 meters 5 nautical miles 5.8 miles 10,000 meters 5.4 nautical miles< 10 kilometers Webpage Corrections August 7th, 2024, the graphic at Rule 37 was corrected to properly reflect the text in the Rule, and was also added to the heading of \"Annex IV - Distress Signals\" (33 CFR 87)\". August 9th, 2024, Rule 35(g) was corrected to read \"...one short, one prolonged and one short blast\" vice \"...one short, one long and one short\". August 21st, 2024, the name and link to the USCG's NavRules Handbook was amended to USCG’s Navigation Rules and Regulations Handbook (Corrected August 8th, 2024); subsequent to corrections to the graphic at page 106 to better reflect the text in Rule 37. ×",
          "inland": "(b) Each vessel navigating on the Great Lakes as defined in the Inland Navigational Rules Act of 1980 (33 U.S.C. 2001 et seq.) and to which the Vessel Bridge-to-Bridge Radiotelephone Act (33 U.S.C. 1201-1208) applies is exempt from the requirements in 33 U.S.C. 1203, 1204, and 1205 and the regulations under §§3, 4, 5, 6, and 7. Each of these vessels and each person to whom 33 U.S.C. 1208(a) applies must comply with Articles VII, X, XI, XII, XIII, XV, and XVI and Technical Regulations 1-9 of “The Agreement Between the United States of America and Canada for Promotion of Safety on the Great Lakes by Means of Radio, 1973.” CONVERSION OF LENGTHS USED IN THE RULES Approximate Conversion of Metric to Imperial / U.S. Customary Measurements 0.3 meters 0.6 meters 2 feet 0.9 meters 3 feet 1 meters 3.3 feet 1.3 meters 1.5 meters 2.5 meters 8.2 feet 3.5 meters 11.5 feet 4.5 meters 14.8 feet 5 meters 16.4 feet 6 meters 19.7 feet 7 meters 23 feet 8 meters 26.2 feet 12 meters< 39.4 feet 20 meters 65.6 feet 25 meters 82 feet 30 meters 100 feet 50 meters 164 feet 75 meters 246 feet 100 meters 109 yards 150 meters< 164 yards 200 meters 219 yards 463 meters 0.25 nautical miles 506 yards 914 meters 0.49 nautical miles 1000 yards 1,000 meters 0.54 nautical miles< 1 kilometer< 1609 meters 0.87 nautical miles 1 mile 1,829 meters 0.99 nautical miles 2,000 yards 1,852 meters 1 nautical mile 1.2 miles 2,000 meters 1.08 nautical miles 1.2 miles 2,743 meters 1.48 nautical miles 3,000 yards 3,658 meters 1.97 nautical miles 4,000 yards 3,704 meters 2 nautical miles 2.3 miles 4,572 meters 2.47 nautical miles 5,000 yards 7,408 meters 4 nautical miles 4.6 miles 9,260 meters 5 nautical miles 5.8 miles 10,000 meters 5.4 nautical miles< 10 kilometers Webpage Corrections August 7th, 2024, the graphic at Rule 37 was corrected to properly reflect the text in the Rule, and was also added to the heading of \"Annex IV - Distress Signals\" (33 CFR 87)\". August 9th, 2024, Rule 35(g) was corrected to read \"...one short, one prolonged and one short blast\" vice \"...one short, one long and one short\". August 21st, 2024, the name and link to the USCG's NavRules Handbook was amended to USCG’s Navigation Rules and Regulations Handbook (Corrected August 8th, 2024); subsequent to corrections to the graphic at page 106 to better reflect the text in Rule 37. ×"
        }
      ]
    }
  }
}
